<template>
  <div>
    <!-- 번호이동 고객 TransferCompanySection -->
    <!-- 번호이동일 때 번호이동고객정보 -->
    <div
            class="registration-page transfer-company-section"
            v-if="openMarketInfo.registrationTypeCode === 'move'"
    >
      <div class="registration-page-container">
        <div class="section">
          <div class="section-header"><h3>가입내역(번호이동)</h3></div>
          <div class="section-body">
            <dl class="field-group">
              <dt class="field-label">
                <label for="transfer-mobile-number">번호이동전화번호</label>
              </dt>
              <dd class="field-control">
                <input
                        v-model="registration.chgHopTlno"
                        id="transfer-mobile-number"
                        @input="onlyNumber"
                        type="text"
                        name="transferMobileNo"
                        maxlength="11"
                        placeholder="'-' 없이 숫자만 입력"
                        autocomplete="off"
                        class="input-text input-font input-horizontal"
                        title="번호이동 전화번호 입력"
                        ref="ref_transferMobileNumber"
                />
              </dd>
            </dl>
            <dl class="field-group">
              <dt class="field-label">
                <label>변경전 통신사</label>
              </dt>
              <dd class="field-control">
                <div
                        :id="'radio-button-container-' + mcco.code"
                        class="input-container input-horizontal"
                        v-for="mcco in mccoList"
                        v-bind:key="mcco.code"
                        :value="mcco.name"
                >
                  <input
                          v-model="registration.noRnftEnprCd"
                          type="radio"
                          name="company"
                          :value="mcco.code"
                          class="input-radio"
                          title="변경전 통신사 선택"
                          :id="'before-transfer-company-' + mcco.code"
                  />
                  <label
                          :for="'before-transfer-company-' + mcco.code"
                          class="input-label"
                  >{{ mcco.name }}</label
                  >
                </div>
              </dd>
            </dl>
            
            <dl v-if="isShowSoacYn" class="field-group">
              <dt class="field-label">
                <label>번호이동 정보</label>
              </dt>
              <dd class="field-control">
                <div class="field-control-sub">
                  <ul class="notice-text-list">
                    <li class="notice-text">
                      고객님의 정산 요금 확인을 위하여 다름 4개 항목 중 1개이상
                      반드시 표시바랍니다.
                    </li>
                    <li class="notice-text">
                      은행계좌와 신용카드는 현재 사용하고 있는 이동통신사의
                      결제정보입니다.
                    </li>
                  </ul>
                </div>
                <div class="field-control-sub">
                  <select
                          v-model="registration.mnpSoacTrgtCd"
                          name="check-fee-method"
                          class="input-width-large"
                          ref="ref_mnpSoacTrgtCd"
                  >
                    <option value="">선택하세요.</option>
                    <option value="2">휴대폰 일련번호 뒷 네자리</option>
                    <option value="3">요금납부 은행 계좌번호 뒷 네자리</option>
                    <option value="5">요금납부 신용카드 뒷 네자리</option>
                    <option value="1">지로납부</option>
                  </select>
                </div>
                <div class="field-control-sub">
                  <span
                          v-if="registration.mnpSoacTrgtCd === '2'"
                          class="serial_no"
                          title="휴대폰 일련번호 뒷 네자리"
                  ></span>
                  <span
                          v-else-if="registration.mnpSoacTrgtCd === '3'"
                          class="account_no"
                          title="요금납부 은행 계좌번호 뒷 네자리"
                  ></span>
                  <span
                          v-else-if="registration.mnpSoacTrgtCd === '5'"
                          class="card_no"
                          title="요금납부 신용카드 뒷 네자리"
                  ></span>
                </div>
                <div
                        v-if="
                    registration.mnpSoacTrgtCd &&
                      registration.mnpSoacTrgtCd !== '1'
                  "
                        class="field-control-sub"
                >
                  <input
                          v-model="registration.mnpSoacNo"
                          type="mnpSoacNo"
                          autocomplete="off"
                          name="checkFeeMethodNo"
                          maxlength="4"
                          placeholder="'-'없이 숫자만 입력"
                          class="input-text input-font"
                          ref="ref_mnpSoacNo"
                  />
                </div>
              </dd>
            </dl>           
          </div>
        </div>
      </div>
    </div>

    <!-- 가입내역 시작 DeviceSection -->
    <div class="registration-page">
      <div class="registration-page-container">
        <div class="section">
          <div class="section-header"><h3>가입내역</h3></div>
          <div class="section-body">
            <dl class="field-group">
              <dt class="field-label">
                <label for="phoneModelCd">단말기 모델명</label>
              </dt>
              <dd class="field-control">
                <select
                        v-model="registration.dvicMdlCd"
                        name="phoneModelCd"
                        id="phoneModelCd"
                        ref="phoneModelCd"
                        class="input-width-large"
                        @change="changeDevice"
                >
                  <option value="">선택하세요</option>
                  <option 
                          v-for="device in deviceList"
                          v-bind:key="device.trmMdlCd"
                          :value="device.trmMdlCd"
                          title="단말기 모델"
                  >
                  {{ device.trmMdlNm }}
                  </option>
                </select>
                <!-- <span class='dynamic-data-temp'>from meta service</span> -->
                <!-- 갤럭시 S23 예판 문구추가 -->
                <div v-if="openMarketInfo.rsvSaleYn === 'Y' && isShowEventMsg">
                    <ul class="notice-text-list">
                      <li class="notice-text">
                        출시 예정일 2023년 2월 17일(금)<br/>
                        사전예약기간 2023년 2월 7일(화) ~ 2023년 2월 13일(월)
                      </li>
                       <li class="notice-text">
                        Double Storage 혜택<br/>
                        사전예약 기간(2/7~2/13) 동안 256GB를 512GB 모델로 무료 업그레이드 해드립니다.
                       </li>
                       <li class="notice-text">
                        256GB, 1TB는 공식 출시(2/17) 후 구매 가능합니다.
                       </li>
                    </ul>
                </div>
                 <!-- 갤럭시 S23 예판 문구추가 -->
              </dd>
            </dl>
            <!--[ST] RITM2876892 M2M 요금약정기간 추가 건-->
            <div v-if="part2.formM2MYn != 'Y'">
              <dl class="field-group">
                <dt class="field-label">
                  <label for="select-device-color">단말기 색상</label>
                </dt>
                <dd class="field-control">
                  <div class="field-control-sub">
                    <select
                            v-model="registration.dvicColrCd"
                            ref="phoneColor"
                            id="select-device-color"
                            name="device-color"
                            class="input-width-large"
                            @change="changeColor"
                    >
                      <option value="">선택하세요</option>
                      <option
                              v-for="(color, index) in colorList"
                              v-bind:key="index"
                              :value="color.code"
                              title="단말기 색상 선택"
                      >
                        {{ color.name }}
                      </option>
                    </select>
                    <!-- <span class='dynamic-data-temp'>from meta service</span> -->
                  </div>
                  <ul class="notice-text-list">
                    <li class="notice-text">
                      단말기 색상은 해피콜 상담을 통해 최종 확정됩니다.
                    </li>
                  </ul>
                </dd>
              </dl>
            </div>
            <!--[ST] RITM2876892 M2M 요금약정기간 추가 건-->

            <!-- 번이일때 유심정보 아닐 때 S -->
            <div v-if="'move' === openMarketInfo.registrationTypeCode">
            <!-- USIM S -->
              <dl class="field-group" >
                <dt class="field-label">
                  <label for="desired-number">USIM</label>
                </dt>
                <dd class="field-control">
                  <div class="field-control-sub">
                    <div id="radio-container-loss" class="input-container input-horizontal">
                      <input
                              id="usim-selection-use-y"
                              v-model="vUsimRqstYn"
                              type="radio"
                              name="usimUseYn"
                              value="Y"
                              class="input-checkbox input-text"
                              title="USIM 신청 선택"
                              checked
                              ref="ref_usimRqstYn"
                              @click="checkUsimInsr('Y')"
                      />
                      <label for="usim-selection-use-y" class="input-label">
                        신청
                      </label>
                    </div>
                    <!--div id="radio-container-loss" class="input-container input-horizontal">
                      <input
                              id="usim-selection-use-n"
                              v-model="vUsimRqstYn"
                              type="radio"
                              name="usimUseYn"
                              value="N"
                              class="input-checkbox input-text"
                              title="USIM 신청 선택"
                              @click="checkUsimInsr('N')"
                      />
                      <label for="usim-selection-use-n" class="input-label">
                        미신청
                      </label>
                    </div-->
                  </div>
                </dd>
              </dl>
              <!-- USIM E -->
              
              <!-- eSIM S -->
              <dl class="field-group" v-if="display.isEsimDevice">
                <dt class="field-label">
                  <label for="desired-number">eSIM</label>
                  <em>&nbsp;</em>
                  <!--em class="text-info-title"  style='margin-left:5;' @click="informEsim()">&nbsp;</em -->
                </dt>
                <dd class="field-control">
                  <div class="field-control-sub">
                    <div id="radio-container-loss" class="input-container input-horizontal">
                      <input
                              id="esim-selection-use-y"
                              v-model="vEsimTrmYn"
                              type="radio"
                              name="usimUseYn"
                              value="Y"
                              class="input-checkbox input-text"
                              title="eSIM 신청 선택"
                              ref="ref_esimTrmYn"
                              @click="checkEsimInsr('Y')"
                      />
                      <label for="esim-selection-use-y" class="input-label">
                        신청
                      </label>
                    </div>
                    <!--div id="radio-container-loss" class="input-container input-horizontal">
                      <input
                              id="esim-selection-use-n"
                              v-model="vEsimTrmYn"
                              type="radio"
                              name="esimUseYn"
                              value="N"
                              class="input-checkbox input-text"
                              title="eSIM 신청 선택"
                              @click="checkEsimInsr('N')"
                      />
                      <label for="esim-selection-use-n" class="input-label">
                        미신청
                      </label>
                    </div-->
                  </div>
                </dd>
               </dl> 
              <!-- eSIM E -->
            </div>
            <!-- 번이일때 유심정보 아닐 때 E -->

            <!-- 번이가 아닐 때 S -->
            <div v-if="'move' !== openMarketInfo.registrationTypeCode">
              <!--[ST] RITM2876892 M2M 요금약정기간 추가 건-->
              <div v-if="part2.formM2MYn != 'Y'">
                <dl
                        class="field-group"
                        v-if="'new' === openMarketInfo.registrationTypeCode"
                >
                  <dt class="field-label">
                    <label for="desired-number">희망번호</label>
                  </dt>
                  <dd class="field-control">
                    <div class="field-control-sub m-input-col">
                      <span
                              class="input-sub-text"
                              v-if="openMarketInfo.rotrRqstCd !== 'Y'"
                      >010-****-</span
                      >
                      <input
                              id="desired-number"
                              v-model="registration.chgHopTlno"
                              type="text"
                              maxlength="4"
                              @input="onlyNumber"
                              autocomplete="off"
                              name="desired-number"
                              class="input-text input-font input-width-xsmall mw60"
                              title="희망번호 맨 뒤 네자리 숫자 입력"
                              ref="ref_hopeNum"
                      />
                    </div>
                    <ul class="notice-text-list">
                      <li class="notice-text">
                        희망번호 뒤 4자리를 입력해 주세요.
                      </li>
                    </ul>
                  </dd>
                </dl>

                



                <dl
                        class="field-group"
                        v-if="
                    'chg' === openMarketInfo.registrationTypeCode ||
                      'renew' === openMarketInfo.registrationTypeCode
                  "
                >
                  <dt class="field-label">
                    <label for="customer-phone-number">휴대폰번호</label>
                  </dt>
                  <dd class="field-control">
                    <div v-if="is_payStyleData">
                      <input
                              id="chg-hope-full-phone-number"
                              v-model="registration.chgHopTlno"
                              type="text"
                              @input="onlyNumber"
                              maxlength="11"
                              autocomplete="off"
                              name="chg-hope-full-phone-number"
                              class="input-text input-font"
                              placeholder="'-' 없이 숫자만 입력"
                              ref="ref_hopeFullNum"
                      />
                    </div>
                    <div v-if="!is_payStyleData">
                      <input
                              id="chg-hope-full-phone-number"
                              v-model="registration.chgHopTlno"
                              type="text"
                              @input="onlyNumber"
                              @keypress="reqItemDstrDiscountNull"
                              maxlength="11"
                              autocomplete="off"
                              name="chg-hope-full-phone-number"
                              class="input-text input-font"
                              placeholder="'-' 없이 숫자만 입력"
                              ref="ref_hopeFullNumNotPay"
                      />
                    </div>
                  </dd>
                </dl>
              </div>
              <!--[ED] RITM2876892 M2M 요금약정기간 추가 건-->

              <!-- USIM S -->
              <dl class="field-group" >
                <dt class="field-label">
                  <label for="desired-number">USIM</label>
                </dt>
                <dd class="field-control">
                  <div class="field-control-sub">
                    <div id="radio-container-loss" class="input-container input-horizontal">
                      <input
                              id="usim-selection-use-y"
                              v-model="vUsimRqstYn"
                              type="radio"
                              name="usimUseYn"
                              value="Y"
                              class="input-checkbox input-text"
                              title="USIM 신청 선택"
                              checked
                              ref="ref_usimRqstYn"
                              @click="checkUsimInsr('Y')"
                      />
                      <label for="usim-selection-use-y" class="input-label">
                        신청
                      </label>
                    </div>
                    <div id="radio-container-loss" class="input-container input-horizontal" v-if=" 'chg' === this.openMarketInfo.registrationTypeCode ||'renew' === this.openMarketInfo.registrationTypeCode ">
                      <input
                              id="usim-selection-use-n"
                              v-model="vUsimRqstYn"
                              type="radio"
                              name="usimUseYn"
                              value="N"
                              class="input-checkbox input-text"
                              title="USIM 신청 선택"
                              @click="checkUsimInsr('N')"
                      />
                      <label for="usim-selection-use-n" class="input-label">
                        기존유심사용
                      </label>
                    </div>
                  </div>
                </dd>
              </dl>
              <!-- USIM E -->
              
              <!-- eSIM S -->
              <dl class="field-group" v-if="display.isEsimDevice">
                <dt class="field-label">
                  <label for="desired-number">eSIM</label>
                  <em>&nbsp;</em>
                  <!--em class="text-info-title"  style='margin-left:5;' @click="informEsim()">&nbsp;</em-->
                </dt>
                <dd class="field-control">
                  <div class="field-control-sub">
                    <div id="radio-container-loss" class="input-container input-horizontal">
                      <input
                              id="esim-selection-use-y"
                              v-model="vEsimTrmYn"
                              type="radio"
                              name="usimUseYn"
                              value="Y"
                              class="input-checkbox input-text"
                              title="eSIM 신청 선택"
                              ref="ref_esimTrmYn"
                              @click="checkEsimInsr('Y')"
                      />
                      <label for="esim-selection-use-y" class="input-label">
                        신청
                      </label>
                    </div>
                    <!-- div id="radio-container-loss" class="input-container input-horizontal">
                      <input
                              id="esim-selection-use-n"
                              v-model="vEsimTrmYn"
                              type="radio"
                              name="esimUseYn"
                              value="N"
                              class="input-checkbox input-text"
                              title="eSIM 신청 선택"
                              @click="checkEsimInsr('N')"
                      />
                      <label for="esim-selection-use-n" class="input-label">
                        미신청
                      </label>
                    </div -->
                  </div>
                </dd>
               </dl> 
              <!-- eSIM E -->
            </div>

            <!-- 중고폰 신청서일 경우 -->
            <div v-if="openMarketInfo.shndHphnYn === 'Y'">
              <dl class="field-group">
                <dt class="field-label">
                  단말기 일련번호
                </dt>
                <dd class="field-control">
                  <input
                          id="phone-serial-number"
                          v-model="registration.trmSrno"
                          type="text"
                          @input="onlyText"
                          name="phone-serial-number"
                          size="10"
                          maxlength=""
                          autocomplete="off"
                          class="input-text input-font"
                          title="단말기 일련번호"
                          ref="ref_serialNum"
                  />
                </dd>
              </dl>
            </div>

            <!-- 할부 N -->
            <div
                    v-if="
                openMarketInfo.isttYn === 'N' && openMarketInfo.rcmdSaleKcCd
              "
            >
              <dl class="field-group">
                <dt class="field-label">
                  판매금액
                </dt>
                <dd class="field-control">
                  <div class="field-control-sub">
                    <div class="input-container">
                      <label class="input-label"
                      >{{ openMarketInfo.isttAmt }}원</label
                      >
                    </div>
                  </div>
                </dd>
              </dl>
            </div>

            <div v-if="openMarketInfo.crgrSaleYn === 'Y'">
              <dl class="field-group">
                <dt class="field-label">
                  <label>판매금액</label>
                </dt>
                <dd class="field-control">
                  <div class="field-control-sub">
                    <div
                            id="radio-button-container-crgr-buy-y"
                            class="input-container input-horizontal"
                    >
                      <input
                              id="crgr-buy-y-select"
                              v-model="registration.crgrBuyYn"
                              type="radio"
                              name="bill-type"
                              value="Y"
                              class="input-radio"
                              title="충전기 구매"
                              ref="ref_crgrBuyYn"
                      />
                      <label for="crgr-buy-y-select" class="input-label"
                      >구매(청구서납부)</label
                      >
                    </div>
                    <div
                            id="radio-button-container-crgr-buy-n"
                            class="input-container input-horizontal"
                    >
                      <input
                              id="crgr-buy-n-select"
                              v-model="registration.crgrBuyYn"
                              type="radio"
                              name="bill-type"
                              value="N"
                              class="input-radio"
                              title="충전기 바구매"
                      />
                      <label for="crgr-buy-n-select" class="input-label"
                      >비구매</label
                      >
                    </div>
                  </div>
                  <ul class="notice-text-list">
                    <li class="notice-text">
                      구매 선택 시 충전기 금액이 요금에 합산청구됩니다.
                    </li>
                  </ul>
                </dd>
              </dl>
            </div>

            <!-- 구매 충전기 화면 정의서 참고 -->

            <dl class="field-group" v-if="display.isIPhoneDevice">
              <dt class="field-label">
                iPhone 이용고객 동의
              </dt>
              <dd class="field-control">
                <div
                        id="checkbox-container-iphone-agreement"
                        class="input-container"
                >
                  <input
                          id="iphone-agreement"
                          v-model="isIphonePop"
                          type="checkbox"
                          title="새창열림"
                          name="iphone-agreement"
                          value="iphone-agreement"
                          class="input-checkbox input-text"
                          ref="ref_iphoneAgreement"
                  />
                  <label
                          for="iphone-agreement"
                          class="input-label"
                          @click="clickIphnUseAgrYn"
                  ><em class="primary-text">(필수)</em> 동의 - iPhone</label
                  >
                </div>
              </dd>
              <IphoneAgreePopup @close="popupIphoneClose" />
            </dl>
                        
            <!--[ST]MNP 전환지원금 고객확인여부 (2024-03-19)-->
            <!-- [단통법폐지Prj] Start 단통법 폐지관련 단통법 오픈 전까지만 전환지원금 내역 보이도록 함. 오픈 후에는 사용 안함. 2025.06.04 miyoung34 -->
            <dl class="field-group" v-if="openMarketInfo.registrationTypeCode === 'move' 
             && this.$store.state.openMarketInfo.lrpsDiscOpenYn == 'N'">
            <!-- [단통법폐지Prj] End 단통법 폐지관련 단통법 오픈 전까지만 전환지원금 내역 보이도록 함. 오픈 후에는 사용 안함. 2025.06.04 miyoung34 -->
              <dt class="field-label">
                <label>전환지원금 지급 안내</label>
              </dt>
              <dd class="field-control">
                <div class="field-control-sub">
                  <div class="input-container">
                    <!--checkbox to open the transition support -->
                    <input
                            id="agreement-mnp-phone"
                            v-model="chkAgreeMNP"
                            type="checkbox"
                            name="agreement-mnp"
                            value="agreement-mnp"
                            class="input-checkbox input-text"
                            ref="ref_agreeMnp"
                            @click="clickOpenTransitionPopUp"
                    />
                    <label for="agreement-mnp-phone" class="input-label"
                    ><em class="primary-text">(필수) 전환지원금 지급에 관하여 확인하였습니다.</em></label>
                  </div>
                </div>
              </dd>
            </dl>
            <!--[ED]MNP 전환지원금 고객확인여부 (2024-03-19)-->
            <dl class="field-group" v-if="display.is5GDevice">
              <dt class="field-label">
                <label>5G 개통고객 대상 안내</label>
              </dt>
              <dd class="field-control">
                <div class="field-control-sub">
                  <div class="input-container">
                    <input
                            id="agreement-5g-phone"
                            v-model="chkAgree5G"
                            type="checkbox"
                            name="agreement-5g"
                            value="agreement-5g"
                            class="input-checkbox input-text"
                            ref="ref_agree5G"
                    />
                    <label for="agreement-5g-phone" class="input-label"
                    ><em class="primary-text">(필수)</em> 동의 - 5G</label
                    >
                  </div>
                  <ul class="notice-text-list">
                    <li class="notice-text">
                      본인은 5G서비스 제공 지역에 대해 충분한 설명을
                      들었으며,사용환경 (5G 기지국 미 구축, 일부 건물 실내, 지하
                      등)에 따라 5G음영지역이 발생할 수 있고 그 경우 LTE로
                      이용되는 점에 대해 동의 하겠습니다.
                    </li>
                  </ul>
                  <ul class="notice-text-list">
                    <li class="notice-text">
                      본인은 요금제 가입시 제공받는 서비스 할인 혜택에 대해 귀사
                      또는 제휴사의 운영 및 기술, 사업상의 상당한 이유가 있는
                      경우 최소 30일 전에 안내 받은 후, 변경 또는 중단되는 것에
                      대해 동의하겠습니다.
                    </li>
                  </ul>
                </div>
              </dd>
              </dl>
              <!--5G 커버리지추가 2021.05.21(장희정) 시작-->
              <dl class="field-group" v-if="display.is5GDevice">
              <dt class="field-label">
                <label>5G 서비스 주 생활지역</label>
              </dt>
              <dd class="field-control">
                <div>
                  <dl class="field-group">
                    <dt class="field-label">
                        <label for="addr-ctdoclssnm"><em class="primary-text">(필수)</em>시도</label>
                    </dt>
                    <dd class="field-control">
                        <div class="field-control-sub">
                        <select
                            id="addr-ctdoclssnm"
                            v-model="addr.ctdoClssNm"
                            ref="ref_ctdoClssNm"
                            name="addr-ctdoclssnm"
                            class="input-width-small"
                            @change="selectedCtdo"
                        >
                            <option value="">선택</option>
                            <option
                            v-for="(ctdoList, index) in ctdoList"
                            :key="index"
                            :value="ctdoList.ctdoClssNm"
                            >{{ ctdoList.ctdoClssNm }}</option>
                        </select>
                        </div>
                    </dd>
                  </dl>
                  <dl class="field-group">
                    <dt class="field-label">
                        <label for="addr-ccwnm"><em class="primary-text">(필수)</em>구시군</label>
                    </dt>
                    <dd class="field-control">
                        <div class="field-control-sub">
                        <select
                            id="addr-ccwnm"
                            v-model="addr.ccwNm"
                            ref="ref_ccwNm"
                            name="addr-ccwnm"
                            class="input-width-small"
                            @change="selectedCcwNm"
                        >
                            <option value="">선택</option>
                            <option
                            v-for="(ccwNmList, index) in ccwNmList"
                            :key="index"
                            :value="ccwNmList.ccwNm"
                            >{{ ccwNmList.ccwNm }}</option
                            >
                        </select>
                        </div>
                    </dd>
                  </dl>
                  <dl class="field-group">
                    <dt class="field-label">
                        <label for="addr-townNm"><em class="primary-text">(필수)</em>읍면동</label>
                    </dt>
                    <dd class="field-control">
                        <div class="field-control-sub">
                        <select
                            id="addr-townNm"
                            v-model="addr.townNm"
                            ref="ref_townNm"
                            name="addr-townNm"
                            class="input-width-small"
                            @change="selectedTownNm"
                        >
                            <option value="">선택</option>
                            <option
                            v-for="(townNmList, index) in townNmList"
                            :key="index"
                            :value="townNmList.townNm"
                            >{{ townNmList.townNm }}</option
                            >
                        </select>
                        </div>
                    </dd>
                  </dl>
              <!--  </div>
              </dd>
              <dd class="field-control">
                <div>-->
                  <ul class="notice-text-list">
                    <li class="notice-text">
                     회사는 현재 3.5GHz 주파수 대역으로 5G서비스를 제공중에 있으며, 빠르면 2022년 상반기까지 85개 시 행정동 및 주요 읍면 중심부, 다중 이용시설, 전국 주요 역사 및 고속도록 등 공공
                     인프라에 5G망 구축을 완료 할수 있도록 노력하고 있습니다. 현재 5G서비스 이용가능 지역은 회사 홈페이지에서 확인 할수 있습니다.
                     (<a  id="CoverMap" @click="openCoverMap" title="새창열림" target="_blank" tabindex="0" >http://coveragemap.uplus.co.kr/EssCvgApp/index_v2.html</a>)
                    </li>
                    <li class="notice-text">
                     5G 전국망 구축 전까지 일부 지역에서는 5G서비스를 이용할수 없다는 점을 판매자로 부터 충분히 안내 받았습니다.
                    </li>
                    <li class="notice-text">
                     구축후 서비스 이용 가능 지역이더라도 통신환경에 따라 <span  class="dynamic-data-temp">건물안이나 지하, 외곽등에서는 서비스 이용이 제한 될 수 있습니다.</span> 이경우 LTE 서비스를 이용하는 점에 대해 동의 합니다.
                    </li>
                  </ul>
                  <div class="input-container">
                    <input
                            id="agreement-5g-coverage"
                            v-model="chkAgree5GCoverage"
                            type="checkbox"
                            name="agreement-5g-coverage"
                            value="agreement-5g-coverage"
                            class="input-checkbox input-text"
                            ref="ref_agree5G_coverage"
                    />
                    <label for="agreement-5g-coverage" class="input-label"
                    ><em class="primary-text">(필수)5G 서비스 및 주 생활지역에서의 가용지역에관하여 확인하였습니다.</em> </label >
                  </div>
                </div>
              </dd>
               <!--5G 커버리지추가 2021.05.21(장희정) 끝-->
            </dl>
          </div>
        </div>
      </div>
    </div>

    <!-- 신청내역 FeePlanSection -->
    <div
            v-if="
        openMarketInfo.registrationTypeCode === 'move' ||
          openMarketInfo.registrationTypeCode === 'new' ||
          is_payStyleData
      "
    >
      <!-- 신청내역 시작 -->
      <div class="section">
        <div class="section-header">
          <h3>
            신청내역
          </h3>
        </div>
        <div class="section-body">
          <dl class="field-group">
            <dt class="field-label">
              <label for="payStyleSelect">대리점추천요금제</label>
            </dt>
            <dd class="field-control">
              <div class="field-control-sub">
                <select
                        :readonly = "onsaPrevPpUseYn"
                        v-model="registration.ppCd"
                        ref="payStyleSelect"
                        id="payStyleSelect"
                        name="payStyleSelect"
                        class="input-width-xlarge"
                        @change="changePpCd"
                >
                  <option value="">선택하세요</option>
                  <option
                          v-for="pay in phonePayStyleList"
                          :key="pay.code"
                          :value="pay.code"
                          title="대리점추천옵션요금제"
                  >
                    {{ pay.name }}
                  </option>
                </select>
                <span>{{  
                  $store.state.DynamicData['bandsPayTypeText'][1]
                }}</span>
                <div class="input-container" v-if="(this.openMarketInfo.registrationTypeCode === 'chg' || this.openMarketInfo.registrationTypeCode === 'renew') ">
                  <input
                    id="agreement-prevPpUse"
                    v-model="onsaPrevPpUseYn"
                    type="checkbox"
                    name="agreement-prevPpUse"
                    value="agreement-prevPpUse"
                    class="input-checkbox input-text input-text-disabled"
                  />
                  <label for="agreement-prevPpUse" class="input-label" @click="clickSelfPhonePay"
                  >기존요금제 유지</label >
                </div>
                <div class="data-text">{{ ppDscr }}</div>
              </div>
            </dd>
          </dl>
          <dl class="field-group">
            <dt class="field-label">
              <label for="shop-recommended-plan-data"
              >고객님이선택하신요금제</label
              >
            </dt>
            <dd class="field-control">
              <input
                      id="phone-pay-style"
                      v-model="registration.ppNm"
                      type="text"
                      name="phonePayStyle"
                      class="input-text input-font input-text-disabled input-width-xlarge"
                      readonly
                      title="요금제"
              />
              <ul class="notice-text-list">
                <li class="notice-text">
                  대리점 추천 요금제 외 다른 요금제 선택을 원하시면 해피콜
                  상담시 말씀해주시기바랍니다.
                </li>
              </ul>
            </dd>
          </dl>

          <div v-if="dataPayStyleList.length !== 0">
            <dl v-if="openMarketInfo.msBsType === 'MS'" class="field-group">
              <dt class="field-label">
                <label for="shop-recommended-plan-data"
                >대리점추천옵션요금제</label
                >
              </dt>
              <dd class="field-control">
                <div class="field-control-sub">
                  <select
                          v-model="registration.dataPpCd"
                          id="shop-recommended-plan-data"
                          name="check-fee-method"
                          class="input-width-mediumn"
                          ref="dataStyleSelect"
                          @change="changeDataPpCd()"
                  >
                    <option value="">선택하세요</option>
                    <option
                            v-for="dataPay in dataPayStyleList"
                            v-bind:key="dataPay.code"
                            :value="dataPay.code"
                            title="대리점추천옵션요금제"
                    >
                      {{ dataPay.name }}
                    </option>
                  </select>
                </div>
              </dd>
            </dl>

            <dl v-if="openMarketInfo.msBsType === 'MS'" class="field-group">
              <dt class="field-label">
                <label for="shop-recommended-plan-data"
                >고객님이선택하신옵션요금제</label
                >
              </dt>
              <dd class="field-control">
                <input
                        id="phone-data-style"
                        v-model="registration.dataPpNm"
                        type="text"
                        name="phoneDataStyle"
                        class="input-text input-font input-text-disabled"
                        readonly
                        title="선택요금제"
                />
                <ul class="notice-text-list">
                  <li class="notice-text">
                    대리점 추천 요금제 외 다른 요금제 선택을 원하시면 해피콜
                    상담시 말씀해주시기바랍니다.
                  </li>
                </ul>
              </dd>
            </dl>

            <dl class="field-group" v-if="togglePopSale">
              <dt class="field-label">
                <label for="popSale">할인서비스</label>
              </dt>
              <dd class="field-control">
                <div class="field-control-sub">
                  <a
                          class="link-detail"
                          id="popSale"
                          @click="discountDesc"
                          title="새창열림"
                          target="_blank"
                          tabindex="0"
                  >상세보기</a>
                </div>
                <ul class="notice-text-list">
                  <li class="notice-text">
                    장애인/국가유공자할인 - 대리점에 자격확인을 하신 후
                    신청하시기 바랍니다.
                  </li>
                </ul>
              </dd>
            </dl>
          </div>
        </div>
      </div>
    </div>

    <!-- 의무약정 RouterAgreedSection -->
    <!-- M2M 의무약정 -->
    <!-- [ST] [오픈마켓유심가입] 2025.12.18 전승미 -->
    <div v-if="part2.formM2MYn === 'Y' && display.agreedAgreeYn && openMarketInfo.shndHphnYn !== 'Y' && openMarketInfo.usimEntrAppfYn !== 'Y'">
    <!-- [ED] [오픈마켓유심가입] 2025.12.18 전승미 -->
      <!-- 라우터인 경우 -->
      <div
              class="section"
              v-if="openMarketInfo.rotrRqstCd === 'Y' && routerDutyData.length > 0"
      >
        <div class="section-header">
          <h3>
            <!--[ST] RITM2876892 M2M 요금약정기간 추가 건-->
            단말 의무약정
            <!--[ED] RITM2876892 M2M 요금약정기간 추가 건-->
          </h3>
        </div>
        <div class="section-body">
          <dl class="field-group">
            <dt class="field-label">
              <!--[ST] RITM2876892 M2M 요금약정기간 추가 건-->
              <label for="discMonth">단말약정기간</label>
              <!--[ED] RITM2876892 M2M 요금약정기간 추가 건-->
            </dt>
            <dd class="field-control">
              <select
                      v-model="retrieveData.rotrAgmtMmct"
                      ref="discMonth"
                      id="discMonth"
                      name="check-fee-method"
                      class="input-width-mediumn"
                      @change="chgAgreedPrice('rotr')"
              >
                <option value="">선택하세요</option>
                <option
                        v-for="rotr in routerDutyData"
                        v-bind:key="rotr.code"
                        :value="rotr.code"
                        title="라우터 약정"
                >
                  {{ rotr.name }}
                </option>
              </select>
            </dd>
          </dl>

          <div v-if="rotr_phonePriceTr">
            <dl class="field-group">
              <dt class="field-label">
                <label for="phoneHalbuPrice">약정지원금액</label>
              </dt>
              <dd class="field-control m-input-col">
                <input
                        id="phoneHalbuPrice"
                        ref="phoneHalbuPrice"
                        v-model="retrieveData.rotrAgmtAmt"
                        type="text"
                        name="phoneHalbuPrice"
                        class="input-text input-font input-text-disabled text-right mw80"
                        readonly
                        title="약정지원금액"
                /><span class="input-sub-text">원</span>
              </dd>
            </dl>
            <dl class="field-group">
              <dt class="field-label">
                <label for="pricePerMonth">월청구금액</label>
              </dt>
              <dd class="field-control m-input-col">
                <input
                        id="pricePerMonth"
                        ref="pricePerMonth"
                        value="0"
                        type="text"
                        name="pricePerMonth"
                        class="input-text input-font input-text-disabled text-right mw80"
                        readonly
                        title="월청구금액"
                /><span class="input-sub-text">원</span>
              </dd>
            </dl>
            <dl class="field-group">
              <dt class="field-label">
                <!--[ST] RITM2876892 M2M 요금약정기간 추가 건-->
                <label for="halbuMonth">단말약정기간</label>
                <!--[ED] RITM2876892 M2M 요금약정기간 추가 건-->
              </dt>
              <dd class="field-control m-input-col">
                <input
                        id="halbuMonth"
                        ref="halbuMonth"
                        v-model="retrieveData.rotrAgmtMmct"
                        type="text"
                        name="halbuMonth"
                        class="input-text input-font input-text-disabled text-right mw80"
                        readonly
                        title="약정기간"
                /><span class="input-sub-text">개월</span>
              </dd>
            </dl>
            <dl class="field-group" id="phonePriceTr">
              <dt class="field-label">
                <label for="phonePrice">위약금액</label>
              </dt>
              <dd class="field-control m-input-col">
                <input
                        id="phonePrice"
                        ref="phonePrice"
                        v-model="retrieveData.rotrAgmtAmt"
                        type="text"
                        name="phonePrice"
                        class="input-text input-font input-text-disabled text-right mw80"
                        readonly
                        title="위약금액"
                /><span class="input-sub-text">원</span>
              </dd>
            </dl>
          </div>

          <dl class="field-group" v-if="phonePriceDescTr">
            <dt class="field-label"></dt>
            <dd class="field-control m-input-col">
              <ul class="notice-text-list">
                <li class="notice-text">
                  약정기간 종료 전 이용계약을 해지/양수인 약정
                  미승계/약정철회/지원금받은 단말로 기변/약정요금제 변경 시
                  지원금반환금(정산금) 발생됨을 승인합니다.<br />
                  구매자 본인은 (<span
                        id="routrphonePayStyleTxt"
                        ref="routrphonePayStyleTxt"
                >{{ registration.ppNm }}</span
                >) 요금제를 (<span id="routrAgrMonthTxt">{{
                    retrieveData.rotrAgmtMmct
                  }}</span
                >)개월 동안 유지(약정) 하는 것을 조건으로 총 지원금 총
                  <span id="routrAgrPriceTxt">{{
                    retrieveData.rotrAgmtAmt
                  }}</span
                  >원(의무약정금액)을 단말기 구매가격 에누리로 받았습니다.<br />
                  지원금 반환금 산정식 : 위약금=약정금액X{(약정기간-약정후
                  사용기간) ÷ 약정기간(일)}
                </li>
                <li class="notice-text">
                  위와 같이 판매계약을 체결하고 뒷면의 의무약정,
                  지원금반환금(정산금) 규정 등을 충분히 이해하고 계약을 체결 및
                  준수할 것에 동의합니다.
                </li>
              </ul>
              <div
                      id="checkbox-container-iphone-agreement"
                      class="input-container"
              >
                <input
                        id="router-agreement"
                        v-model="registration.dutyAgmtAgrYn"
                        true-value="Y"
                        false-value="N"
                        type="checkbox"
                        title="라우터동의"
                        name="router-agreement"
                        value="router-agreement"
                        class="input-checkbox input-text"
                        ref="ref_agreementAgree"
                />
                <label for="router-agreement" class="input-label"><em class="primary-text">(필수)</em> 동의</label>
              </div>
            </dd>
          </dl>
        </div>
      </div>
      <!-- 일반 의무약정인 경우 -->
      <div
              class="section"
              v-if="part2.formM2MYn === 'Y' && openMarketInfo.rotrRqstCd != 'Y' && dutyData.length > 0"
      >
        <div class="section-header">
          <h3>
            <!--[ST] RITM2876892 M2M 요금약정기간 추가 건-->
            단말 의무약정
            <!--[ED] RITM2876892 M2M 요금약정기간 추가 건-->
          </h3>
        </div>
        <div class="section-body">
          <dl class="field-group">
            <dt class="field-label">
              <!--[ST] RITM2876892 M2M 요금약정기간 추가 건-->
              <label for="discMonth">단말약정기간</label>
              <!--[ED] RITM2876892 M2M 요금약정기간 추가 건-->
            </dt>
            <dd class="field-control">
              <div class="field-control-sub">
                <select
                        v-model="retrieveData.agmtTermMmct"
                        ref="discMonth"
                        id="discMonth"
                        name="check-fee-method"
                        class="input-width-mediumn"
                        @change="chgAgreedPrice('m2m')"
                >
                  <option value="">선택하세요</option>
                  <option
                          v-for="duty in dutyData"
                          v-bind:key="duty.code"
                          :value="duty.code"
                          title="의무약정"
                  >
                    {{ duty.name }}
                  </option>
                </select>
              </div>
            </dd>
          </dl>
          <div v-if="m2m_phonePriceTr">
            <dl class="field-group" ref="phoneHalbuPriceTr">
              <dt class="field-label">
                <label for="phoneHalbuPrice">약정지원금액</label>
              </dt>
              <dd class="field-control m-input-col">
                <input
                        id="phoneHalbuPrice"
                        ref="phoneHalbuPrice"
                        v-model="retrieveData.dutyAgmtSuptAmt"
                        type="text"
                        name="phoneHalbuPrice"
                        class="input-text input-font input-text-disabled text-right mw80"
                        readonly
                        title="약정지원금액"
                /><span class="input-sub-text">원</span>
              </dd>
            </dl>
            <dl class="field-group" ref="phoneHalbuPriceTr">
              <dt class="field-label">
                <label for="pricePerMonth">월청구금액</label>
              </dt>
              <dd class="field-control m-input-col">
                <input
                        id="pricePerMonth"
                        ref="pricePerMonth"
                        value="0"
                        type="text"
                        name="pricePerMonth"
                        class="input-text input-font input-text-disabled text-right mw80"
                        readonly
                        title="월청구금액"
                /><span class="input-sub-text">원</span>
              </dd>
            </dl>
            <dl class="field-group" ref="phoneHalbuPriceTr">
              <dt class="field-label">
                <!--[ST] RITM2876892 M2M 요금약정기간 추가 건-->
                <label for="halbuMonth">단말약정기간</label>
                <!--[ED] RITM2876892 M2M 요금약정기간 추가 건-->
              </dt>
              <dd class="field-control m-input-col">
                <input
                        id="halbuMonth"
                        ref="halbuMonth"
                        v-model="retrieveData.agmtTermMmct"
                        type="number"
                        name="halbuMonth"
                        class="input-text input-font input-text-disabled text-right mw80"
                        readonly
                        title="약정기간"
                /><span class="input-sub-text">개월</span>
              </dd>
            </dl>
            <dl class="field-group" ref="phonePriceTr">
              <dt class="field-label">
                <label for="phonePrice">위약금액</label>
              </dt>
              <dd class="field-control m-input-col">
                <input
                        id="phonePrice"
                        ref="phonePrice"
                        v-model="retrieveData.dutyAgmtSuptAmt"
                        type="text"
                        name="phonePrice"
                        class="input-text input-font input-text-disabled text-right mw80"
                        readonly
                        title="위약금액"
                /><span class="input-sub-text">원</span>
              </dd>
            </dl>
          </div>
          <dl class="field-group" id="m2mAgreeStyle" v-if="phonePriceDescTr">
            <dt class="field-label"></dt>
            <dd class="field-control m-input-col">
              <ul class="notice-text-list">
                <li class="notice-text">
                  약정기간 종료 전 이용계약을 해지/양수인 약정
                  미승계/약정철회/지원금받은 단말로 기변/약정요금제 변경 시
                  지원금반환금(정산금) 발생됨을 승인합니다.<br />
                  구매자 본인은 (<span id="m2mPhonePayStyleTxt">{{
                    registration.ppNm
                  }}</span
                >) 요금제를 (<span id="m2mAgrMonthTxt">{{
                    retrieveData.agmtTermMmct
                  }}</span
                >)개월 동안 유지(약정) 하는 것을 조건으로 총 지원금 총
                  <span id="m2mAgrPriceTxt">{{
                    retrieveData.dutyAgmtSuptAmt
                  }}</span
                  >원(의무약정금액)을 단말기 구매가격 에누리로 받았습니다.<br />
                  지원금 반환금 산정식 : 위약금=약정금액X{(약정기간-약정후
                  사용기간) ÷ 약정기간(일)}
                </li>
                <li class="notice-text">
                  위와 같이 판매계약을 체결하고 뒷면의 의무약정,
                  지원금반환금(정산금) 규정 등을 충분히 이해하고 계약을 체결 및
                  준수할 것에 동의합니다.
                </li>
              </ul>
              <div
                      id="checkbox-container-iphone-agreement"
                      class="input-container"
              >
                <input
                        id="router-agreement"
                        v-model="registration.dutyAgmtAgrYn"
                        true-value="Y"
                        false-value="N"
                        type="checkbox"
                        title="라우터동의"
                        name="router-agreement"
                        value="router-agreement"
                        class="input-checkbox input-text"
                        ref="ref_agreementAgree"
                />
                <label for="router-agreement" class="input-label"><em class="primary-text">(필수)</em> 동의</label>
              </div>
            </dd>
          </dl>
        </div>
      </div>
    </div>
    <!-- 의무약정 정책일 경우 -->
    <!-- [ST] [오픈마켓유심가입] 2025.12.18 전승미 -->
    <div v-if="part2.formM2MYn === 'N' && dutyAgmList.length > 0 && openMarketInfo.shndHphnYn !== 'Y' && openMarketInfo.usimEntrAppfYn !== 'Y'">
    <!-- [ED] [오픈마켓유심가입] 2025.12.18 전승미 -->
      <div class="section-body">
        <dl class="field-group">
          <dt class="field-label">            
            <label for="discMonth">약정기간</label>            
          </dt>
          <dd class="field-control">
            <div class="field-control-sub">
              <select
                      v-model="retrieveData.agmtTermMmct"
                      ref="discMonth"
                      id="discMonth"
                      name="check-fee-method"
                      class="input-width-mediumn"
                      @change="chgAgreedPrice('dutyAgm')"
              >
                <option value="">선택하세요</option>
                <option
                        v-for="dutyAgm in dutyAgmList"
                        v-bind:key="dutyAgm.agmtMnbr"
                        :value="dutyAgm.agmtMnbr"
                        title="의무약정"
                >
                  {{ duty.agmtMnbr }}
                </option>
              </select>
            </div>
          </dd>
        </dl>

        <dl class="field-group" id="phonePriceTr" v-if="duty_agm_phonePriceTr">
          <dt class="field-label">
            <label for="phonePrice">약정금액</label>
          </dt>
          <dd class="field-control m-input-col">
            <input
                    size="10"
                    id="phonePrice"
                    ref="phonePrice"
                    v-model="retrieveData.dutyAgmtSuptAmt"
                    type="text"
                    name="phonePrice"
                    class="input-text input-font input-text-disabled text-right mw80"
                    readonly
                    title="약정금액"
            /><span class="input-sub-text">원</span>
          </dd>
        </dl>

        <dl class="field-group">
          <dt class="field-label"></dt>
          <dd class="field-control m-input-col">
            <ul class="notice-text-list">
              <li
                      class="notice-text"
                      ref="phonePriceDescTr"
                      v-if="phonePriceDescTr"
              >
                약정 철회 시 위약금이 발생합니다.<br /><strong
              >위약금 = 약정금액 X {(약정기간 - 약정후 사용기간) ÷
                약정기간(일)}</strong
              ><br /><br />
              </li>
              <li class="notice-text">
                신규가입,번호이동,기기변경시 단말기 구입비의 일부 또는 전부를
                지원하는 조건으로 의무 사용기간을 정하는 프로그램입니다.
              </li>
              <li class="notice-text">
                약정기간 종료전에 이용계약 해지(요금미납, 단말기 분실.파손 등
                사유포함), 명의변경(양수인이 의무약정 승계 않는 경우),
              </li>
              <li class="notice-text">
                약정철회 시는 위약금을 납부하여야 합니다.<br /><br />
                <strong
                >위약금 = 약정금액 X {(약정기간 - 약정후 사용기간) ÷
                  약정기간(일)}</strong
                ><br />
                일시정지, 이용정지 등 기간은 약정 후 사용기간에 산입되지
                않습니다.
              </li>
            </ul>
            <div
                    id="checkbox-container-iphone-agreement"
                    class="input-container"
            >
              <input
                      id="router-agreement"
                      v-model="registration.dutyAgmtAgrYn"
                      true-value="Y"
                      false-value="N"
                      type="checkbox"
                      title="라우터동의"
                      name="router-agreement"
                      value="router-agreement"
                      class="input-checkbox input-text"
              />
              <label for="router-agreement" class="input-label"><em class="primary-text">(필수)</em> 동의</label>
            </div>
          </dd>
        </dl>
      </div>
    </div>

    <!--[ST] RITM2876892 M2M 요금약정기간 추가 건-->
    <!-- 요금할인약정 ChrgDcntAgreedSection -->
    <!-- M2M 요금할인약정 -->    
    <!--div v-if="part2.formM2MYn === 'Y' && display.agreedAgreeYn && openMarketInfo.shndHphnYn !== 'Y' && openMarketInfo.usimEntrAppfYn !== 'Y'"-->
    <div v-if="part2.formM2MYn === 'Y' && this.openMarketInfo.registrationTypeCode === 'new' && dsntData.length > 0">        
      <div class="section">  
        <div class="section-header">
          <h3>
            요금할인약정
          </h3>
        </div>
        <div class="section-body">
          <dl class="field-group">
            <dt class="field-label">
              <label for="dcntMonth">요금약정기간</label>
            </dt>
            <dd class="field-control">
              <select
                          id="m2mPpAgdcMmct"
                          v-model="registration.mobileRegistrationCaptureDetail.m2mPpAgdcMmct"
                          ref="ref_m2mPpAgdcMmct"
                          name="check-line-limit"
                          class="input-width-small"
                          @change="chgAgreedM2mDcntNm()"                          
                  >
                  <option value="">선택하세요</option>
                    <option
                            v-for="dsnt in dsntData"
                            v-bind:key="dsnt.code"
                            :value="dsnt.code"
                            title="요금할인약정"
                    >
                      {{ dsnt.name }}
                    </option>
                    <!--option value=''>선택하세요</option>
                    <option value='0'>없음</option>
                    <option value='24'>24개월</option>
                    <option value='36'>36개월</option>
                    <option value='36'>36개월</option-->
                  </select>
            </dd>
          </dl>
          <dl class="field-group" v-if="m2mDcntNmTr">
            <dt class="field-label">
              <label for="shop-recommended-plan-data"
              >M2M 요금약정할인명</label
              >
            </dt>
            <dd class="field-control">
              <input
                      id="m2mPpAgdcTermNm"
                      v-model="m2mDcntNm"
                      type="text"
                      name="m2mDcntNm"
                      class="input-text input-font input-text-disabled input-width-xlarge"
                      readonly
                      title="M2M 요금약정할인명"
              />              
            </dd>
          </dl>
          <dl class="field-group" v-if="m2mDcntNmTr">
          <dt class="field-label"></dt>
          <dd class="field-control m-input-col">
            <ul class="notice-text-list">              
              <li class="notice-text">
                약정 기간내에 해지하는 경우 아래 도표에 따라 약정할인 반환금이 부과됩니다.
              </li>                      
            </ul>
            <div class="table-wrapper">
              <table border="1">
                <thead>
                  <tr>
                    <th class="sticky_both" width="150">약정구분</th>
                    <th width="150">이용금액</th>
                    <th width="600">산식</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td align="center" rowspan=2>2년 약정</td>
                    <td align="center">6개월 이하</td>
                    <td align="center">기수혜 총 약정할인금액 * 100%</td>
                  </tr>
                  <tr>                    
                    <td align="center">7개월 이상</td>
                    <td align="center">기수혜 총 약정할인금액 * 잔여약정기간 / (약정기간 - 180일)</td>
                  </tr>
                  <tr>
                    <td align="center" rowspan=2>3년 약정</td>
                    <td align="center">8개월 이하</td>
                    <td align="center">기수혜 총 약정할인금액 * 100%</td>
                  </tr>
                  <tr>                    
                    <td align="center">9개월 이상</td>
                    <td align="center">기수혜 총 약정할인금액 * 잔여약정기간 / (약정기간 - 240일)</td>
                  </tr>
                </tbody>
              </table>            
            </div>
            <br/>
            <div
                    id="checkbox-container-iphone-agreement"
                    class="input-container"
            >
              <input
                      id="dcnt-agreement"
                      v-model="registration.mobileRegistrationCaptureDetail.agdcRfunAgrYn"
                      true-value="Y"
                      false-value="N"
                      type="checkbox"
                      title="요금약정동의"
                      name="dcnt-agreement"
                      value="dcnt-agreement"
                      class="input-checkbox input-text"
                      ref="ref_agreementAgreeM2mDcnt"
              />
              <label for="dcnt-agreement" class="input-label"><em class="primary-text">(필수)</em> 동의</label>
            </div>
          </dd>
        </dl>
        </div>
      </div>
    </div>
    <!--[ED] RITM2876892 M2M 요금약정기간 추가 건-->

    <!--[ST] RITM2876892 M2M 요금약정기간 추가 건-->
    <div v-if="part2.formM2MYn != 'Y'">
    <!-- 부가서비스 AdditionalServiceSection -->
      <div class="registration-page">
        <div class="registration-page-container">
          <div class="section">
            <div class="section-header"><h3>부가서비스</h3></div>
            <div class="section-body">
              <dl class="field-group"  v-if="sppsList.length !== 0 ">
                <dt class="field-label">
                  대리점추천 부가서비스
                </dt>
                <dd class="field-control">
                  <div class="field-control-sub">
                    <div v-if="sppsList.length !== 0">
                      <ul class="notice-text-list">
                        <li class="notice-text">
                        <!--  대리점 추천 부가 서비스-->
                        </li>
                      </ul>
                      <div
                              class="input-container"
                              v-for="(spps, index) in sppsList"
                              v-bind:key="index"
                      >
                        <p for="spps" class="input-label">- {{ spps.name }}</p>
                      </div>
                    </div>
                  </div> 
                </dd>
              </dl>
              <dl  class="field-group" v-if="rqstSppsList.length !== 0 ">
                <dt class="field-label">
                  고객선택 부가 서비스
                </dt>
                <dd class="field-control">
                  <a class="link-detail"
                            id="btnAddService"
                            @click="btnAddService"
                            title="새창열림"
                            target="_blank"
                            tabindex="0">상세보기</a>
                      <div class="input-container" v-for="(ssps, index) in rqstSppsList"
                              v-bind:key="index">
                        <input
                                :id="ssps.code"
                                v-model="part2.checkedRqstSppsCdList"
                                type="checkbox"
                                :value="ssps.code"
                                class="input-checkbox input-text"
                                title="선택부가서비스"
                        />
                        <label :for="ssps.code" class="input-label">{{ssps.name }}</label>
                      </div>
                  </dd>
                </dl>
                <!-- 디즈니 플러스 추가 시작  2021.11.02-->    
                <div v-if="onetDsnySppsUseYn === 'Y' ">        
                        <dl class="field-group">
                          <dt class="field-label">
                            디즈니 +
                          </dt>
                          <dd class="field-control">
                              <ul class="notice-text-list">
                                  <li class="notice-text">
                                    월트 디즈니 컴퍼니의 6개 브랜드를 하나의 동영상 스트리밍 서비스로 시청할 수 있는 OTT 서비스 입니다(OTT :  온라인동영상 스트리밍 서비스)
                                  </li>
                                </ul>
                                <a class="link-detail"
                                      id="popDisney"
                                      @click="popDisneyDetail"
                                      title="새창열림"
                                      target="_blank"
                                      tabindex="0">상세보기</a>
                                <div id="radio-disney-pay" class="input-container">
                                  <input
                                          id="disney-selection-pay"
                                          v-model="dsnyRqstSppsCd"
                                          type="radio"
                                          name="disney"
                                          value="LRZ0003114"
                                          class="input-checkbox input-text"
                                          title="디즈니 유형 선택"
                                          @click="checkDisney('1')"
                                          ref="ref_disneyPay"
                                  />
                                  <label for="disney-selection-pay" class="input-label">디즈니+ 유료 월 9900(부가세 포함)</label>
                              </div>
                              <div id="radio-disney-none" class="input-container">
                                <input
                                        id="disney-selection-none"
                                        v-model="dsnyRqstSppsCd"
                                        type="radio"
                                        name="disney"
                                        value=""
                                        class="input-checkbox input-text"
                                        title="디즈니유형 선택"
                                        @click="checkDisney('2')"
                                        ref="ref_rqstSppsCdCntn"
                                />
                                <label for="disney-selection-none" class="input-label">신청을 원하지 않음</label>
                              </div>
                                <div class="field-control-sub">
                                  <div id="checkbox-agreement-disney-confirm" class="input-container">
                                    <input
                                            id="agreement-disney-confirm" 
                                            v-model="dsnySppsAgrYn"
                                            type="checkbox"
                                            name="agreement-disney-confirm"
                                            class="input-checkbox input-text"
                                            title=""
                                            ref="ref_disneyConfirm"/>
                                    <label
                                            for="agreement-disney-confirm"
                                            class="input-label"
                                            @click="clickDsnySppsAgrYn()"
                                    ><em class="primary-text">(필수)</em> 디즈니+ 상품내용을 충분히 이해하고 이에대한 이용약관,개인정보3자 제공에 대한동의를 읽었으며 디즈니+월정액 서비스 가입에 동의합니다.</label>
                                  </div>
                                  <DisneyAgreePopup @close="popupDisneyClose" />
                                  <div class="field-control-sub">
                                    <a class="link-detail"
                                            id=""
                                            title="새창열림"
                                            target="_blank"
                                            tabindex="0"
                                            @click="clickDsnySppsPrvs()">이용약관보기</a>
                                  </div>
                              </div>
                          </dd>
                        </dl>
                </div>
              <!-- 디즈니 플러스 추가 끝 -->
              <dl class="field-group">
                <dt class="field-label">
                  휴대폰보험
                </dt>
                <dd class="field-control">
                  <ul class="notice-text-list">
                    <li class="notice-text">
                      신규폰 구입 후 발생되는 분실,도난,파손,침수시 단말기 교체
                      또는 수리비를 지원해 드리는 단말기 보험상품입니다.(유료)
                    </li>
                  </ul>
                  <a
                          class="link-detail"
                          id="popLssInsr"
                          @click="popLssInsr"
                          title="새창열림"
                          target="_blank"
                          tabindex="0"
                  >상세보기</a
                  >
                  <div class="field-control-sub">
                    <div id="radio-container-all" class="input-container">
                      <input
                              id="insuarance-selection-all"
                              v-model="registration.lssInsrCnslAgrYn"
                              type="radio"
                              name="all"
                              value="1"
                              class="input-checkbox input-text"
                              title="휴대폰 보험유형 선택"
                              ref="ref_lssInsrCnslAgrYn"
                              @click="checkInsr('1')"
                      />
                      <label for="insuarance-selection-all" class="input-label">
                        종합형(분실,파손보장)
                        <em class="primary-text">
                          (패드/워치/키즈폰은 제외)</em
                        ></label
                      >
                    </div>
                    <div id="radio-container-loss" class="input-container">
                      <input
                              id="insuarance-selection-loss"
                              v-model="registration.lssInsrCnslAgrYn"
                              type="radio"
                              name="loss"
                              value="3"
                              class="input-checkbox input-text"
                              title="휴대폰 보험유형 선택"
                              @click="checkInsr('3')"
                      />
                      <label for="insuarance-selection-loss" class="input-label"
                      >파손형(파손만보장)</label
                      >
                    </div>
                    <div id="radio-container-none" class="input-container">
                      <input
                              id="insuarance-selection-none"
                              v-model="registration.lssInsrCnslAgrYn"
                              type="radio"
                              name="none"
                              value="2"
                              class="input-checkbox input-text"
                              title="휴대폰 보험유형 선택"
                              @click="checkInsr('2')"
                      />
                      <label for="insuarance-selection-none" class="input-label"
                      >신청을 원하지 않음</label
                      >
                    </div>
                  </div>
                  <div class="field-control-sub">
                    <div id="checkbox-agreement-insuarance-confirm" class="input-container">
                      <input
                              id="agreement-insuarance-confirm"
                              v-model="lssInsrCnslAgrChk"
                              type="checkbox"
                              name="network-blocking"
                              class="input-checkbox input-text"
                              title=""
                              ref="ref_insuaranceConfirm"
                      />
                      <label
                              for="agreement-insuarance-confirm"
                              class="input-label"
                      ><em class="primary-text">(필수)</em> 휴대폰 분실/파손
                        보험에 대한 이용약관을 읽었으며 이에 동의합니다.</label
                      >
                    </div>
                  </div>
                  <div class="field-control-sub">
                    <a
                            class="link-detail"
                            id=""
                            title="새창열림"
                            target="_blank"
                            tabindex="0"
                            @click="popLssInsr2"
                    >이용약관보기</a
                    >
                  </div>
                </dd>
              </dl>

            <dl class="field-group" v-show="this.$store.state.openMarketInfo.onetTxinsrUseYn == 'Y'">
              <dl class="field-group">
                <dt class="field-label">
                  맘대로 폰교체
                </dt>
                <dd class="field-control">
                  <div class="field-control-sub">
                    <div id="radio-container-all" class="input-container input-horizontal" @click="checkInsrAlert()">
                      <input
                              id="insuarance-selection-change"
                              v-model="registration.onetAplePncrDivsCd"
                              value="01"
                              type="radio"
                              name="change"
                              class="input-checkbox input-text"
                              title="휴대폰 보험유형 선택"
                              ref="changeInsr"
                              v-bind:disabled="changeDisabled"
                              
                      />
                      <label for="insuarance-selection-change" class="input-label">                                        
                        교체형 가입<br>
                      <ul id="repeat-object" >
                        <li v-for="dsydLmt in dsydLmtList"   v-bind:key="dsydLmt.lssSdydTrmProdDivsCd" >
                          서비스명: {{ dsydLmt.lssSdydTrmProdDivsNm }} <br>
                          월이용료: {{ dsydLmt.lssDsydTrmMmUsfe }}원
                      </li>
                      </ul>
                      </label>
                    </div>
                    <div id="radio-container-none" class="input-container" @click="checkInsrAlert()">
                      <input
                              id="insuarance-selection-noChange"
                              v-model="registration.onetAplePncrDivsCd"
                              value="00"
                              type="radio"
                              name="noChange"
                              class="input-checkbox input-text"
                              title="휴대폰 보험유형 선택"
                              ref="noChangeInsr"
                              v-bind:disabled="noChangeDisabled"
                      />
                      <label for="insuarance-selection-noChange" class="input-label"
                        >미가입<br>
                        개통 후 1년이내만<br>
                        가입 가능합니다.

                        </label>
                    </div>
                    <div id="radio-container-none" class="input-container">
                      <a
                              class="link-detail"
                              id="popLssInsr"
                              @click="popLssInsr3"
                              title="새창열림"
                              target="_blank"
                              tabindex="0"
                      >자세히 보기</a
                      >
                    </div>
                    <div id="radio-container-none" class="input-container">
                      ※ 맘대로 폰교체는 파손, 고장 뿐 아니라 고객이 원할때 서비스 가입 동안 2회까지<br>
                        휴대폰을 교체할 수 있는 서비스 입니다.<br>
                      ※ 휴대폰 정상가에 따라 월 이용료가 정해지며, 가입 첫 달은 이용일 수에따라 요금을 계산 합니다.

                    </div>
                    <div id="" class="input-container">
                        <input
                                id="agreement-changeInsr-confirm"
                                v-model="changeInsrCnslAgrChk"
                                type="checkbox"
                                name="network-blocking"
                                class="input-checkbox input-text"
                                title=""
                                ref="ref_changeInsrConfirm"
                        />
                        <label
                                for="agreement-changeInsr-confirm"
                                class="input-label"
                        ><em class="primary-text">(필수)</em>맘대로 폰교체에 대한 이용약관을 읽었으며 이에 동의 합니다.</label
                        >
                    </div>
                  </div>
                </dd>
              </dl>
            </dl>
              <dl v-if="registration.custKdCd === 'A'" class="field-group">
                <dt class="field-label">
                  청소년 음란물정보 차단
                </dt>
                <dd class="field-control">
                  <ul class="notice-text-list">
                    <li class="notice-text">
                      청소년의 이동전화 가입 시 필수로 유해정보차단수단에
                      가입해야합니다.
                    </li>
                    <li class="notice-text">
                      차단장치의 종류 및 고지에 대한 안내를 받았으며, 차단장치
                      설치에 동의합니다.
                    </li>
                  </ul>
                  <!--
                <div
                    id="checkbox-container-adult-blocking"
                    class="input-container"
                  >
                    <input
                      id="agreement-adult-blocking"
                      v-model="registration.adltCntsIsolRqstYn"
                      type="checkbox"
                      name="adult-blocking"
                      true-value="Y"
                      false-value="N"
                      class="input-checkbox input-text"
                      title="청소년 음란물정보 차단 필수동의"
                      ref="ref_adultBlocking"
                    />
                    <label for="agreement-adult-blocking" class="input-label"
                      ><em class="primary-text">(필수)</em> 청소년 음란물정보
                      차단(무료) 동의</label
                    >
                  </div>
                  -->

                  <div class="field-control-sub">
                    <div
                            id="checkbox-container-network-blocking"
                            class="input-container"
                    >
                      <input
                              id="agreement-network-blocking"
                              v-model="registration.nwIsolYn"
                              type="checkbox"
                              name="network-blocking"
                              true-value="Y"
                              false-value="N"
                              class="input-checkbox input-text"
                              title="네트워크 차단 동의"
                              ref="ref_networkBlocking"
                      />
                      <label for="agreement-network-blocking" class="input-label"
                      ><em class="primary-text">(필수)</em> 네트워크차단(무료)
                        동의</label
                      >
                    </div>
                    <!-- 2020.08.14 문구추가 장희정 C20200805_81650_42816650-->
                    <label
                            for="radio-container-loss"
                            class="input-label"
                    ><em class="primary-text">자녀폰지킴이-앱차단(무료 또는 유료)필수 택1</em></label>
                    <!-- 아래 두개는 radio버튼 형식으로 바꿔야됨 둘 중 한개만 선택가능하도록 -->
                    <div id="radio-container-loss" class="input-container">
                      <input
                              id="agreement-app-blocking_op1"
                              v-model="registration.smatAppUseYn"
                              type="radio"
                              name="app-free"
                              class="input-checkbox input-text"
                              value="Y"
                              @change="appUseYnRadiobox"
                              title="자녀폰 지킴이 유료 무료 중 선택"
                              ref="ref_appBlocking_op1"
                      />
                      <label
                              for="agreement-app-blocking_op1"
                              class="input-label"
                      >(선택) 자녀폰 지킴이-앱차단(무료) 동의</label
                      >
                    </div>
                    <div id="radio-container-loss" class="input-container">
                      <input
                              id="agreement-app-blocking_op2"
                              v-model="registration.smatAppUseYn"
                              type="radio"
                              name="app-paid"
                              class="input-checkbox input-text"
                              value="N"
                              @change="appUseYnRadiobox"
                              title="자녀폰 지킴이 유료 무료 중 선택"
                              ref="ref_appBlocking_op2"
                      />
                      <label
                              for="agreement-app-blocking_op2"
                              class="input-label"
                      >(선택) 자녀폰 지킴이-앱차단(유료) 동의</label
                      >
                    </div>
                  </div>
                  <!--- -->
                </dd>
              </dl>
            </div>
          </div>
          <div
                  class="section"
                  id="plan-view-tr"
                  v-if="registration.dcntKdCd === 'DT01' && onsaAplyPlnNm === 'Six Plan'"
          >
            <div class="section-header">
              <h3>플랜</h3>
            </div>
            <div class="section-body">
              <dl class="field-group">
                <dt class="field-label">
                  식스플랜 약관동의
                </dt>
                <dd class="field-control">
                  <ul class="notice-text-list">
                    <li class="notice-text">
                      본인은 식스플랜 약정내용 및 유의사항을 충분히 안내 받았으며
                      이에 따라 가입을 신청합니다.
                    </li>
                  </ul>
                  <a
                          class="link-detail"
                          id="popsixPlan"
                          @click="sixPlanDesc"
                          tabindex="0"
                  >상세보기</a
                  >
                  <div class="field-control-sub">
                    <div
                            id="checkbox-container-foreignerAgree"
                            class="input-container"
                    >
                      <input
                              id="six-plan-agreement-check"
                              v-model="sixPlanAgreeChk"
                              type="checkbox"
                              name="sixPlan"
                              class="input-checkbox input-text"
                              title="식스플랜 약관동의"
                              ref="ref_sixPlanAgreeChk"
                      />
                      <label for="six-plan-agreement-check" class="input-label"
                      ><em class="primary-text">(필수)</em> 동의
                      </label>
                    </div>
                  </div>
                </dd>
              </dl>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--[ED] RITM2876892 M2M 요금약정기간 추가 건-->

    <!-- 선택옵션 SecureOptionSection -->
    <div class="registration-page">
      <div class="registration-page-container">
        <div class="section" v-if="this.part2.formM2MYn === 'N' && this.openMarketInfo.rotrRqstCd === 'N'">
          <div class="section-header">
            <h3>U+스토어 비밀번호설정안내</h3>
          </div>
          <div class="section-body">
            <dl class="field-group">
              <dt class="field-label">
                U+스토어 비밀번호설정안내
              </dt>
              <dd class="field-control">
                <ul class="notice-text-list">
                  <li class="notice-text">
                    안전한 결제를 위해 비밀번호를 꼭 설정하시기 바랍니다.<br />
                    <em class="primary-text"
                    >비밀번호 설정 방법은 가입 후 MMS를 통해 안내하오니
                      참조하시기 바랍니다</em
                    >
                  </li>
                </ul>
                <a
                        class="link-detail"
                        id="popPasswordDesc"
                        @click="passwordDesc"
                        tabindex="0"
                >상세보기</a
                >
                <div class="field-control-sub">
                  <div
                          id="checkbox-container-foreignerAgree"
                          class="input-container"
                  >
                    <input
                            id="store-security-setting-agreement"
                            v-model="passwordAgreeChk"
                            type="checkbox"
                            name="sixPlan"
                            class="input-checkbox input-text"
                            ref="ref_passwordAgreeChk"
                    />
                    <label
                            for="store-security-setting-agreement"
                            class="input-label"
                    ><em class="primary-text">(필수)</em> 확인</label
                    >
                  </div>
                </div>
              </dd>
            </dl>
          </div>
        </div>
        <!--[ST] RITM2876892 M2M 요금약정기간 추가 건-->
        <div v-if="part2.formM2MYn != 'Y'">
          <div class="section">
            <div class="section-header"><h3>선택사항</h3></div>
            <div class="section-body">
              <dl class="field-group">
                <dt class="field-label">
                  <label for="select-security-level">보안등급설정</label>
                </dt>
                <dd class="field-control">
                  <div class="field-control-sub">
                    <select
                            id="select-security-level"
                            v-model="registration.prmsLinePcnt"
                            ref="ref_prmsLinePcnt"
                            name="check-line-limit"
                            class="input-width-small"
                    >
                      <option value="">선택하세요</option>
                      <option value="0">비제한</option>
                      <option value="2">2회선</option>
                      <option value="3">3회선</option>
                    </select>
                  </div>
                  <ul class="notice-text-list">
                    <li class="notice-text">
                      보안등급에 따라 온라인가입가능 회선수를 설정할 수 있습니다.
                    </li>
                  </ul>
                </dd>
              </dl>
              <dl class="field-group">
                <dt class="field-label">
                  대리인 가입제한여부
                </dt>
                <dd class="field-control">
                  <div class="field-control-sub">
                    <div
                            id="radio-button-container-agent-enterLimitY"
                            class="input-container input-horizontal"
                    >
                      <input
                              id="set-limitation-agreement-yes"
                              v-model="registration.agntEntrRstnYn"
                              type="radio"
                              name="agentEnter"
                              value="Y"
                              class="input-radio"
                              title="대리인 가입제한여부 설정"
                              ref="ref_agntEntrRstnYn"
                      />
                      <label
                              for="set-limitation-agreement-yes"
                              class="input-label"
                      >제한</label
                      >
                    </div>
                    <div
                            id="radio-button-container-agent-enterLimitN"
                            class="input-container input-horizontal"
                    >
                      <input
                              id="set-limitation-agreement-no"
                              v-model="registration.agntEntrRstnYn"
                              type="radio"
                              name="agentEnter"
                              value="N"
                              class="input-radio"
                              title="대리인 가입제한여부 설정"
                      />
                      <label for="set-limitation-agreement-no" class="input-label"
                      >비제한</label
                      >
                    </div>
                  </div>
                  <ul class="notice-text-list">
                    <li class="notice-text">
                      본인이 아닌 대리인의 가입을 제한할 수 있습니다.
                    </li>
                  </ul>
                </dd>
              </dl>
            </div>
          </div>
        </div>
        <!--[ED] RITM2876892 M2M 요금약정기간 추가 건-->
        <v-dialog />
      </div>
    </div>

    <!-- 할부내역 InstallmentSection -->
    <!-- [ST] [오픈마켓유심가입] 2025.12.18 전승미 -->
    <div class="registration-page" v-if="openMarketInfo.isttYn === 'Y' && openMarketInfo.shndHphnYn !== 'Y' && openMarketInfo.usimEntrAppfYn !== 'Y'">
    <!-- [ED] [오픈마켓유심가입] 2025.12.18 전승미 -->
      <div class="registration-page-container">
        <div class="section">
          <div class="section-header"><h3>할부내역</h3></div>
          <div class="section-body">
            <dl class="field-group">
              <dt class="field-label">
                <label>할인유형</label>
              </dt>
              <dd class="field-control" v-if="display.useDscnt">
                <div
                        id="radio-button-container-installmentDevice-six"
                        class="input-container input-horizontal"
                >
                  <input
                          id="installment-type-six"
                          v-model="onsaAplyPlnNm"
                          @change="changeDcntKdCd"
                          type="radio"
                          name="installmentType"
                          value="Six Plan"
                          class="input-radio"
                          title="할인유형 선택"
                  />
                  <label for="installment-type-six" class="input-label"
                  >단말할인({{display.suptAmtTxt}}할인/식스플랜)</label
                  >
                </div>                
                <div
                        id="radio-button-container-installmentDevice-basic"
                        class="input-container input-horizontal"
                >
                  <input
                          id="installment-type-basic"
                          v-model="onsaAplyPlnNm"
                          @change="changeDcntKdCd"
                          type="radio"
                          name="installmentType"
                          value="Basic"
                          class="input-radio"
                          title="할인유형 선택"
                  />
                  <label for="installment-type-basic" class="input-label"
                  >단말할인({{display.suptAmtTxt}}할인/베이직플랜)</label
                  >
                </div>
                <div
                        id="radio-button-container-installmentFee"
                        class="input-container input-horizontal"
                        v-if="openMarketInfo.chocAgmtDcntUseYn === 'Y'"
                >
                  <input
                          id="installment-type-plan"
                          v-model="onsaAplyPlnNm"
                          @change="changeDcntKdCd"
                          type="radio"
                          name="installmentType"
                          value=""
                          class="input-radio"
                          title="할인유형 선택"
                  />
                  <label for="installment-type-plan" class="input-label"
                  >요금할인(선택약정할인)</label
                  >
                </div>

                <select
                        v-model="registration.isttTermMmct"
                        v-if="registration.dcntKdCd === 'DT02'"
                        @change="changeDcntKd"
                        name="installmentMonths"
                        class="input-width-small"
                >
                  <option value="12">12개월</option>
                  <option value="24">24개월</option>
                </select>
              </dd>
              <dd class="field-control" v-if="display.nonDscnt">
                <div
                        id="radio-button-container-installmentNone"
                        class="input-container input-horizontal"
                >
                  <input
                          id="installment-type-none"
                          v-model="registration.dcntKdCd"
                          type="radio"
                          name="installmentType"
                          value=""
                          class="input-radio"
                          title="할인유형 선택"
                  />
                  <label for="installment-type-none" class="input-label"
                  >해당없음</label
                  >
                </div>
              </dd>
            </dl>
<!-- [단통법폐지Prj] Start 단통법 폐지관련 해당 항목 삭제 및 추가 됨. 2025.06.04 miyoung34 -->
            <!-- <dl class="field-group"> -->
            <dl class="field-group" v-if="display.halbuArea">
<!-- [단통법폐지Prj] End 단통법 폐지관련 해당 항목 삭제 및 추가 됨. 2025.06.04 miyoung34 -->
              <dt class="field-label">
                <!-- tinsAmt -->
                <label for="installment-price">할부금액</label>
              </dt>
              <dd class="field-control">
                <div class="field-control-sub m-input-col">
                  <input
                          id="installment-price"
                          ref="phoneHalbuPrice"
                          type="text"
                          name="installmentPrice"
                          class="input-text-disabled input-font text-right mw80"
                          readonly
                          value=""
                          v-model="itemDstrDiscount.phoneHalbuPrice"
                  />
                  <span class="input-sub-text">원</span>
                </div>
              </dd>
            </dl>
<!-- [단통법폐지Prj] Start 단통법 폐지관련 해당 항목 삭제 및 추가 됨. 2025.06.04 miyoung34 -->
            <!-- <dl class="field-group"> -->
            <dl class="field-group" v-if="display.halbuArea">
<!-- [단통법폐지Prj] End 단통법 폐지관련 해당 항목 삭제 및 추가 됨. 2025.06.04 miyoung34 -->
              <dt class="field-label">
                <label for="installment-mon-price">월청구금액</label>
              </dt>
              <dd class="field-control">
                <div class="field-control-sub m-input-col">
                  <input
                          id="installment-mon-price"
                          type="text"
                          name="installmentMonthPrice"
                          class="input-text-disabled input-font text-right mw80"
                          readonly
                          v-model="pricePerMonth"
                          @blur="isInputActive = false"
                  />
                  <span class="input-sub-text">원</span>
                </div>
              </dd>
            </dl>
<!-- [단통법폐지Prj] Start 단통법 폐지관련 해당 항목 삭제 및 추가 됨. 2025.06.04 miyoung34 -->
            <!-- <dl class="field-group" v-if="registration.dcntKdCd === 'DT02'"> -->
            <dl class="field-group" v-if="registration.dcntKdCd === 'DT02' && display.halbuArea">
<!-- [단통법폐지Prj] End 단통법 폐지관련 해당 항목 삭제 및 추가 됨. 2025.06.04 miyoung34 -->
              <dt class="field-label">
                <label for="installment-period">할부기간</label>
              </dt>
              <dd class="field-control">
                <div class="field-control-sub m-input-col">
                  <input
                          id="installment-period"
                          v-model="registration.isttTermMmct"
                          type="text"
                          name="installmentMonthPeriod"
                          class="input-text-disabled input-font text-right mw80"
                          readonly
                  />
                  <span class="input-sub-text">개월</span>
                </div>
              </dd>
            </dl>
<!-- [단통법폐지Prj] Start 단통법 폐지관련 해당 항목 삭제 및 추가 됨. 2025.06.04 miyoung34 -->
            <!-- <dl class="field-group"> -->
            <dl class="field-group" v-if="display.halbuArea">
<!-- [단통법폐지Prj] End 단통법 폐지관련 해당 항목 삭제 및 추가 됨. 2025.06.04 miyoung34 -->
              <dt class="field-label">
                <!-- hphnInitStlmAmt -->
                <label for="first-required-price">최초청구금액</label>
              </dt>
              <dd class="field-control">
                <div class="field-control-sub m-input-col">
                  <input
                          id="first-required-price"
                          type="text"
                          name="firstRequirePrice"
                          class="input-text-disabled input-font text-right mw80"
                          readonly
                          v-model="itemDstrDiscount.phoneFirstPayPrice"
                  />
                  <span class="input-sub-text">원</span>
                </div>
              </dd>
            </dl>
<!-- [단통법폐지Prj] Start 단통법 폐지관련 해당 항목 삭제 및 추가 됨. 2025.06.04 miyoung34 -->
            <!-- <dl class="field-group"> -->
            <dl class="field-group" v-if="display.halbuArea">
<!-- [단통법폐지Prj] End 단통법 폐지관련 해당 항목 삭제 및 추가 됨. 2025.06.04 miyoung34 -->
              <dt class="field-label">
                할부수수료
              </dt>
              <dd class="field-control">
                <div class="field-control-sub">
                  <ul class="notice-text-list">
                    <li class="notice-text">
                      연 5.9%가 원리금 균등 분할 상환 방식으로 매월 청구 됨
                    </li>
                  </ul>
                </div>
              </dd>
            </dl>
<!-- [단통법폐지Prj] Start 단통법 폐지관련 해당 항목 삭제 및 추가 됨. 2025.06.04 miyoung34 -->
            <!-- <dl class="field-group"> -->
            <dl class="field-group" v-if="display.halbuArea">
<!-- [단통법폐지Prj] End 단통법 폐지관련 해당 항목 삭제 및 추가 됨. 2025.06.04 miyoung34 -->
              <dt class="field-label">
                <label for="release-price">출고가</label>
              </dt>
              <dd class="field-control">
                <div class="field-control-sub m-input-col">
                  <input
                          id="release-price"
                          type="text"
                          name="releasePrice"
                          class="input-text-disabled input-font text-right mw80"
                          readonly
                          v-model="itemDstrDiscount.dlvrPrc"
                  />
                  <span class="input-sub-text">원</span>
                </div>
              </dd>
            </dl>
<!-- [단통법폐지Prj] Start 단통법 폐지관련 해당 항목 삭제 및 추가 됨. 2025.06.04 miyoung34 -->
            <!-- <dl class="field-group"> -->
            <dl class="field-group" v-if="display.halbuArea">
<!-- [단통법폐지Prj] End 단통법 폐지관련 해당 항목 삭제 및 추가 됨. 2025.06.04 miyoung34 -->
              <dt class="field-label">
                <label for="total-support-price">총지원금</label>
              </dt>
              <dd class="field-control">
                <div class="field-control-sub m-input-col">
                  <input
                          id="total-support-price"
                          v-model="itemDstrDiscount.totalSuprtAmt"
                          type="text"
                          name="totalSupportPrice"
                          class="input-text-disabled input-font text-right mw80"
                          readonly
                  />
                  <span class="input-sub-text">원</span>
                  <!--
                  <span
                          class="input-sub-text"
                          v-if="
                      registration.isttTermMmct === '24' &&
                        registration.dcntKdCd === 'DT02'
                    "
                  >(공시지원금:
                    <span ref="suprtAmt24Txt">{{
                      itemDstrDiscount.suprtAmt24
                    }}</span
                    >원, 추가지원금:
                    <span ref="addSuprtAmt24Txt"
                    >{{ itemDstrDiscount.addSuprtAmt24 }}원)</span
                    ></span
                  >
                  <span
                          class="input-sub-text"
                          v-if="
                      registration.isttTermMmct === '12' &&
                        registration.dcntKdCd === 'DT02'
                    "
                  >(공시지원금:
                    <span ref="suprtAmt12Txt">{{
                      itemDstrDiscount.suprtAmt12
                    }}</span
                    >원, 추가지원금:
                    <span ref="addSuprtAmt12Txt"
                    >{{ itemDstrDiscount.addSuprtAmt12 }}원)</span
                    ></span
                  >
                  -->
                </div>
              </dd>
            </dl>
<!-- [단통법폐지Prj] Start 단통법 폐지관련 해당 항목 삭제 및 추가 됨. 2025.06.04 miyoung34 -->
            <!-- <dl class="field-group" v-if="(this.registration.isttTermMmct === '24' 
                                            && (this.registration.dcntKdCd === 'DT02') || this.registration.dcntKdCd === 'DT01' )
                                            "> -->
              <dl class="field-group" v-if="(this.registration.isttTermMmct === '24' 
                                            && (this.registration.dcntKdCd === 'DT02') || this.registration.dcntKdCd === 'DT01' )
                                            && display.halbuArea
                                            ">
<!-- [단통법폐지Prj] End 단통법 폐지관련 해당 항목 삭제 및 추가 됨. 2025.06.04 miyoung34 -->
              <dt class="field-label" align="right">
                <label for="release-price">{{display.suptAmtTxt}}</label><!-- 이통사지원금 -->
              </dt>
              <dd class="field-control">
                <div class="field-control-sub m-input-col">
                  <input
                          id="release-price"
                          type="text"
                          name="viewSuprtAmt24"
                          class="input-text-disabled input-font text-right mw80"
                          readonly
                          v-model="itemDstrDiscount.suprtAmt24"
                  />
                  <span class="input-sub-text">원</span>
                </div>
              </dd>
            </dl>
<!-- [단통법폐지Prj] Start 단통법 폐지관련 해당 항목 삭제 및 추가 됨. 2025.06.04 miyoung34 -->
            <!-- <dl class="field-group" v-if="this.registration.isttTermMmct === '12' && this.registration.dcntKdCd === 'DT02'"> -->
              <dl class="field-group" v-if="this.registration.isttTermMmct === '12' && this.registration.dcntKdCd === 'DT02' && display.halbuArea">
<!-- [단통법폐지Prj] End 단통법 폐지관련 해당 항목 삭제 및 추가 됨. 2025.06.04 miyoung34 -->
              <dt class="field-label" align="right">
                <label for="release-price">{{display.suptAmtTxt}}</label><!-- 이통사지원금 -->
              </dt>
              <dd class="field-control">
                <div class="field-control-sub m-input-col">
                  <input
                          id="release-price"
                          type="text"
                          name="viewSuprtAmt12"
                          class="input-text-disabled input-font text-right mw80"
                          readonly
                          v-model="itemDstrDiscount.suprtAmt12"
                  />
                  <span class="input-sub-text">원</span>
                </div>
              </dd>
            </dl>
<!-- [단통법폐지Prj] Start 단통법 폐지관련 해당 항목 삭제 및 추가 됨. 2025.06.04 miyoung34 -->
        <!-- <dl class="field-group" v-if="(this.openMarketInfo.addSuptAmtUseYn !== 'N') 
            && ((this.registration.isttTermMmct === '24' && this.registration.dcntKdCd === 'DT02') || this.registration.dcntKdCd === 'DT01')  
        -->
            <dl class="field-group" v-if="(this.openMarketInfo.addSuptAmtUseYn !== 'N') 
            && ((this.registration.isttTermMmct === '24' && this.registration.dcntKdCd === 'DT02') || this.registration.dcntKdCd === 'DT01') 
            && this.$store.state.openMarketInfo.lrpsDiscOpenYn == 'N'
            ">
<!-- [단통법폐지Prj] End 단통법 폐지관련 해당 항목 삭제 및 추가 됨. 2025.06.04 miyoung34 -->
              <dt class="field-label" align="right">
                <label for="release-price">추가지원금</label>
              </dt>
              <dd class="field-control">
                <div class="field-control-sub m-input-col">
                  <input
                          id="release-price"
                          type="text"
                          name="viewAddSuprtAmt24"
                          class="input-text-disabled input-font text-right mw80"
                          readonly
                          v-model="itemDstrDiscount.addSuprtAmt24"
                  />
                  <span class="input-sub-text">원</span>
                </div>
              </dd>
            </dl>
<!-- [단통법폐지Prj] Start 단통법 폐지관련 해당 항목 삭제 및 추가 됨. 2025.06.04 miyoung34 --> 
            <!-- <dl class="field-group" v-if="(this.openMarketInfo.addSuptAmtUseYn !== 'N') && (this.registration.isttTermMmct === '12' && this.registration.dcntKdCd === 'DT02') "> -->
              <dl class="field-group" 
                v-if="(this.openMarketInfo.addSuptAmtUseYn !== 'N') && (this.registration.isttTermMmct === '12' && this.registration.dcntKdCd === 'DT02')
                                && this.$store.state.openMarketInfo.lrpsDiscOpenYn == 'N'
            ">
<!-- [단통법폐지Prj] End 단통법 폐지관련 해당 항목 삭제 및 추가 됨. 2025.06.04 miyoung34 -->
              <dt class="field-label" align="right">
                <label for="release-price">추가지원금</label>
              </dt>
              <dd class="field-control">
                <div class="field-control-sub m-input-col">
                  <input
                          id="release-price"
                          type="text"
                          name="viewAddSuprtAmt12"
                          class="input-text-disabled input-font text-right mw80"
                          readonly
                          v-model="itemDstrDiscount.addSuprtAmt12"
                  />
                  <span class="input-sub-text">원</span>
                </div>
              </dd>
            </dl> 
<!-- [단통법폐지Prj] Start 단통법 폐지관련 해당 항목 삭제 및 추가 됨. 2025.06.04 miyoung34 -->           
            <!-- <dl class="field-group" v-if="'move' === this.openMarketInfo.registrationTypeCode"> -->
             <dl class="field-group" v-if="'move' === this.openMarketInfo.registrationTypeCode
                 && this.$store.state.openMarketInfo.lrpsDiscOpenYn == 'N'">
<!-- [단통법폐지Prj] End 단통법 폐지관련 해당 항목 삭제 및 추가 됨. 2025.06.04 miyoung34 -->
              <dt class="field-label" align="right">
                <label for="release-price">전환지원금</label>
              </dt>
              <dd class="field-control">
                <div class="field-control-sub m-input-col">
                  <input
                          id="release-price"
                          type="text"
                          name="viewAllCvrtSufuAmt"
                          class="input-text-disabled input-font text-right mw80"
                          readonly
                          v-model="itemDstrDiscount.allCvrtSufuAmt"
                  />
                  <span class="input-sub-text">원</span>
                </div>
              </dd>
            </dl>
<!-- [단통법폐지Prj] Start 단통법 폐지관련 해당 항목 삭제 및 추가 됨. 2025.06.04 miyoung34 -->   
            <dl class="field-group" v-if="this.$store.state.openMarketInfo.lrpsDiscOpenYn == 'Y'">
              <dt class="field-label" align="right">
                <label for="release-price"></label>
              </dt>
              <dd class="field-control">
                  <div
                          id="dv-onsa-dbnw-sufu-aply-yn"
                          class="input-container"
                  >
                    <input
                            id="check-onsa-dbnw-sufu-aply-yn"
                            v-model="onsaDbnwSufuAplyYn"
                            type="checkbox"
                            name="viewOnsaDbnwSufuAplyYn"
                            class="input-checkbox input-text"
                            ref="ref_onsaDbnwSufuAplyYn"
                            disabled
                    />
                    <label for="check-onsa-dbnw-sufu-aply-yn" class="input-label"><em class="primary-text">유통망지원금</em></label>
                  </div>
              </dd>
            </dl>
<!-- [단통법폐지Prj] End 단통법 폐지관련 해당 항목 삭제 및 추가 됨. 2025.06.04 miyoung34 -->
            <dl class="field-group">
              <dt class="field-label">
                <label></label>
              </dt>
              <dd class="field-control">
                <div
                        v-if="
                    $store.state.ValidationView[
                      'installmentSectionPhonePayStyle'
                    ][0]
                  "
                >
                  <ul class="notice-text-list">
                    <li class="notice-text">
                      본인은 선택적 약정할인 관한 내용을(약정기간,
                      선택적약정할인 반환금 발생사유 및 산정 방식 등) 충분히
                      안내 받았으며, 이에 {{ registration.isttTermMmct }}개월
                      약정으로 선택적 약정할인을 신청합니다
                    </li>
                  </ul>
                  <a class="link-detail" title="선택적약정할인"  @click="priceDiscount"
                  >상세보기</a
                  >
                </div>

                <ul
                        class="notice-text-list"
                        v-if="
                    $store.state.ValidationView[
                      'installmentSectionPhonePayStyle'
                    ][1]
                  "
                >
                  <li class="notice-text">
                    구매자 본인은 약정된 (
                    <span ref="phonePayStyleTxt">{{ registration.ppNm }}</span>
                    )요금제를 ( {{ registration.isttTermMmct }} ) 개월 동안
                    유지(약정) 하는 것을 조건으로 
                    <!-- [단통법폐지Prj] Start 단통법 폐지관련 해당 항목 삭제 및 추가 됨. 2025.06.04 miyoung34 -->
                    <!-- 지원금 총
                    <b ref="totalSuprtAmtTxt"
                    >{{ itemDstrDiscount.totalSuprtAmt }} 원</b
                    ><br />
                    을  -->
                    <span v-if="this.display.halbuArea">
                    지원금 총
                    <b ref="totalSuprtAmtTxt"
                    >{{ itemDstrDiscount.totalSuprtAmt }} 원</b
                    ><br />
                    을 
                    </span>
                    <!-- [단통법폐지Prj] End 단통법 폐지관련 해당 항목 삭제 및 추가 됨. 2025.06.04 miyoung34 -->
                    단말기 구매가격 에누리로 받았습니다.
                  </li>
                  <li class="notice-text">
                    약정기간 종료 전 이용계약을 해지/양수인 약정
                    미승계/약정철회/지원금받은 단말로 기변/약정요금제 변경 시
                    지원금반환금(정산금) 발생됨을 승인합니다.<br />
                    ( 지원금반환금 산정식 : 제공된 지원금(지원금 정산 반영 후) X
                    {(약정기간(일)-약정 후 사용기간(일))/약정기간(일)} )
                  </li>
                </ul>

                <ul
                        class="notice-text-list"
                        v-if="
                    $store.state.ValidationView[
                      'installmentSectionPhonePayStyle'
                    ][2]
                  "
                >
                  <li class="notice-text">
                    구매자 본인은 약정된
                    <b>{{ registration.isttTermMmct }}개월</b> 동안 사용기간을
                    유지할것을 약정하며, 선택한 요금제에 따라 위 표에 기재된
                    약정내용을 이행하는 조건으로 총
                    <b ref="totalSuprtAmtTxt">{{
                      itemDstrDiscount.totalSuprtAmt
                      }}</b
                    >원 을 단말기 구매가격에 에누리(할인)으로 제공 받았습니다
                  </li>
                  <li class="notice-text">
                    요금제 180일 미 유지 하향 변경 시 <br />
                    <em class="primary-text"
                    >약정기간 종료 전 이용계약을 해지/양수인 약정
                      미승계/약정철회/지원금받은 단말로 기변/약정요금제 변경 시
                      지원금반환금(정산금) 발생됨을 승인합니다. <br />
                      (지원금반환금 산정식 : 제공된 지원금(지원금 정산 반영 후)
                      X {(약정기간(일)-약정 후 사용기간(일))/약정기간(일)})</em
                    >
                  </li>
                  <li class="notice-text">
                    요금제 180일 유지 하향 변경 시
                    <em class="primary-text">별도 차액 정산금 없음.</em>
                  </li>
                  <li class="notice-text desc">
                    위와 같이 판매계약을 체결하고 뒷면의 할부약정,
                    지원금반환금(정산금) 규정 등을 충분히 이해하고 계약을 체결
                    및 준수할 것에 동의합니다.
                  </li>
                </ul>

                <div
                        v-if="
                    $store.state.ValidationView[
                      'installmentSectionPhonePayStyle'
                    ][3]
                  "
                >
                  <div>
                    <ul class="notice-text-list">
                      <li class="notice-text">
                        위와 같이 판매계약을 체결하고 뒷면의 할부약정,
                        지원금반환금(정산금) 규정 등을 충분히 이해하고 계약을
                        체결 및 준수할 것에 동의합니다.
                      </li>
                    </ul>
                  </div>
                  <div
                          id="checkbox-container-agreeContract"
                          class="input-container"
                  >
                    <input
                            id="agreement-all-installment-check"
                            v-model="agreeContract"
                            type="checkbox"
                            name="agreeContract"
                            class="input-checkbox input-text"
                            ref="ref_agreeContract"
                    />
                    <label
                            for="agreement-all-installment-check"
                            class="input-label"
                    ><em class="primary-text">(필수)</em> 동의</label
                    >
                  </div>
                </div>
              </dd>
            </dl>
          </div>
        </div>
      </div>
    </div>

    <!-- 배송지입력 ShipToAddrSection -->
    <div class="registration-page">
      <div class="registration-page-container">
        <div class="section">
          <div class="section-header"><h3>배송지</h3></div>
          <div class="section-body">
            <dl class="field-group">
              <dt class="field-label">
                정보확인
              </dt>
              <dd class="field-control">
                <div
                        id="checkbox-container-agreeContract"
                        class="input-container"
                >
                  <input
                          id="check-same-address-with-customer"
                          v-model="display.sameWithCustomerAddressToShip"
                          type="checkbox"
                          name="sameWithCustomerAddressToShop"
                          class="input-checkbox input-text"
                  />
                  <label
                          for="check-same-address-with-customer"
                          class="input-label"
                          @click="copyCustomerAddressToShop"
                  >위 가입자 정보와 동일</label
                  >
                </div>
              </dd>
            </dl>
            <dl class="field-group">
              <dt class="field-label">
                <label for="shipment-receiver-name">수취인명</label>
              </dt>
              <dd class="field-control">
                <input
                        v-model="registration.dlvRcipNm"
                        id="shipment-receiver-name"
                        type="text"
                        @input="onlyText"
                        name="name"
                        autocomplete="off"
                        class="input-text input-font"
                        title="수취인 성명 입력"
                        ref="ref_dlvRcipNm"
                />
              </dd>
            </dl>

            <dl class="field-group">
              <dt class="field-label">
                고객주소
              </dt>
              <dd class="field-control">
                <div class="field-control-sub m-input-half">
                  <input
                          v-model="registration.dlplZpcd"
                          type="text"
                          name="postCode"
                          class="input-text input-width-xsmall input-font input-text-disabled"
                          placeholder="우편번호"
                          readonly
                          title="우편번호"
                  />
                  <span class="field-group-space"></span>
                  <button
                          @click="zipcodeAddressPop"
                          title="새창열림"
                          type="button"
                          ref="ref_zipcodeAddressPop"
                  >
                    주소찾기
                  </button>
                </div>
                <div class="field-control-sub">
                  <input
                          v-model="registration.dlplBadr"
                          type="text"
                          name="address1"
                          class="input-text input-width-xlarge input-font input-text-disabled"
                          readonly
                          title="주소"
                  />
                </div>
                <div class="field-control-sub">
                  <input
                          v-model="registration.dlplDadr"
                          type="text"
                          name="address2"
                          class="input-text input-width-xlarge input-font input-text-disabled"
                          readonly
                          title="주소"
                  />
                </div>
              </dd>
            </dl>

            <dl class="field-group">
              <dt class="field-label">
                <label for="shipment-receiver-phone-number1"
                >수취인 연락처1</label
                >
              </dt>
              <dd class="field-control">
                <input
                        v-model="registration.dlplTlno"
                        id="shipment-receiver-phone-number1"
                        type="text"
                        maxlength="11"
                        @input="onlyNumber"
                        name="shipment-receiver-phone-number1"
                        autocomplete="off"
                        class="input-text input-font"
                        placeholder="'-' 없이 숫자만 입력"
                        title="수취인 기본 연락처 입력"
                        ref="ref_dlplTlno"
                />
              </dd>
            </dl>

            <dl class="field-group">
              <dt class="field-label">
                <label for="shipment-receiver-phone-number2"
                >수취인 연락처2</label
                >
              </dt>
              <dd class="field-control">
                <input
                        v-model="registration.dlvCtplNm"
                        id="shipment-receiver-phone-number2"
                        type="text"
                        maxlength="11"
                        @input="onlyNumber"
                        name="shipment-receiver-phone-number2"
                        autocomplete="off"
                        class="input-text input-font"
                        placeholder="'-' 없이 숫자만 입력"
                        title="수취인 추가 연락처 입력"
                />
              </dd>
            </dl>
          </div>
        </div>
        <div class="section">
          <div class="section-header">
            <h3>기타</h3>
          </div>
          <div class="section-body">
            <dl class="field-group">
              <dt class="field-label">
                <label for="leave-additional-request">추가요청사항</label>
              </dt>
              <dd class="field-control">
                <textarea
                        v-model="registration.addReqMttrCntn"
                        id="leave-additional-request"
                        name="addReqMttrCntn"
                        @input="onlyText"
                        rows="5"
                        class="input-text input-font"
                        placeholder="요청사항을 입력하세요"
                        title="추가요청사항 입력"
                />
              </dd>
            </dl>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isPart2Popup">
      <ZipcodeDirectPopup @close="popupClose" />
    </div>
    <div v-if="isOpenTransitionPopUp">
      <TransitionSupportPopup @close="transitionPopupClose" @confirm="transitionPopupConfirm" />
    </div>
    <v-dialog />
  </div>
</template>

<script>
  import { common } from '~/js/common'
  import { searchCtdoClssNmList,searchCcwNmList ,searchTownNmAdngList} from '@/api/common'
  import request from '@/utils/request'
  import {
    getPricePlan,
    getItemDstrZero,
    getItemDstrDiscount,
    getItemDstrDiscountNew,
    getItemDstrDiscountNDbwnSuptAmt
  } from '@/api/captureService'
  import { getComCodeList } from '@/api/metaService'
  import {
    getPayStyleInfo,
    getSelfPhonePay,
    getApplServiceKindInfo,
    getDeviceList,
    getLssDaydInsLmtList,
    //[ST][CSR ID:RITM2876892] M2M 요금약정기간 추가 건-20260909
    requestChrgAgmtPlcy
    //[ED][CSR ID:RITM2876892] M2M 요금약정기간 추가 건-20260909
  } from '@/api/openmarket'
  import IphoneAgreePopup from '../popup/IphoneAgreePopup'
  import ZipcodeDirectPopup from '../popup/ZipcodeDirectPopup'
  import DisneyAgreePopup from '../popup/DisneyAgreePopup'
  import { nextTick } from 'q'
  import TransitionSupportPopup from "../popup/TransitionSupportPopup";
  export default {
    name: 'Part2',

    props: {
      openMarketInfoProps: Object,
      registrationProps: Object,
      sectionDataProps: Object
    },

    components: {
      IphoneAgreePopup,
      ZipcodeDirectPopup,
      DisneyAgreePopup,
      TransitionSupportPopup,
    },

    computed: {
    },

    data() {
      return {
        isOpenTransitionPopUp: false,
        ppDscr: '',
        togglePopSale: false,
        passwordAgreeChk: false,
        agreeContract: false,
        sixPlanAgreeChk: false,
        chkAgree5G: false,
        chkAgree5GCoverage: false,
        openMarketInfo: {},
        registration: {},
        part2: {},
        totalSuprtAmt: 0,
        pricePerMonth: 0,
        onsaAplyPlnNm: '',
        onsaPrevPpUseYn: false,
        itemDstrDiscount: {
          itemId: '', //단말기모델코드     String 15
          dlvrPrc: '', //*출고가격        String 15
          majrPrdctNm: '', //단말기명         String 240
          svcCd: '', //상품코드(요금제코드)  String 10
          svcNm: '', //상품명(요금제명)      String 240
          devcSbsd: '', //단말보조금       String 13
          devcPrmn: '', //단말장려금       String 13
          sbsdPayAmt: '', //보조금지급금액    String 13
          cntcTermMnbr: '', //계약기간개월수  String 10
          entrSttsCd: '', //판매가격할인금액   String 13
          suprtAmt24: '', //*지원금(24개월기준)    총지원금        String 13
          addSuprtAmt24: '', //추가지원금(24개월기준)  추가지원금(입력용)  String 13
          saleAmt24: '', //*판매가(24개월기준)  출고가-총지원금    String 13
          dscntUseQtyRateNac: '', //"할인사용수량요율(010신규)" String 5
          dscntUseQtyRateMnp: '', //"할인사용수량요율(번호이동)"  String 5
          dscntUseQtyRateRjn: '', //"할인사용수량요율(재가입,기변) String 5
          workDvRateNac: '', //"작업구분별 요율계산(010신규)" String 20
          workDvRateMnp: '', //"작업구분별 요율계산(번호이동)"  String 20
          workDvRateRjn: '', //"작업구분별 요율계산(재가입,기변)"   String 20
          dscntUseQtyRate: '',
          workDvRate: '',
          totalSuprtAmt: '',
          phoneHalbuPrice: '',
          pricePerMonth: '',
          phoneFirstPayPrice: '',
          startDate: '',
          endDate: '',
          suprtAmt12: '',
          addSuprtAmt12: '',
          mbltDirtAmt12: '',
          saleAmt12: '',
          trmSaleSufuDcntKndCd: '',
          mnpCvrtSuptAmt:'', //"번호이동전환지원금"
          addCvrtSuptAmt:'', //"추가전환지원금"
          allCvrtSufuAmt:'' //"총전환지원금"
        },

        phonePayStyleList: [],
        sppsList: [],
        rqstSppsList: [],
        dataPayStyleList: [],
        discList: [],
        pricePlan: {},
        deviceList: [],
        colorList: [],
        vUsimRqstYn:"",
        // [단통법폐지Prj] Start 단통법 폐지관련 해당 항목 추가 됨. 2025.06.04 miyoung34
        onsaDbnwSufuAplyYn:true, // 유통망지원금적용여부
        // [단통법폐지Prj] End 단통법 폐지관련 해당 항목 추가 됨. 2025.06.04 miyoung34
        display: {
          useDscnt: true,
          nonDscnt: false,
          isIPhoneDevice: false,
          is5GDevice: false,
          agreedAgreeYn: true,
          sameWithCustomerAddressToShip: false,
          isEsimDevice:false
          // [단통법폐지Prj] Start 단통법 폐지관련 해당 항목 추가 됨. 2025.06.04 miyoung34
          ,halbuArea:false
          ,suptAmtTxt: this.$store.state.openMarketInfo.lrpsDiscOpenYn == 'N' ? '공시지원금' : '이통사지원금',
          // [단통법폐지Prj] End 단통법 폐지관련 해당 항목 추가 됨. 2025.06.04 miyoung34
        },

        originItemDstrDiscount: {
          itemId: '',
          dlvrPrc: 0,
          majrPrdctNm: '',
          svcCd: '',
          svcNm: '',
          devcSbsd: 0,
          devcPrmn: 0,
          sbsdPayAmt: 0,
          cntcTermMnbr: 0,
          entrSttsCd: '',
          suprtAmt24: 0,
          addSuprtAmt24: 0,
          saleAmt24: 0,
          dscntUseQtyRateNac: 0,
          dscntUseQtyRateMnp: 0,
          dscntUseQtyRateRjn: 0,
          workDvRateNac: 0,
          workDvRateMnp: 0,
          workDvRateRjn: 0,
          dscntUseQtyRate: 0,
          workDvRate: 0,
          totalSuprtAmt: 0,
          phoneHalbuPrice: 0,
          pricePerMonth: 0,
          phoneFirstPayPrice: 0,
          suprtAmt12: 0,
          addSuprtAmt12: 0,
          mbltDirtAmt12: 0,
          saleAmt12: 0,
          trmSaleSufuDcntKndCd: '',
          mnpCvrtSuptAmt:0, //"번호이동전환지원금"
          addCvrtSuptAmt:0, //"추가전환지원금"
          allCvrtSufuAmt:0  //"총전환지원금"
        },

        retrieveData: {
          rotrAgmtAmt: '0',
          rotrAgmtMmct: '',
          dutyAgmtSuptAmt: '0',
          agmtTermMmct: ''
        },
        m2m_phonePriceTr: false,
        duty_agm_phonePriceTr: false,
        rotr_phonePriceTr: false,
        phonePriceDescTr: false,

        //[ST][CSR ID:RITM2876892] M2M 요금약정기간 추가 건-20260909
        m2mDcntNmTr: false,
        //[ED][CSR ID:RITM2876892] M2M 요금약정기간 추가 건-20260909

        isIphonePop: false,
        isPart2Popup: false,
        is_payStyleData: false,
        lssInsrCnslAgrChk: false,
        changeInsrCnslAgrChk: false,
        hasItem: false,
        bandsPayTypeText1: '',
        nonDscntTp: 'N',

        //맘대로 폰교체 disabled
        noChangeDisabled: '',
        changeDisabled: '',
        dsydLmtList:[],// 맘대로 보험 추가 장희정


        dutyData: [], //의무약정 정보 리스트
        routerDutyData: [],
        //[ST][CSR ID:RITM2876892] M2M 요금약정기간 추가 건-20261018
        dsntData: [], //요금할인약정 정보 리스트
        //[ED][CSR ID:RITM2876892] M2M 요금약정기간 추가 건-20261018        
        mccoList: [],
        dutyAgmList: [
          // {
          //     existYn: '',
          //     mdlUpr: '',
          //     itemId: '',
          //     agmtAmt: '',
          //     agmtMnbr: '',
          //     dlrAgmtAmt: '',
          //     dlrAgmtLslp: '',
          //     dscntKdCd: '',
          // }
        ],
        // 5g 커버리지 장희정
        addr: {
          ctdoClssNm: '',
          ccwNm: '',
          townNm: '',
        },
        ctdoList: [],
        ccwNmList:[],
        townNmList:[],
        disneyAgrChk:false,
        isDisneyPop:false,
        onetDsnySppsUseYn:'',
        dsnySppsAgrYn:false,
        dsnyRqstSppsCd:'',
        // 이벤트 메시지
        isShowEventMsg: false ,
        
        //과기부 번호이동 간소화
        isShowSoacYn: false

        //[ST]MNP 전환지원금 고객확인여부 (2024-03-19)*/
        , chkAgreeMNP: false
        //[ED]MNP 전환지원금 고객확인여부 (2024-03-19)*/

        //[ST][CSR ID:RITM2876892] M2M 요금약정기간 추가 건-20260909
        , chrgAgmtPlcyData: []
        , m2mDcntNm: ''
        //[ED][CSR ID:RITM2876892] M2M 요금약정기간 추가 건-20260909 
     
      }
     
    },

    created() {
      this.isIphnUseAgr = 'N'
      this.isIphonePop = false
      this.lssInsrCnslAgrChk = false
      this.display.sameWithCustomerAddressToShip = false
      this.sixPlanAgreeChk = false
      this.registration.prmsLinePcnt = ""
      this.registration.dvicColrCd = ""
    },

    mounted() {
      this.initPart2()
      this.isIphnUseAgr = this.registration.iphnUseAgrYn === 'Y' ? 'Y' : 'N'
      this.isIphonePop = this.registration.iphnUseAgrYn === 'Y' ? true : false
      this.display.isIPhoneDevice = this.isIphonePop
      this.display.is5GDevice = this.chkAgree5G
      //[단통법폐지Prj] Start 단통법 폐지관련 추가 2025.06.04 miyoung34
      this.display.halbuArea = (this.$store.state.openMarketInfo.lrpsDiscOpenYn == 'N' 
                                || (this.$store.state.openMarketInfo.lrpsDiscOpenYn == 'Y' && this.$store.state.openMarketInfo.dmbrYn == 'Y'))
      //[단통법폐지Prj] End 단통법 폐지관련 추가 2025.06.04 miyoung34
      this.togglePopSale =
              this.openMarketInfo.rotrRqstCd === 'Y' ||
              (this.openMarketInfo.isttYn === 'Y' && this.part2.formM2MYn === 'Y')
      this.getDeviceList(this.openMarketInfo.dealCd, this.openMarketInfo.formId)
      this.getColorList(this.openMarketInfo.dealCd, this.openMarketInfo.formId)
      this.getMccoList(this.openMarketInfo.dealCd, this.openMarketInfo.formId)
      if(this.registration.dcntKdCd === 'DT02') {
        this.registration.isttTermMmct = this.registration.agmtTermMmct
      }
      this.isttTermMmct()

      //맘대로 폰교체 onload 세팅
      if(this.registration.lssInsrCnslAgrYn != '2') {
          this.changeDisabled = true;
          this.noChangeDisabled = true;
        } else {
          this.changeDisabled = false;
          this.noChangeDisabled = false;
       }
    
      //[ST][CSR:C20211110_82139_4482139] 신규부가서비스(디즈니)반영요청건 2021.11.15 박지숙 
      for (let i = 0; i < this.part2.checkedRqstSppsCdList.length; i++) {
        if(this.part2.checkedRqstSppsCdList[i] === 'LRZ0003114' ){
          this.dsnyRqstSppsCd = 'LRZ0003114'
          this.dsnySppsAgrYn = this.registration.mobileRegistrationCaptureDetail.onetDsnySppsAgrYn === 'Y' ? true : false
        }
      }       
      // [ED][CSR:C20211110_82139_4482139] 신규부가서비스(디즈니)반영요청건 2021.11.15 박지숙 
      
      this.vUsimRqstYn = this.registration.mobileRegistrationCaptureDetail.usimRqstYn
      this.vEsimTrmYn = this.registration.mobileRegistrationCaptureDetail.esimTrmYn

      //[ST] 예판 일경우 날짜 체크 시작 2023.02.02 장희정
      
      var dateObj = new Date(); // 날짜 Object 생성
      var age     = 0; // 나이
      var yy      = dateObj.getFullYear(); // 현재년도
      var mm      = dateObj.getMonth() + 1; // 현재월
      var dd      = dateObj.getDate(); // 현재일

      if (mm < 10) mm = '0' + mm; // 현재 월이 10보다 작을경우 '0' 문자 합한다
      if (dd < 10) dd = '0' + dd; // 현재 일이 10보다 작을경우 '0' 문자 합한다
      var getdate = yy +"-"+ mm +"-"+ dd;
 
      const  today=new Date(getdate);
      const  sdate = new Date('2023-02-06');
      const  edate = new Date('2023-02-13');

      if(today>= sdate  && today <= edate){
          this.isShowEventMsg = true
      }
      //[ED] 예판 일경우 날짜 체크 시작 2023.02.02 장희정
      
      //[ST] 과기부 번호이동 간소화 2023.12.22
      const soacdate =  new Date('2024-01-02');
      if(today < soacdate){
        this.isShowSoacYn = true
      }
      //[ED] 과기부 번호이동 간소화 2023.12.22

    },

    methods: {
      /**
       * Function    : initPart2
       * Description : Part2 초기 세팅 함수
       **/
      initPart2() {
        this.$store.dispatch('SetDevcieSectionSelfPhonePayStyle', false)
        this.openMarketInfo = this.openMarketInfoProps
        this.registration = this.registrationProps
        this.part2 = this.sectionDataProps
        this.getDutyData()
        this.getRouterDutyData()
        //[ST][CSR ID:RITM2876892] M2M 요금약정기간 추가 건-20261018
        this.getDsntData()
        //[ED][CSR ID:RITM2876892] M2M 요금약정기간 추가 건-20261018        
        this.fn_AgreedMonthInit()
        if (this.registration.dvicMdlCd) {
          this.fn_setPhoneModel(this.$refs.phoneModelCd)
          if (this.registration.ppCd) {
            this.fn_paySelect()
          }
        }

        //[ST][CSR ID:RITM2876892] M2M 요금약정기간 추가 건-20260909

        //단말약정 버그 수정
        this.retrieveData.agmtTermMmct = this.registration.agmtTermMmct
        this.retrieveData.rotrAgmtMmct = this.registration.rotrAgmtMmct
        
        this.m2mDcntNm = this.registration.mobileRegistrationCaptureDetail.m2mPpAgdcTermNm
        //this.registration.mobileRegistrationCaptureDetail.m2mPpAgdcMmct = ''
        //this.registration.mobileRegistrationCaptureDetail.agdcRfunAgrYn = 'Y'

        if( this.registration.mobileRegistrationCaptureDetail.m2mPpAgdcMmct == '24'
            || this.registration.mobileRegistrationCaptureDetail.m2mPpAgdcMmct == '36'
        ){
          this.m2mDcntNmTr = true
          
          this.getChrgAgmtPlcy()
        }else{
          this.m2mDcntNmTr = false          
          this.registration.mobileRegistrationCaptureDetail.m2mPpAgdcTermNm = ''
        }
        //[ED][CSR ID:RITM2876892] M2M 요금약정기간 추가 건-20260909

        //console.log("test = " + this.registration.mobileRegistrationCaptureDetail.m2mPpAgdcMmct)
      },

      /**
       * Function    : onlyNumber
       * Description : input값 숫자 체크
       **/
      onlyNumber(e) {
        if(e.target.name === 'transferMobileNo') this.registration.chgHopTlno = e.target.value.replace(/[^0-9]/gi, '')
        if(e.target.name === 'desired-number') this.registration.chgHopTlno = e.target.value.replace(/[^0-9]/gi, '')
        if(e.target.name === 'chg-hope-full-phone-number') this.registration.chgHopTlno = e.target.value.replace(/[^0-9]/gi, '')
        if(e.target.name === 'shipment-receiver-phone-number1') this.registration.dlplTlno = e.target.value.replace(/[^0-9]/gi, '')
        if(e.target.name === 'shipment-receiver-phone-number2') this.registration.dlvCtplNm = e.target.value.replace(/[^0-9]/gi, '')
      },

      /**
       * Function    : onlyText
       * Description : input값 텍스트 체크
       **/
      onlyText(e) {
        if(e.target.name === 'phone-serial-number') this.registration.trmSrno = e.target.value.replace(/[^ㄱ-ㅎ가-힣a-zA-Z0-9_@*/+.-\s]/gi, '')
        if(e.target.name === 'shipment-receiver-name') this.registration.dlvRcipNm = e.target.value.replace(/[^ㄱ-ㅎ가-힣a-zA-Z0-9_@*/+.-\s]/gi, '')
        if(e.target.name === 'addReqMttrCntn') this.registration.addReqMttrCntn = e.target.value.replace(/[^ㄱ-ㅎ가-힣a-zA-Z0-9_@*/+.-\s]/gi, '')
      },

      /**
       * Function    : transferCompanySectionValidation
       * Description : 번호이동 validation
       **/
      transferCompanySectionValidation() {
        let regExp
        let title = '온라인 가입신청 안내'

        // 번호이동 validation
        if (this.openMarketInfo.registrationTypeCode === 'move') {
          if (!this.registration.chgHopTlno) {
            this.openAlert(
                    title,
                    '번호 이동 전화번호를 입력하세요.',
                    this.$refs.ref_transferMobileNumber
            )
            return false
          }
          regExp = /^[0-9]{10,11}$/
          if (!regExp.test(this.registration.chgHopTlno)) {
            this.openAlert(
                    title,
                    '번호 이동 전화번호는 10자리 이상 숫자를 입력해주세요.',
                    this.$refs.ref_transferMobileNumber
            )
            return false
          }
          if (!this.registration.noRnftEnprCd) {
            this.openAlert(
                    title,
                    '변경전 통신사를 선택하세요.',
                    this.$refs.ref_transferCompany
            )
            return false
          }
          if(this.isShowSoacYn){
            if (!this.registration.mnpSoacTrgtCd) {
              this.openAlert(
                      title,
                      '정산 요금 확인을 위해 정산대상을 선택하세요.',
                      this.$refs.ref_mnpSoacTrgtCd
              )
              return false
            }
            if (this.registration.mnpSoacTrgtCd !== '1') {
              if (!this.registration.mnpSoacNo) {
                this.openAlert(
                        title,
                        '번호 이동 정산번호를 입력하세요.',
                        this.$refs.ref_mnpSoacNo
                )
                return false
              }
            }
          }else{
            this.registration.mnpSoacTrgtCd ="0"
            this.registration.mnpSoacNo = "0000"
          }
        }

        return true
      },

      /**
       * Function    : deviceSectionValidation
       * Description : 단말기 선택 validation
       **/
      deviceSectionValidation() {
        let regExp
        let title = '온라인 가입신청 안내'

        if (!this.registration.dvicMdlCd) {
          this.openAlert(title, '단말기를 선택하세요.', this.$refs.phoneModelCd)
          return false
        }
        // if (!this.registration.dvicColrCd) {
        //   this.openAlert(
        //     title,
        //     '단말기 색상을 선택하세요.',
        //     this.$refs.phoneColor
        //   )
        //   return false
        // }
        
        if (!this.registration.chgHopTlno) {
          if ('new' === this.openMarketInfo.registrationTypeCode)
            this.openAlert(
                    title,
                    '희망번호를 입력하세요.',
                    this.$refs.ref_hopeNum
            )
          if (
                  'chg' === this.openMarketInfo.registrationTypeCode ||
                  'renew' === this.openMarketInfo.registrationTypeCode
          ) {
            if (this.is_payStyleData) {
              this.openAlert(
                      title,
                      '휴대폰번호를 입력하세요.',
                      this.$refs.ref_hopeFullNum
              )
            } else {
              this.openAlert(
                      title,
                      '휴대폰번호를 입력하세요.',
                      this.$refs.ref_hopeFullNumNotPay
              )
            }
          }
          return false
        }
        regExp = /^[0-9]{4}$/
        if ('new' === this.openMarketInfo.registrationTypeCode) {
          if (!regExp.test(this.registration.chgHopTlno)) {
            this.openAlert(
                    title,
                    '희망번호는 4자리 이상 숫자를 입력해주세요.',
                    this.$refs.ref_hopeNum
            )
            return false
          }
        }
        regExp = /^[0-9]{10,11}$/
        if (
                'chg' === this.openMarketInfo.registrationTypeCode ||
                'renew' === this.openMarketInfo.registrationTypeCode
        ) {
          if (!regExp.test(this.registration.chgHopTlno)) {
            if (this.is_payStyleData) {
              this.openAlert(
                      title,
                      '휴대폰번호는 10자리 이상 숫자를 입력해주세요.',
                      this.$refs.ref_hopeFullNum
              )
            } else {
              this.openAlert(
                      title,
                      '휴대폰번호는 10자리 이상 숫자를 입력해주세요.',
                      this.$refs.ref_hopeFullNumNotPay
              )
            }
            return false
          }
        }
        //[ST] [오픈마켓유심가입] 2025.12.18 전승미
        if (this.openMarketInfo.shndHphnYn === 'Y' && this.openMarketInfo.usimEntrAppfYn !== 'Y' ) {
        //[ED] [오픈마켓유심가입] 2025.12.18 전승미
          if (!this.registration.trmSrno) {
            this.openAlert(
                    title,
                    '단말기 일련번호를 입력해주세요.',
                    this.$refs.ref_serialNum
            )
            return false
          }
        }
        //[ST] [오픈마켓유심가입] 2025.12.18 전승미
        if (this.openMarketInfo.usimEntrAppfYn === 'Y') {
          this.registration.trmSrno = "0000" ; // 유심가입신청서이면 단말일련번호 0000
          //console.log("오픈마켓유심가입 step2 Part2 deviceSectionValidation this.registration.trmSrno :", this.registration.trmSrno)
          //console.log("오픈마켓유심가입 step2 Part2 deviceSectionValidation this.registration.shpnEntrRqstYn :", this.registration.shpnEntrRqstYn)
          //console.log("오픈마켓유심가입 step2 Part2 deviceSectionValidation this.registration.trmStusDivsCd :", this.registration.trmStusDivsCd)
        }       
        //[ED] [오픈마켓유심가입] 2025.12.18 전승미

        if (this.openMarketInfo.crgrSaleYn === 'Y') {
          if (!this.registration.crgrBuyYn) {
            this.openAlert(
                    title,
                    '충전기 구매여부를 선택하세요.',
                    this.$refs.ref_crgrBuyYn
            )
            return false
          }
        }
       
       /* 
       if(this.display.isEsimDevice){

          if(this.registration.mobileRegistrationCaptureDetail.usimRqstYn === '') {
            this.openAlert(
              title,
              'USIM 사용여부를 선택하세요',
              this.$refs.ref_usimRqstYn
            )
            return false
          }
          if(this.registration.mobileRegistrationCaptureDetail.esimTrmYn === '') {
            this.openAlert(
              title,
              'eSIM 사용여부를 선택하세요',
              this.$refs.ref_usimRqstYn
            )
            return false
          }

          if(this.registration.mobileRegistrationCaptureDetail.usimRqstYn !== 'Y' && this.registration.mobileRegistrationCaptureDetail.esimTrmYn !== 'Y') {
             if('chg' !== this.openMarketInfo.registrationTypeCode && 'renew' !== this.openMarketInfo.registrationTypeCode){
                this.openAlert(
                  title,
                  'USIM/eSIM 중 한가지는 반드시 선택하셔야 합니다.',
                  this.$refs.ref_usimRqstYn
                )
                return false
             }
          }
        }else{
            if(this.registration.mobileRegistrationCaptureDetail.usimRqstYn === '' ) {
              this.openAlert(
                title,
                'USIM 사용여부를 선택하세요',
                this.$refs.ref_usimRqstYn
              )
              return false
            }

            if(!this.display.isEsimDevice){
              if(  
                    this.registration.mobileRegistrationCaptureDetail.usimRqstYn === 'N' 
                    && (this.openMarketInfo.registrationTypeCode === 'new' || this.openMarketInfo.registrationTypeCode === 'move')  
                ){
                document.all.usimUseYn[0].checked = true
                this.openAlert(
                  'SIM 신청 안내',
                  '[신규/번호이동]은 USIM 신청을 하셔야 합니다.',
                  this.$refs.ref_usimRqstYn
                )
              }
            }
        }  
        */
        
        //[ST] USIM 선택 
        let usimCheck = false
        let usimRadio = document.all.usimUseYn
        
        if(usimRadio.length > 0){
          for(let i=0;i<usimRadio.length;i++){
            if(usimRadio[i].checked === true ){
                usimCheck = true
            }
          }
        }else{
            if(usimRadio.checked === true ){
                usimCheck = true
            }
        }

        if(!usimCheck){
           this.openAlert(
                          title,
                          'SIM 사용여부를 선택하세요',
                          this.$refs.ref_usimRqstYn
           )
           return false
        }
        //[ED] USIM 선택 

        if (this.display.isIPhoneDevice) {
          if (this.registration.iphnUseAgrYn !== 'Y') {
            this.openAlert(
                    title,
                    'iPhone 이용고객 동의여부를 선택하세요.',
                    this.$refs.ref_iphoneAgreement
            )
            return false
          }
        }

        /*[ST]MNP 전환지원금 고객확인여부 (2024-03-19)*/
        // [단통법폐지Prj] Start 단통법 폐지관련 단통법 오픈 전까지만 전환지원금 내역 보이도록 함. 오픈 후에는 사용 안함. 2025.06.04 miyoung34
        if ('move' === this.openMarketInfo.registrationTypeCode &&  !this.chkAgreeMNP 
            && this.$store.state.openMarketInfo.lrpsDiscOpenYn == 'N' ) {
        // [단통법폐지Prj] End 단통법 폐지관련 단통법 오픈 전까지만 전환지원금 내역 보이도록 함. 오픈 후에는 사용 안함. 2025.06.04 miyoung34
          this.openAlert(
                  title,
                  '전환지원금 지급에 대한 고객 확인 여부를 선택하세요.',
                  this.$refs.ref_agreeMnp
          )
          return false
        }
        /*[ED]MNP 전환지원금 고객확인여부 (2024-03-19)*/
        

        if (this.display.is5GDevice) {
          if (!this.chkAgree5G) {
            this.openAlert(
                    title,
                    '5G 개통고객 동의여부를 선택하세요.',
                    this.$refs.ref_agree5G
            )
            return false
          }

          if (!this.addr.ctdoClssNm) {
            this.openAlert(
                    title,
                    '주 생활지역에서의 시도를 선택해주세요',
                    this.$refs.ref_ctdoClssNm
            )
            return false
          }
          if (!this.addr.ccwNm) {
            this.openAlert(
                    title,
                    '주 생활지역에서의 구시군을 선택해주세요',
                    this.$refs.ref_ccwNm
            )
            return false
          }
          if (!this.addr.townNm) {
            this.openAlert(
                    title,
                    '주 생활지역에서의 읍면동을 선택해주세요',
                    this.$refs.ref_townNm
            )
            return false
          }

          if (!this.chkAgree5GCoverage) {
            this.openAlert(
                    title,
                    '5G 서비스 및 주 생활지역에서의 가용지역에 관하여 확인이 필요합니다.',
                    this.$refs.ref_agree5G_coverage
            )
            return false
          }
          /* [ST][CSR:C20211110_82139_4482139] 신규부가서비스(디즈니)반영요청건 2021.11.15 박지숙 */
          if (!this.dsnySppsAgrYn && this.dsnyRqstSppsCd != '' && this.onetDsnySppsUseYn === 'Y') {
            this.openAlert(
                    title,
                    '디즈니+ 동의여부를 확인해주세요.',
                    this.$refs.ref_disneyConfirm
            )
            return false
          }
          /* [ED]][CSR:C20211110_82139_4482139] 신규부가서비스(디즈니)반영요청건 2021.11.15 박지숙 */

        }

        if('chg' === this.openMarketInfo.registrationTypeCode || 'renew' === this.openMarketInfo.registrationTypeCode) {
          if(!this.registration.ppCd) {
            this.openAlert(
                    title,
                    '요금제를 선택해주세요.',
                    this.$refs.payStyleSelect
            )
            return false
          }
        }

        

        return true
      },

      /**
       * Function    : deviceSectionValidationM2M
       * Description : 단말기 선택 validation M2M
       **/
      //[ST] RITM2876892 M2M 요금약정기간 추가 건
      deviceSectionValidationM2M() {
                
        let regExp
        let title = '온라인 가입신청 안내'

        if (!this.registration.dvicMdlCd) {
          this.openAlert(title, '단말기를 선택하세요.', this.$refs.phoneModelCd)
          return false
        }
                
        //[ST] USIM 선택 
        let usimCheck = false
        let usimRadio = document.all.usimUseYn

        if(usimRadio.length > 0){
          for(let i=0;i<usimRadio.length;i++){
            if(usimRadio[i].checked === true ){
                usimCheck = true
            }
          }
        }else{
            if(usimRadio.checked === true ){
                usimCheck = true
            }
        }
        


        if(!usimCheck){
           this.openAlert(
                          title,
                          'SIM 사용여부를 선택하세요',
                          this.$refs.ref_usimRqstYn
           )
           return false
        }
        //[ED] USIM 선택 

        

        if('chg' === this.openMarketInfo.registrationTypeCode || 'renew' === this.openMarketInfo.registrationTypeCode) {
          if(!this.registration.ppCd) {
            this.openAlert(
                    title,
                    '요금제를 선택해주세요.',
                    this.$refs.payStyleSelect
            )
            return false
          }
        }

        

        return true
      },      
      //[ED] RITM2876892 M2M 요금약정기간 추가 건

      /**
       * Function    : feePlanSectionValidation
       * Description : 신청내역(요금제)
       **/
      feePlanSectionValidation() {
        let regExp
        let title = '온라인 가입신청 안내'
        if (
                this.openMarketInfo.registrationTypeCode === 'new' ||
                this.openMarketInfo.registrationTypeCode === 'move'
        ) {
          if (!this.registration.ppCd) {
            this.openAlert(
                    title,
                    '대리점 추천 요금제를 선택하세요.',
                    this.$refs.payStyleSelect
            )
            return false
          }
        }
        return true
      },

      /**
       * Function    : routerAgreeSectionValidation
       * Description : 의무약정 validation
       **/
      routerAgreeSectionValidation() {
        let regExp
        let title = '온라인 가입신청 안내'

        if (this.part2.formM2MYn === 'Y' && this.display.agreedAgreeYn) {
          if (
                  this.openMarketInfo.rotrRqstCd === 'Y' &&
                  this.routerDutyData.length > 0
          ) {
            if (!this.registration.rotrAgmtMmct) {
              this.openAlert(
                      title,
                      '라우터 약정기간을 선택하세요.',
                      this.$refs.discMonth
              )
              return false
            }
            if (this.registration.dutyAgmtAgrYn !== 'Y') {
              this.openAlert(
                      title,
                      '라우터 약정 동의여부를 확인해주세요.',
                      this.$refs.ref_agreementAgree
              )
              return false
            }
          }
          if (
                  this.openMarketInfo.rotrRqstCd != 'Y' &&
                  this.dutyData.length > 0
          ) {

            if (!this.registration.agmtTermMmct) {
              this.openAlert(
                      title,
                      '단말약정기간을 선택하세요.',
                      this.$refs.discMonth
              )
              return false
            }

            if (this.registration.dutyAgmtAgrYn !== 'Y' && this.registration.agmtTermMmct !=='0') {
              this.openAlert(
                      title,
                      '단말약정 동의여부를 확인해주세요.',
                      this.$refs.ref_agreementAgree
              )
              return false
            }
          }
        }

        if (this.part2.formM2MYn === 'N' && this.dutyAgmList.length > 0) {
          if (!this.registration.agmtTermMmct) {
            this.openAlert(title, '약정기간을 선택하세요.', this.$refs.discMonth)
            return false
          }
          if (this.registration.dutyAgmtAgrYn !== 'Y') {
            this.openAlert(
                    title,
                    '약정 동의여부를 확인해주세요.',
                    this.$refs.ref_agreementAgree
            )
            return false
          }
        }

        //[ST] RITM2876892 M2M 요금약정기간 추가 건
        if(this.part2.formM2MYn === 'Y' 
            && (this.registration.mobileRegistrationCaptureDetail.m2mPpAgdcMmct == '24' || this.registration.mobileRegistrationCaptureDetail.m2mPpAgdcMmct == '36')
            && this.dsntData.length > 0
            &&  this.openMarketInfo.registrationTypeCode === 'new'){
          
          if (this.m2mDcntNm === '') {
            this.openAlert(
                    title,
                    '조건에 해당하는 M2M 요금약정 정책이 없습니다. \n 요금제 및 요금약정기간을 다시 선택하세요.',
                    this.$refs.ref_m2mPpAgdcMmct
            )
            return false  
          }
                              
          if (this.registration.mobileRegistrationCaptureDetail.agdcRfunAgrYn !== 'Y') {
            this.openAlert(
                    title,
                    '요금약정 동의여부를 확인해주세요.',
                    this.$refs.ref_agreementAgreeM2mDcnt
            )
            return false
          }
        }else if( this.part2.formM2MYn === 'Y' 
                && this.registration.mobileRegistrationCaptureDetail.m2mPpAgdcMmct === ''
                &&  this.openMarketInfo.registrationTypeCode === 'new' && this.dsntData.length > 0){
          this.openAlert(
                    title,
                    '요금약정기간을 선택하세요.',
                    this.$refs.ref_m2mPpAgdcMmct
            )
            return false
        }
        //[ED] RITM2876892 M2M 요금약정기간 추가 건

        return true
      },

      /**
       * Function    : installmentSectionValidation
       * Description : 할부내역 validation
       **/
      installmentSectionValidation() {
        let regExp
        let title = '온라인 가입신청 안내'

        if (
                this.$store.state.ValidationView[
                        'installmentSectionPhonePayStyle'
                        ][3] &&
                !this.agreeContract
        ) {
          this.openAlert(
                  title,
                  '할부내역 필수 동의여부를 확인해주세요.',
                  this.$refs.ref_agreeContract
          )
          return false
        }
        if (!this.hasItem) {
          this.openAlert(
                  title,
                  '선택하신 요금제는 모바일 출고 정보를 가져 오지 못하여 신청이 불가능 합니다!\n다른 요금제로 변경 바랍니다.'
          )
          return false
        }
        return true
      },

      /**
       * Function    : additionalServiceSectionValidation
       * Description : 부가서비스 validation
       **/
      additionalServiceSectionValidation() {
        let regExp
        let title = '온라인 가입신청 안내'
        if (!this.registration.lssInsrCnslAgrYn) {
          this.openAlert(
                  title,
                  '휴대폰 보험 유형을 선택해주세요.',
                  this.$refs.ref_lssInsrCnslAgrYn
          )
          return false
        }
        
        if (!this.lssInsrCnslAgrChk && this.registration.onetAplePncrDivsCd == '') {
          this.openAlert(
                  title,
                  '휴대폰 보험 동의여부를 확인해주세요.',
                  this.$refs.ref_insuaranceConfirm
          )
          return false
        }
        if (!this.changeInsrCnslAgrChk && this.registration.onetAplePncrDivsCd != '') {
          this.openAlert(
                  title,
                  '맘대로 폰교체 보험 동의여부를 확인해주세요.',
                  this.$refs.ref_changeInsrConfirm
          )
          return false
        }
        if (this.registration.custKdCd === 'A') {
          this.registration.adltCntsIsolRqstYn='Y'//  무조건 선택
          /* if (!this.registration.adltCntsIsolRqstYn) {
          this.openAlert(
            title,
            '청소년 음란물정보 차단 필수동의여부를 확인해주세요.',
            this.$refs.ref_adultBlocking
          )
          return false
        }*/
          if (!this.registration.nwIsolYn) {
            this.openAlert(
                    title,
                    '네트워크차단(무료) 동의여부를 확인해주세요.',
                    this.$refs.ref_networkBlocking
            )
            return false
          }
          if (this.registration.smatAppUseYn==='') {
            this.openAlert(
                    title,
                    '자녀폰 지킴이를 선택해주세요.',
                    this.$refs.ref_appBlocking_op1
            )
            return false
          }
        }
        if (this.registration.dcntKdCd === 'DT01' && this.onsaAplyPlnNm === 'Six Plan') {
          if (!this.sixPlanAgreeChk) {
            this.openAlert(
                    title,
                    '식스플랜 약관 동의여부를 확인해주세요.',
                    this.$refs.ref_sixPlanAgreeChk
            )
            return false
          }
        }
        /* [ST][CSR:C20211110_82139_4482139] 신규부가서비스(디즈니)반영요청건 2021.11.15 박지숙 */
        if (!this.dsnySppsAgrYn && this.dsnyRqstSppsCd != '' && this.onetDsnySppsUseYn === 'Y') {
          this.openAlert(
                  title,
                  '디즈니+ 동의여부를 확인해주세요.',
                  this.$refs.ref_disneyConfirm
          )
          return false
        }
        /* [ED]][CSR:C20211110_82139_4482139] 신규부가서비스(디즈니)반영요청건 2021.11.15 박지숙 */
        return true
      },

      /**
       * Function    : secureOptionSectionValidation
       * Description : 보안옵션 validation
       **/
      secureOptionSectionValidation() {
        let regExp
        let title = '온라인 가입신청 안내'
        if(this.part2.formM2MYn === 'N' && this.openMarketInfo.rotrRqstCd === 'N') {
          if (!this.passwordAgreeChk) {
            this.openAlert(
                    title,
                    'U+스토어 비밀번호설정안내 동의여부를 확인해주세요.',
                    this.$refs.ref_passwordAgreeChk
            )
            return false
          }
        }
        if (this.registration.prmsLinePcnt === '') {
          this.openAlert(
                  title,
                  '보안등급설정를 선택해주세요.',
                  this.$refs.ref_prmsLinePcnt
          )
          return false
        }
        if (this.registration.agntEntrRstnYn === '') {
          this.openAlert(
                  title,
                  '대리인 가입제한여부를 선택해주세요.',
                  this.$refs.ref_agntEntrRstnYn
          )
          return false
        }
        return true
      },

      /**
       * Function    : shipToAddrSectionValidation
       * Description : 배송지 추가요청 validation
       **/
      shipToAddrSectionValidation() {
        let regExp
        let title = '온라인 가입신청 안내'
        if (!this.registration.dlvRcipNm) {
          this.openAlert(
                  title,
                  '수취인명을 입력하세요.',
                  this.$refs.ref_dlvRcipNm
          )
          return false
        }
        if (
                !this.registration.dlplZpcd ||
                !this.registration.dlplBadr ||
                !this.registration.dlplDadr
        ) {
          this.openAlert(
                  title,
                  '주소를 다시 입력하세요.',
                  this.$refs.ref_zipcodeAddressPop
          )
          return false
        }
        if (!this.registration.dlplTlno) {
          this.openAlert(
                  title,
                  '수취인 연락처를 입력하세요.',
                  this.$refs.ref_dlplTlno
          )
          return false
        }
        regExp = /^[0-9]{10,11}$/
        if (!regExp.test(this.registration.dlplTlno)) {
          this.openAlert(
                  title,
                  '수취인 연락처는 10자리 이상 숫자를 입력해주세요.',
                  this.$refs.ref_dlplTlno
          )
          return false
        }
        return true
      },

      /**
       * Function    : validCondition
       * Description : Part2 필수값 validation
       **/
      validCondition() {
        let title = '온라인 가입신청 안내'
        if (!this.transferCompanySectionValidation()) return false
        
        //[ST] RITM2876892 M2M 요금약정기간 추가 건
        if(this.part2.formM2MYn != 'Y'){
          if (!this.deviceSectionValidation()) return false
        }else{
          if (!this.deviceSectionValidationM2M()) return false
        }
        //[ED] RITM2876892 M2M 요금약정기간 추가 건

        if (!this.feePlanSectionValidation()) return false
        if (!this.routerAgreeSectionValidation()) return false
        
        //[ST] RITM2876892 M2M 요금약정기간 추가 건
        if(this.part2.formM2MYn != 'Y')
          if (!this.additionalServiceSectionValidation()) return false
        //[ED] RITM2876892 M2M 요금약정기간 추가 건

        //[ST] RITM2876892 M2M 요금약정기간 추가 건
        if(this.part2.formM2MYn != 'Y')
          if (!this.secureOptionSectionValidation()) return false
        //[ED] RITM2876892 M2M 요금약정기간 추가 건          
        
        //[ST] [오픈마켓유심가입] 2025.12.18 전승미
        if (this.openMarketInfo.isttYn === 'Y' && this.openMarketInfo.shndHphnYn !== 'Y' && this.openMarketInfo.usimEntrAppfYn !== 'Y') {
        //[ED] [오픈마켓유심가입] 2025.12.18 전승미
          if (!this.installmentSectionValidation()) return false
        }
        
        if (!this.shipToAddrSectionValidation()) return false
        return true
      },

      /**
       * Function    : openAlert
       * Description : 기본 alert 호출 함수
       **/
      openAlert(title, message, ref) {
        this.$modal.show('dialog', {
          text: message,
          title: title,
          buttons: [
            {
              title: '확인',
              class: 'primary-button',
              handler: () => {
                if (ref) {
                  ref.focus()
                }
                this.$modal.hide('dialog')
              }
            }
          ]
        })
      },

      /**
       * Function    : changeDevice
       * Description : 단말모델 변경 이벤트
       **/
      changeDevice() {
        this.resetRegistrationData()
        for (let index in this.deviceList) {
          if (this.deviceList[index].trmMdlCd === this.registration.dvicMdlCd) {
            if(!this.deviceList[index].trmPtnmNm || this.deviceList[index].trmPtnmNm === "null") {
              this.registration.dvicMdlNm = this.deviceList[index].trmMdlNm
            } else {
              this.registration.dvicMdlNm = this.deviceList[index].trmPtnmNm
            }
            if(this.deviceList[index].esimTrmYn==='Y'){
             this.display.isEsimDevice = true
            }else{
              this.display.isEsimDevice = false
              /*
              if( this.openMarketInfo.registrationTypeCode === 'new' || this.openMarketInfo.registrationTypeCode === 'move'){
                document.all.usimUseYn[0].checked = true
              }
              */
            }

            //[단통법폐지Prj] Start 단통법 폐지관련 해당 항목 삭제 됨. 2025.06.04 miyoung34
            // 사전예약 단말이면 전환지원금 내용 숨김
            let presaleTrmMdlCdTxt = this.openMarketInfo.presaleTrmMdlCdTxt
            if ( presaleTrmMdlCdTxt && presaleTrmMdlCdTxt.indexOf(this.registration.dvicMdlCd) > -1) {
              this.$store.state.openMarketInfo.presaleTrmMdlCdYn = "Y";
            } else {
              this.$store.state.openMarketInfo.presaleTrmMdlCdYn= "N";
            }
            //[단통법폐지Prj] End 단통법 폐지관련 해당 항목 삭제 됨. 2025.06.04 miyoung34
            
            break
          }
        }
        if (this.registration.dvicMdlCd) {

          this.fn_setPhoneModel(this.$refs.phoneModelCd)

        }

      },

      /**
       * Function    : changeColor
       * Description : 단말기 색상변경 이벤트
       **/
      changeColor() {
        for (let index in this.colorList) {
          if (this.colorList[index].code === this.registration.dvicColrCd) {
            this.registration.hphnColrNm = this.colorList[index].name
            break
          }
        }
      },

      /**
       * Function    : resetRegistrationData
       * Description : 단말모델 초기화
       **/
      resetRegistrationData() {
        // deviceSection
        this.registration.dvicColrCd = ''
        this.registration.hphnColrNm = ''
        this.registration.trmSrno = ''
        this.registration.crgrBuyYn = ''
        this.registration.iphnUseAgrYn = ''
        this.isIphonePop = false
        this.display.isIPhoneDevice = false
        this.chkAgree5G = false
        this.chkAgree5GCoverage= false
        this.resetFeePlan()
      },

      /**
       * Function    : resetFeePlan
       * Description : 요금제 초기화
       **/
      resetFeePlan() {
        // feePlanSection
        this.registration.ppCd = ''
        this.registration.ppNm = ''
        this.phonePayStyleList = []
        this.sppsList = []
        this.rqstSppsList = []
        this.dataPayStyleList = []
        this.discList = []
        this.pricePlan = {}
        this.registration.dataPpCd = ''
        this.registration.dataPpNm = ''
        this.registration.trmSrno = ''
        this.onsaAplyPlnNm = ''
        this.ppDscr = ''
         /* [ST][CSR:C20211110_82139_4482139] 신규부가서비스(디즈니)반영요청건 2021.11.15 박지숙 */
        this.registration.mobileRegistrationCaptureDetail.onetDsnySppsAgrYn = ''
        this.dsnySppsAgrYn = false 
        /* [ED]][CSR:C20211110_82139_4482139] 신규부가서비스(디즈니)반영요청건 2021.11.15 박지숙 */
        this.$store.dispatch('SetDevcieSectionSelfPhonePayStyle', false)

        // installmentSection
        if(this.openMarketInfo.isttYn === "Y") {
          this.registration.isttTermMmct = '24'
          this.registration.dcntKdCd = 'DT01'
        } else {
          this.registration.isttTermMmct = ''
          this.registration.dcntKdCd = ''
        }
        this.sixPlanAgreeChk = false
        this.$store.dispatch('SetInstallmentSectionPhonePayStyle', [
          false,
          false,
          false,
          false
        ])
        this.$store.state.DynamicData['bandsPayTypeText'][0] = ''
        this.$store.state.DynamicData['bandsPayTypeText'][1] = ''
        this.reqItemDstrDiscountNull()

        // routerAgreeSectionView
        this.registration.rotrAgmtAmt = ''
        this.registration.rotrAgmtMmct = ''
        this.registration.dutyAgmtAgrYn = 'N'
        this.registration.agmtTermMmct = ''
        this.registration.dutyAgmtSuptAmt = ''
        this.registration.agmtTermMmct = ''

        // additionalServiceSection
        this.onsaAplyPlnNm = ''
      },

      /**
       * Function    : fn_setPhoneModel
       * Description : 단말 모델 선택
       **/
      fn_setPhoneModel(model) {
        if (this.registration.dvicMdlCd) {
          let ssn =
                  this.$store.state.step1.customer.ssn1 +
                  this.$store.state.step1.customer.ssn2.substr(0, 1)
          let dealCd = this.openMarketInfo.dealCd
          let entrRqstFomNo = this.openMarketInfo.formId
          let trmMdlCd = this.registration.dvicMdlCd
          getPayStyleInfo(ssn, dealCd, entrRqstFomNo, trmMdlCd).then(res => {
            let response = res.data
            this.phonePayStyleList =
                    response.phonePayStyleList === null
                            ? []
                            : response.phonePayStyleList
            this.sppsList = response.sppsList === null ? [] : response.sppsList
            this.rqstSppsList =
                    response.rqstSppsList === null ? [] : response.rqstSppsList
            this.dataPayStyleList =
                    response.dataPayStyleList === null ? [] : response.dataPayStyleList
            this.discList = response.discList === null ? [] : response.discList

            if (this.phonePayStyleList.length > 0) this.is_payStyleData = true
            else this.is_payStyleData = false

            if (
                    this.openMarketInfo.registrationTypeCode === 'new' ||
                    this.openMarketInfo.registrationTypeCode === 'move'
            ) {
              if (this.openMarketInfo.msBsType === 'MS') {
                let vPayStyleSelect = this.registration.ppCd
                this.chkOZPrice(
                        this.$refs.phoneModelCd,
                        this.registration.dvicMdlCd,
                        vPayStyleSelect,
                        '',
                        []
                )
              } else {
                let agentId = this.openMarketInfo.dealCd
                let formId = this.openMarketInfo.formId
                let svcCd = this.registration.ppCd

                this.retrieveDutyAgmtByModel(
                        svcCd,
                        this.registration.dvicMdlNm,
                        agentId,
                        formId,
                        model
                )
              }
            } else {
              // 의무약정 정책조회 ESB 호출
              let agentId = this.openMarketInfo.dealCd
              let formId = this.openMarketInfo.formId
              let svcCd = this.registration.ppCd
              this.retrieveDutyAgmtByModel(
                      svcCd,
                      this.registration.dvicMdlNm,
                      agentId,
                      formId,
                      model
              )
            }

            if (this.openMarketInfo.isttYn === 'Y') {
              let phoneModelCd = this.registration.dvicMdlCd
              let phonePayStyleCd = this.registration.ppCd

              let isChgAppl = false

              if (
                      this.openMarketInfo.registrationTypeCode === 'chg' ||
                      this.openMarketInfo.registrationTypeCode === 'renew'
              ) {
                isChgAppl = true
              }

              // 요금제가 입력이 안되어 있고 요금제 코드가 없다면
              if (isChgAppl && !this.is_payStyleData && !phonePayStyleCd) {
                if (!this.isCellular(this.registration.chgHopTlno)) {
                  this.openAlert(
                          '온라인 가입신청 안내',
                          '휴대폰 번호 입력 후 본인 요금제 조회 버튼 선택 부탁드립니다.'
                  )
                } else {
                  this.openAlert(
                          '온라인 가입신청 안내',
                          '요금제 조회 버튼 선택 부탁드립니다.'
                  )
                }
              } else if (isChgAppl && !this.is_payStyleData && phonePayStyleCd) {
                this.openAlert(
                        '온라인 가입신청 안내',
                        '요금제 조회 버튼 선택 부탁드립니다.'
                )
              }
            }
            //아이폰 여부 조회
            this.check5GOrIPhone()
            if(this.$store.state.openMarketInfo.onetTxinsrUseYn == 'Y'){
               this.getInsLmtList()// 맘대로 폰리스트조회
            }
             //5G 커버리지조회
            if(this.display.is5GDevice){
              this.getCtdoClssNmList()
              this.selectInit()
            }
          })
        } else {
          this.registration.ppNm = ''
        }
      },

      /**
       * Function    : check5GOrIPhone
       * Description : 아이폰, 5G 여부
       **/
      check5GOrIPhone() {
        this.selectedDevice = this.deviceList.filter(item => {
          return item.trmMdlCd === this.registration.dvicMdlCd
        })
        //apple : manfCd === '0000524'
        // 아이폰 여부
        if (this.selectedDevice[0].manfCd === '0000524') {
          this.display.isIPhoneDevice = true
        } else {
          this.display.isIPhoneDevice = false
        }

        // 5G 여부
        if (this.selectedDevice[0].g5TrmYn === 'Y') {
          this.display.is5GDevice = true
        } else {
          this.display.is5GDevice = false
        }
      },

      /**
       * Function    : clickSelfPhonePay
       * Description : 기존 본인 요금제 조회 클릭
       **/
      clickSelfPhonePay() {
        if (!this.registration.chgHopTlno) {
          this.openAlert(
                  '온라인 가입신청 안내',
                  '휴대폰 번호를 입력하세요.',
                  this.$refs.ref_hopeFullNum
          )
          this.onsaPrevPpUseYn = true  
          this.$store.dispatch('SetDevcieSectionSelfPhonePayStyle', false)
          return
        }
        if (!this.registration.dvicMdlCd) {
          this.openAlert(
                  '온라인 가입신청 안내',
                  '단말기를 선택하세요.',
                  this.$refs.phoneModelCd
          )
          this.onsaPrevPpUseYn = true
          this.$store.dispatch('SetDevcieSectionSelfPhonePayStyle', false)
          return
        }

        if (this.onsaPrevPpUseYn) { // 체크해제
          this.registration.ppNm = ''
          this.registration.ppCd = ''
          this.registration.mobileRegistrationCaptureDetail.onsaPrevPpUseYn = ''
          this.registration.mobileRegistrationCaptureDetail.onsaPrevPpNm = ''
          this.registration.mobileRegistrationCaptureDetail.onsaPrevPpCd = ''
          this.$store.dispatch('SetDevcieSectionSelfPhonePayStyle', false)
          this.reqItemDstrDiscountNull()
        } else { // 체크
          getSelfPhonePay(this.registration.chgHopTlno, this.registration.appfNo).then(res => {
          if (res.data.dsRsltInfo.rsltCd === 'SUCCESS') {
            // this.$nextTick(()=>{
            //   })
            this.registration.ppNm = res.data.dsDsPhonePayResRes[0].svcNm
            this.registration.ppCd = res.data.dsDsPhonePayResRes[0].svcCd
            this.registration.mobileRegistrationCaptureDetail.onsaPrevPpUseYn = 'Y'
            this.registration.mobileRegistrationCaptureDetail.onsaPrevPpNm = this.registration.ppNm
            this.registration.mobileRegistrationCaptureDetail.onsaPrevPpCd = this.registration.ppCd
            this.$store.dispatch('SetDevcieSectionSelfPhonePayStyle', true)
            this.fn_paySelect()
          } else if (res.data.dsRsltInfo.rsltCd === 'FAIL') {
            this.onsaPrevPpUseYn = false 
            this.$store.dispatch('SetDevcieSectionSelfPhonePayStyle', false)
            this.openAlert('온라인 가입신청 안내', res.data.dsRsltInfo.rsltMsg)
            if(this.registration.ppNm === ''){
              this.reqItemDstrDiscountNull()
            }
          } else {
            this.onsaPrevPpUseYn = false
            this.$store.dispatch('SetDevcieSectionSelfPhonePayStyle', false)
            this.openAlert(
                    '온라인 가입신청 안내',
                    '현재 고객의 정보가 없습니다. 휴대폰 번호 재확인후 요금조회 버튼을 클릭하세요.'
            )
            if(this.registration.ppNm === ''){
              this.reqItemDstrDiscountNull()
            }
          }
        })
        }
      },

      /**
       * Function    : clickIphnUseAgrYn
       * Description : 아이폰 동의 여부 팝업
       **/
      clickIphnUseAgrYn() {
        if (!this.isIphonePop) {
          this.$store.state.isConfirm = false
          this.$modal.show('iPhoneAgree')
        } else {
          this.registration.iphnUseAgrYn = 'N'
        }
      },

      /**
       * Function    : clickOpenTransitionPopUp
       * Description : 전환지원금 지급 관련 안내 팝업
       **/
      clickOpenTransitionPopUp() {
        if(this.chkAgreeMNP) {
          return this.isOpenTransitionPopUp = false;
        }
        this.isOpenTransitionPopUp = true;
      },

      /**
       * Function    : popupIphoneClose
       * Description : 아이폰 동의 여부 닫힐 때 콜백함수
       **/
      popupIphoneClose(result) {
        if (result.id === 'ok') {
          this.registration.iphnUseAgrYn = result.ok
          this.isIphonePop = true
        } else {
          this.registration.iphnUseAgrYn = 'N'
          this.isIphonePop = false
        }
      },

      /**
       * Function    : fn_paySelect
       * Description : 화면 로딩시 요금제 확인 (무약정 데이터2배 체크)
       **/
      fn_paySelect() {
        let phoneModelCd = this.registration.ppCd
        if (phoneModelCd) {
          if (this.is_payStyleData) {
            this.chgCallCharge()
          }
          if (this.openMarketInfo.isttYn === 'Y') {
            getComCodeList('G109').then(res => {
              let nonDscntList = res
              for (let i = 0; i < nonDscntList.length; i++) {
                if (nonDscntList[i].cmmCdv === phoneModelCd) {
                  this.nonDscntTp = 'Y'
                  break
                }
              }
              if (this.nonDscntTp === 'Y') {
                this.display.useDscnt = false
                this.display.nonDscnt = true
                this.registration.isttTermMmct = '0'
                this.registration.dcntKdCd = ''
                //[ST] [오픈마켓유심가입] 2025.12.18 전승미
                if(this.openMarketInfo.shndHphnYn !== 'Y' && this.openMarketInfo.usimEntrAppfYn !== 'Y') {
                //[ED] [오픈마켓유심가입] 2025.12.18 전승미  
                  this.selectSubList('zero')
                }               
                this.$store.dispatch('SetInstallmentSectionPhonePayStyle', [
                  false,
                  false,
                  false,
                  false
                ])
              } else {
                let phonePayStyleCd = this.registration.ppCd
                this.display.useDscnt = true
                this.display.nonDscnt = false
                //C20180123_89160_3620987 : M2M 프로세스 구조개선 프로젝트 운영이관 : 조건 추가
                if (this.part2.formM2MYn === 'N') {
                  // this.phonePayType() //베이직/식스 플랜 타입조회
                  
                  this.registration.isttTermMmct = this.registration.isttTermMmct
                          ? this.registration.isttTermMmct
                          : '24'
                  this.registration.dcntKdCd = this.registration.dcntKdCd
                          ? this.registration.dcntKdCd
                          : 'DT01'
                  this.onsaAplyPlnNm = this.onsaAplyPlnNm
                          ? this.onsaAplyPlnNm
                          : 'Six Plan' 
                  //[ST] [오픈마켓유심가입] 2025.12.18 전승미             
                  if(this.openMarketInfo.shndHphnYn !== 'Y' && this.openMarketInfo.usimEntrAppfYn !== 'Y') {
                  //[ED] [오픈마켓유심가입] 2025.12.18 전승미
                    this.selectSubList() //단말기 유통구조개선법 ESB 호출
                  }
                  this.reqPhonePayType() //베이직/식스 플랜 타입조회
                }
              }
            })
          } else {
            this.registration.isttTermMmct = ''
            this.registration.dcntKdCd = ''
            this.phonePayType()// 요금제 상세 조회
          }
        } else {
          this.openAlert('온라인 가입신청 안내', '단말기를 선택하세요.')
        }
      },

      /**
       * Function    : chgCallCharge
       * Description : 통화요금제 선택변경(대리점기본값에서) 이벤트
       **/
      chgCallCharge() {
        let vCode = this.registration.ppCd
        let payStyleSelect = this.$refs.payStyleSelect
        let vName = this.registration.ppNm

        let vOpts = []
        for (let i = 0; i < this.discList.length; i++) {
          vOpts.push(this.discList[i].code)
        }

        this.chkOZPrice(
                payStyleSelect,
                this.registration.ppCd,
                vCode,
                vName,
                vOpts
        ) // <%-- OZ무료통화요금제 의무약정 체크 및 OZ무료통화요금제 신청불가 단말기 체크 --%>
      },

      /**
       * Function    : phonePayType
       * Description : 요금제 상세 조회
       **/
      phonePayType() {
        let oldPpCd = this.registration.ppCd
        let oldPpNm = this.registration.ppNm
        getPricePlan(this.registration.ppCd).then(res => {
          if (res.data !== null) {
            this.pricePlan = res.data
            this.onetDsnySppsUseYn = this.pricePlan.onetDsnySppsUseYn // 디즈니 부가서비스 사용여부 C20211110_82139_4482139
              if (this.openMarketInfo.isttYn === 'Y') {
                          this.ppDscr = this.pricePlan.ppDscr
                          this.ppDscr = this.ppDscr.split('\\n').join('\r\n')
                          this.ppDscr = this.ppDscr.split('\\t').join('\t')
                          //this.reqPhonePayType(res.data)
                          this.reqPhonePayType()
              }
          } else {
            this.openAlert('오류', 'System Error')
          }
        })
      },

      /**
       * Function    : reqPhonePayType
       * Description : 베이직/식스 플랜 타입조회
       **/
      reqPhonePayType() {
        if (this.registration.dcntKdCd !== null || this.registration.dcntKdCd !== '') {
          let bandsType = this.onsaAplyPlnNm

          //this.onsaAplyPlnNm =
          //        bandsType === 'DT00' ? 'Six Plan' : 'Basic' //베이직/식스 플랜 타입
          
          if (bandsType === 'Six Plan') {
            if (
                    this.openMarketInfo.isttYn === 'Y' 
            ) {
              this.$store.state.DynamicData['bandsPayTypeText'][0] = '식스플랜'
              this.$store.state.DynamicData['bandsPayTypeText'][1] = '식스플랜'
              this.registration.dcntKdCd = 'DT01'
            }

            // 식스플랜에 동의가 있을 시 보여 줌
            if (this.sixPlanAgreeChk) {
              this.$store.dispatch('SetInstallmentSectionPhonePayStyle', [
                true,
                false,
                true,
                true
              ])
            } else {
              this.$store.dispatch('SetInstallmentSectionPhonePayStyle', [
                true,
                true,
                false,
                true
              ])
            }

            //식스 플랜 동의 여부
            this.$store.dispatch('SetAdditionalServiceSectionPlanViewTr', true)

          } else if (bandsType === 'Basic') {
            if (
                    this.openMarketInfo.isttYn === 'Y' 
            ) {
              this.$store.state.DynamicData['bandsPayTypeText'][0] = '베이직 플랜'
              this.$store.state.DynamicData['bandsPayTypeText'][1] = '베이직 플랜'
            }

            this.$store.dispatch('SetInstallmentSectionPhonePayStyle', [
              false,
              true,
              false,
              true
            ])

            this.$store.dispatch('SetAdditionalServiceSectionPlanViewTr', false)
            this.sixPlanAgreeChk = false
          } else{
            // 선택적약정할인일때
            if (this.registration.dcntKdCd === 'DT02') {
              this.$store.state.DynamicData['bandsPayTypeText'][0] = ''
              this.$store.state.DynamicData['bandsPayTypeText'][1] = ''
              this.$store.dispatch('SetInstallmentSectionPhonePayStyle', [
                true,
                false,
                false,
                true
              ])
            }
          }
        }
      },

      /**
       * Function    : selectSubList
       * Description : 단말기 유통구조개선법 API 호출
       **/
      selectSubList(type) {
        if (type === 'zero') {
          let itemInput = {
            dealCd: this.openMarketInfo.dealCd, //대리점코드
            modelId: this.registration.dvicMdlCd //선택된 모델 코드
          }
          getItemDstrZero(itemInput).then(res => {
            let response = res.data
            if(response.resultCode === "FAIL") {
              this.hasItem = false
              this.openAlert("온라인 가입신청 안내", response.resultMsg)
              return
            }
            if (response !== null) {
              this.hasItem = true
              this.originItemDstrDiscount = _.cloneDeep(response)
              this.itemDstrDiscount = _.cloneDeep(response)
              this.reqItemDstrDiscount()
            } else {
              this.hasItem = false
              this.openAlert('오류', 'System Error')
              this.reqItemDstrDiscountNull()
            }
          })
        } else {
          //[단통법폐지Prj] Start 단통법 폐지관련 해당 항목 삭제 됨. 2025.06.04 miyoung34
          //::단통법 오픈 전후 함수 호출 분기
          if ('Y' !== this.$store.state.openMarketInfo.lrpsDiscOpenYn) {
            let itemInput = {
              applDscntTp: this.registration.dcntKdCd, //할인유형 코드
              applType: this.openMarketInfo.registrationTypeCode, //신청서 유형
              dealCd: this.openMarketInfo.dealCd, //대리점코드
              modelId: this.registration.dvicMdlCd, //선택된 모델 코드
              phonePayStyleCd: this.registration.ppCd, //선택된 요금제 코드
              addSuptAmtUseYn: this.openMarketInfo.addSuptAmtUseYn, //추가지원금 사용여부
              onsaAplyPlnNm: this.onsaAplyPlnNm, //onsaAplyPlnNm
              posCd:this.openMarketInfo.sbgnPosCd // pos코드
            }
            getItemDstrDiscountNew(itemInput).then(res => {
              let response = res.data
              if(response.resultCode === "FAIL") {
                this.hasItem = false
                this.openAlert("온라인 가입신청 안내", response.resultMsg)
                return
              }
              if (response !== null) {
                this.hasItem = true
                this.originItemDstrDiscount = _.cloneDeep(response)
                this.itemDstrDiscount = _.cloneDeep(response)
                this.reqItemDstrDiscount()
              } else {
                this.hasItem = false
                this.openAlert('오류', 'System Error')
                this.reqItemDstrDiscountNull()
              }
            })
        //단통법 오픈 이후면..
          } else {
            let itemInputNew = {
              applDscntTp: this.registration.dcntKdCd, //할인유형 코드
              applType: this.openMarketInfo.registrationTypeCode, //신청서 유형
              dealCd: this.openMarketInfo.dealCd, //대리점코드
              trmMdlCd: this.registration.dvicMdlCd, //선택된 모델 코드
              prodCd: this.registration.ppCd, //선택된 요금제 코드
              addSuptAmtUseYn: this.openMarketInfo.addSuptAmtUseYn, //추가지원금 사용여부
              onsaAplyPlnNm: this.onsaAplyPlnNm, //onsaAplyPlnNm
              crypAppfNo:this.registration.crypAppfNo, // 암호화신청서번호
              posCd:this.openMarketInfo.sbgnPosCd // pos코드
            }
          
            getItemDstrDiscountNDbwnSuptAmt(itemInputNew).then(res => {
              let response = res.data
              if(response.resultCode === "FAIL") {
                this.hasItem = false
                this.openAlert("온라인 가입신청 안내", response.resultMsg)
                return
              }
              if (response !== null) {
                this.hasItem = true
                this.originItemDstrDiscount = _.cloneDeep(response)
                this.itemDstrDiscount = _.cloneDeep(response)
                this.reqItemDstrDiscount()
              } else {
                this.hasItem = false
                this.openAlert('오류', 'System Error')
                this.reqItemDstrDiscountNull()
              }
            })
          }
        }
        //[단통법폐지Prj] End 단통법 폐지관련 해당 항목 삭제 됨. 2025.06.04 miyoung34
      },

      /**
       * Function    : reqItemDstrDiscountNull
       * Description : 단통법 초기화
       **/
      reqItemDstrDiscountNull() {
        if ('Y' === this.openMarketInfo.isttYn) {
          // 할부Y
          this.part2.dlvrPrc = '0' //출고가
          this.part2.suprtAmt24 = '0' //공시지원금
          this.part2.suprtAmt12 = '0' //공시지원금
          this.part2.addSuprtAmt24 = '0' //추가지원금
          this.part2.addSuprtAmt12 = '0' //추가지원금

          this.part2.mnpCvrtSuptAmt = '0' //전환지원금
          this.part2.addCvrtSuptAmt = '0' //추가전환지원금
          this.part2.allCvrtSufuAmt = '0' //총전환지원금 (전환지원금+추가전환지원금)

          this.part2.totalSuprtAmt = '0'

          this.totalSuprtAmt = 0

          this.itemDstrDiscount.dlvrPrc = 0
          this.itemDstrDiscount.phoneHalbuPrice = 0
          this.itemDstrDiscount.suprtAmt24 = 0
          this.itemDstrDiscount.suprtAmt12 = 0
          this.itemDstrDiscount.addSuprtAmt24 = 0
          this.itemDstrDiscount.addSuprtAmt12 = 0

          this.itemDstrDiscount.mnpCvrtSuptAmt = 0
          this.itemDstrDiscount.addCvrtSuptAmt = 0
          this.itemDstrDiscount.allCvrtSufuAmt = 0

          this.itemDstrDiscount.totalSuprtAmt = 0
          this.pricePerMonth = 0
          this.itemDstrDiscount.phoneFirstPayPrice = 0

          this.registration.tinsAmt = '0'
          this.registration.hphnInitStlmAmt = '0'

          this.registration.mobileRegistrationCaptureDetail.mnpCvrtSuptAmt = '0' //전환지원금
          this.registration.mobileRegistrationCaptureDetail.addCvrtSuptAmt = '0' //추가전환지원금

          //데이터 2배 무약정이 아닌 경우
          if ('Y' !== this.nonDscntTp) {
            this.pricePlan.ppCd = ''
            this.pricePlan.trmSufuPlnDivsCd = '' //  1,2
          }
        }
      },

      /**
       * Function    : isCellular
       * Description : 휴대폰 번호 검사
       **/
      isCellular(hpNo) {
        if (hpNo === '' || hpNo === null) {
          return false
        }
        let ddd = ['010', '011', '016', '017', '018', '019']

        let flag = false
        for (let i = 0; i < ddd.length; i++) {
          if (ddd[i] == hpNo.split(0, 3)) {
            flag = true
          }
        }

        if (!flag) {
          return false
        }

        return true
      },

      /**
       * Function    : reqItemDstrDiscount
       * Description : 단통법 계산
       **/
      reqItemDstrDiscount() {
        if (this.originItemDstrDiscount.dlvrPrc !== null) {
          this.registration.tinsAmt = this.originItemDstrDiscount.phoneHalbuPrice
          this.registration.hphnInitStlmAmt = this.originItemDstrDiscount.phoneFirstPayPrice

          let totalSuprt = 0
          let allCvrtSufuAmt = 0
          //총지원금
          if (this.registration.dcntKdCd === 'DT01'){
            totalSuprt = this.originItemDstrDiscount.totalSuprtAmt
            allCvrtSufuAmt =
                  parseInt(this.originItemDstrDiscount.mnpCvrtSuptAmt)+
                  parseInt(this.originItemDstrDiscount.addCvrtSuptAmt)
          }else {
            if (this.registration.isttTermMmct === '12') {
              totalSuprt =
                      parseInt(this.originItemDstrDiscount.suprtAmt12) +
                      parseInt(this.originItemDstrDiscount.addSuprtAmt12)
            }
            if (this.registration.isttTermMmct === '24') {
              allCvrtSufuAmt =
                      parseInt(this.originItemDstrDiscount.mnpCvrtSuptAmt)+
                      parseInt(this.originItemDstrDiscount.addCvrtSuptAmt)
              totalSuprt =
                      parseInt(this.originItemDstrDiscount.suprtAmt24) +
                      parseInt(this.originItemDstrDiscount.addSuprtAmt24)+
                      parseInt(allCvrtSufuAmt)
            }
          }

          this.itemDstrDiscount.dlvrPrc =  this.originItemDstrDiscount.dlvrPrc !== "" ? this.commaAmt(
                  this.originItemDstrDiscount.dlvrPrc
          ) : 0
          this.pricePerMonth = this.commaAmt(
                  (
                          (this.originItemDstrDiscount.phoneHalbuPrice /
                                  (this.registration.isttTermMmct * 100)) *
                          100
                  ).toFixed()
          )
          this.itemDstrDiscount.phoneHalbuPrice = this.commaAmt(
                  this.originItemDstrDiscount.phoneHalbuPrice
          )
          this.itemDstrDiscount.suprtAmt24 = this.commaAmt(
                  this.originItemDstrDiscount.suprtAmt24
          )
          this.itemDstrDiscount.suprtAmt12 = this.commaAmt(
                  this.originItemDstrDiscount.suprtAmt12
          )
          this.itemDstrDiscount.addSuprtAmt24 = this.commaAmt(
                  this.originItemDstrDiscount.addSuprtAmt24
          )
          this.itemDstrDiscount.addSuprtAmt12 = this.commaAmt(
                  this.originItemDstrDiscount.addSuprtAmt12
          )
          this.itemDstrDiscount.totalSuprtAmt = this.commaAmt(totalSuprt)
          this.itemDstrDiscount.phoneFirstPayPrice = this.commaAmt(
                  this.originItemDstrDiscount.phoneFirstPayPrice
          )

          //전환 지원금 제공 2024-06-26
          
          this.itemDstrDiscount.mnpCvrtSuptAmt = this.commaAmt(
                  this.originItemDstrDiscount.mnpCvrtSuptAmt
          )
          this.itemDstrDiscount.addCvrtSuptAmt = this.commaAmt(
                  this.originItemDstrDiscount.addCvrtSuptAmt
          )          
          this.itemDstrDiscount.allCvrtSufuAmt = this.commaAmt(
                  allCvrtSufuAmt
          )          

          this.registration.mobileRegistrationCaptureDetail.mnpCvrtSuptAmt = this.originItemDstrDiscount.mnpCvrtSuptAmt //전환지원금
          this.registration.mobileRegistrationCaptureDetail.addCvrtSuptAmt = this.originItemDstrDiscount.addCvrtSuptAmt //추가전환지원금
        }
      },

      /**
       * Function    : chkOZPrice
       * Description : OZ무료통화요금제 의무약정 체크 및 OZ무료통화요금제 신청불가 단말기 체크
       **/
      chkOZPrice(obj1, oCode, pCode, pName, pOpts) {
        let flag = false
        let phoneModelObj = this.$refs.phoneModelCd
        let phoneModelNm = this.registration.dvicMdlNm
        // let targetObj = _.find(this.deviceList, {trmMdlCd: this.registration.dvicMdlCd})
        // let phoneModelNm = targetObj.trmMdlNm

        if (
                this.chkOZPhonePayStyle(obj1, oCode, pCode) &&
                this.chkLTEPhonePayStyle(obj1, oCode, pCode)
        ) {
          if (obj1 && obj1.name == 'phoneModelCd') {
            let dataPriceCd = ''
            if (this.dataPayStyleList.length !== 0) {
              dataPriceCd = this.registration.dataPpCd
              for (let i = 0; i < this.dataPayStyleList.length; i++) {
                if (dataPriceCd === this.dataPayStyleList[i].code) {
                  let dataPriceNm = this.dataPayStyleList[i].name
                }
              }
            }
            flag = this.chkDataPrice(
                    phoneModelObj,
                    this.registration.dvicMdlCd,
                    this.registration.dvicMdlNm,
                    dataPriceCd
            )
          } else if (obj1 && obj1.name == 'payStyleSelect') {
            this.setCallCharge(pCode, pName, pOpts)
            flag = true
          }
          //의무약정정책조회ESB
          if (flag) {
            let agentId = this.openMarketInfo.dealCd
            let formId = this.openMarketInfo.formId
            this.retrieveDutyAgmtByModel(
                    pCode,
                    this.registration.dvicMdlCd,
                    agentId,
                    formId,
                    obj1
            )
          }
        }

        //OZ무료통화요금제 의무약정 신청불가
        //OZ무료통화 요금제는 의무약정과 중복하여 신청이 불가합니다.
        //5월1일 출시 신규요금제 추가
        //LPZ0000030 TOP 요금제
        //LPZ0000057 빅플러스 7000
        //LPZ0000058 빅플러스 14000
        //LPZ0000059 빅플러스 28000
        //LPZ0000063 OZ 빅플러스 7000
        //LPZ0000064 OZ 빅플러스 14000
        //LPZ0000065 OZ 빅플러스 28000
        let payStyleCd = this.registration.ppCd
        let agreedYn = this.openMarketInfo.rotrRqstCd
        if (agreedYn === 'N') {
          if (
                  payStyleCd == 'LPZ0000004' ||
                  payStyleCd == 'LPZ0000010' ||
                  payStyleCd == 'LPZ0000021' ||
                  payStyleCd == 'LPZ0000025' ||
                  payStyleCd == 'LPZ0000026' ||
                  payStyleCd == 'LPZ0000027' ||
                  payStyleCd == 'LPZ0000028' ||
                  payStyleCd == 'LPZ0000030' ||
                  payStyleCd == 'LPZ0000057' ||
                  payStyleCd == 'LPZ0000058' ||
                  payStyleCd == 'LPZ0000059' ||
                  payStyleCd == 'LPZ0000063' ||
                  payStyleCd == 'LPZ0000064' ||
                  payStyleCd == 'LPZ0000065'
          ) {
            //alert("OZ무료통화 요금제는 의무약정과 중복하여 신청이 불가합니다.");
            this.display.agreedAgreeYn = false
            if (this.$refs.discMonth) this.$refs.discMonth.disabled = true
            if (this.$refs.phonePrice) this.$refs.phonePrice.disabled = true
          } else {
            this.display.agreedAgreeYn = true
            if (this.$refs.discMonth) this.$refs.discMonth.disabled = false
            if (this.$refs.phonePrice) this.$refs.phonePrice.disabled = false
          }
        }
      },

      /**
       * Function    : chkOZPhonePayStyle
       * Description : OZ무료통화요금제 신청불가 단말기 체크
       **/
      chkOZPhonePayStyle(obj1, oCode, pCode) {
        //OZ무료통화요금제(LPZ0000004(OZ 6시간 무료), LPZ0000010(OZ 8시간 무료), LPZ0000021(OZ 13시간 무료))
        //PDA단말 및 USB단말 신청불가
        //2008.09.30 추가
        //OZPDA무료통화요금제(LPZ0000025(OZ PDA 6시간 무료))
        //SPH-M4650, SPH-M4655만 가능
        //2009.02.01 출시
        //OZ파워팩요금제(LPZ0000026(OZ 파워팩 6시간 무료), LPZ0000027(OZ 파워팩 8시간 무료), LPZ0000028(OZ 파워팩 13시간 무료))
        //PDA단말 및 USB단말 신청불가
        //OZ빅플러스요금제(LPZ0000063(OZ 빅플러스 7000), LPZ0000064(OZ 빅플러스 14000), LPZ0000065(OZ 빅플러스 28000))
        //PDA단말 및 USB단말 신청불가
        let chkResult = true
        let aModel = [
          'LM-680AU',
          'CP-x532',
          'KB-3300A',
          'LogPro-440',
          'EasyData',
          'ASM-1800G',
          'INC-100',
          'Pay-SpeedII',
          'Easy-Speed',
          'PWD-200',
          'KIS-M1000',
          'BM-150',
          'INC-100S',
          'AT570',
          'GPS-L2000',
          'Omnidatav2',
          'Check-1000v2',
          'EasyDatav2',
          'KIS-M1000v2',
          'BPC-901B',
          'EZ-SPEED',
          'SPH-M4650',
          'BIP-5400',
          'MCM-S603',
          'SIGN-SPEED',
          'BIP-1310',
          'IL-1000',
          'KSCC-T110C',
          'G3000',
          'AivPlus',
          'MT-6000',
          'SMT-7000',
          'TELEO',
          'MT-5000',
          'OCM-8000',
          'POZ',
          'Handy-plus',
          'MT-5100',
          'MC1439VB',
          'UBIQ2000',
          'SPH-M4655',
          'PC-EPHONE2',
          'UBIQ2500',
          'BCM-1850',
          'Mobipos',
          'IMP-3',
          'Mobi019B',
          'KB-3300',
          'EMV-1800',
          'Pay-Speed',
          'Mobi019C',
          'BPC-901A',
          'PC-EPHONE',
          'VMC-1000',
          'WTL-1800',
          'G5000A',
          'gTrack-1000',
          'A1650L',
          'Check-1000',
          'MC-3500B',
          'DTS-1800X',
          'MC-3500',
          'OPENWAY',
          'Omnidata',
          'Mobile-sign',
          'Mobile-signX',
          'ETP-100B',
          'NT-1800',
          'MP-6300P',
          'SEM-P300',
          'MC-6300P',
          'Any-Check',
          'TEST_MNP',
          'EMS2000',
          'CB-1880',
          'MTS-300',
          'DTG-1800',
          'SMT-7300',
          'LG-LC8000',
          'G5000',
          'MT5200',
          'K2-2000M',
          'BIP-2010',
          'BIP-2010A',
          'wing-2000M',
          'wing-2000B',
          'DTS-1800',
          'I-KIT',
          'MT-3000',
          'Zess-PLUS',
          'Aircheck-3000',
          'DTSS-1800',
          'SPH-M7350',
          'LG-LU2100'
        ]
        let phoneCd = this.registration.dvicMdlCd
        if (phoneCd != ' ') {
          if (
                  pCode == 'LPZ0000004' ||
                  pCode == 'LPZ0000010' ||
                  pCode == 'LPZ0000021' ||
                  pCode == 'LPZ0000026' ||
                  pCode == 'LPZ0000027' ||
                  pCode == 'LPZ0000028'
          ) {
            for (let i = 0; i < aModel.length; i++) {
              if (phoneCd == aModel[i]) {
                this.openAlert(
                        '온라인 가입신청 안내',
                        '해당단말기는 OZ무료통화요금제를 신청할 수 없습니다.'
                )
                this.selBoxReset(obj1, oCode)
                chkResult = false
                break
              }
            }
          } else if (pCode == 'LPZ0000025') {
            if (
                    phoneCd != 'SPH-M4650' &&
                    phoneCd != 'SPH-M4655' &&
                    phoneCd != 'SPH-M7350' &&
                    phoneCd != 'LG-LU2100'
            ) {
              this.openAlert(
                      '온라인 가입신청 안내',
                      '해당단말기는 OZ PDA 6시간 무료를 신청할 수 없습니다.'
              )
              this.selBoxReset(obj1, oCode)
              chkResult = false
            }
          } else if (
                  pCode == 'LPZ0000063' ||
                  pCode == 'LPZ0000064' ||
                  pCode == 'LPZ0000065'
          ) {
            for (let i = 0; i < aModel.length; i++) {
              if (phoneCd == aModel[i]) {
                this.openAlert(
                        '온라인 가입신청 안내',
                        '해당단말기는 OZ 빅플러스 요금제를 신청할 수 없습니다.'
                )
                this.selBoxReset(obj1, oCode)
                chkResult = false
                break
              }
            }
          }
        }

        return chkResult
      },

      /**
       * Function    : chkLTEPhonePayStyle
       * Description : LTE 요금제 신청불가 단말기 체크
       **/
      chkLTEPhonePayStyle(obj1, oCode, pCode) {
        //LPZ0001181(LTE 데이터 5GB), LPZ0001182(LTE 데이터 10GB)
        //LTE 모뎀(LG-LD611) 라우터(SHV-E100L) 만 신청가능
        let chkResult = true
        let phoneCd = this.registration.dvicMdlCd
        if (phoneCd != ' ') {
          if (pCode == 'LPZ0001181' || pCode == 'LPZ0001182') {
            if (phoneCd != 'LG-LD611' && phoneCd != 'SHV-E100L') {
              this.openAlert(
                      '온라인 가입신청 안내',
                      '해당단말기는 LTE 데이터 요금제를 신청할 수 없습니다.'
              )
              this.selBoxReset(obj1, oCode)
              chkResult = false
            }
          }
        }

        return chkResult
      },

      /**
       * Function    : chkDataPrice
       * Description : 데이터정액요금제에 대한 가입가능 단말기 체크
       **/
      chkDataPrice(obj1, oCode, oName, pCode) {
        let result = false

        let modelCd = this.registration.ppCd
        //데이터 정액요금종류 확인
        let priceType = this.dataPriceType(pCode)
        //데이터 정액요금제에 따른 가입가능 단말기 체크
        let chkResult = false
        switch (priceType) {
          case 0:
            if (this.chkPDAPhone(modelCd, '') || this.chkUSBModem(modelCd)) {
              this.openAlert(
                      '온라인 가입신청 안내',
                      '해당단말기는 OZ무한자유 요금제를 신청할 수 없습니다.'
              )
              chkResult = true
            }
            break
          case 1:
            if (
                    this.chkOZPhone(modelCd) ||
                    this.chkPDAPhone(modelCd, '') ||
                    this.chkUSBModem(modelCd)
            ) {
              this.openAlert(
                      '온라인 가입신청 안내',
                      '해당단말기는 안심정액 데이터 요금제를 신청할 수 없습니다.'
              )
              chkResult = true
            }
            break
          case 2:
            if (this.chkPDAPhone(modelCd, '') || this.chkUSBModem(modelCd)) {
              this.openAlert(
                      '온라인 가입신청 안내',
                      '해당단말기는 데이터 일 정액 요금제를 신청할 수 없습니다.'
              )
              chkResult = true
            }
            break
          case 3:
            if (!this.chkPDAPhone(modelCd, 'WEB')) {
              this.openAlert(
                      '온라인 가입신청 안내',
                      '해당단말기는 OZ무한자유 웹뷰어 요금제를 신청할 수 없습니다.'
              )
              chkResult = true
            }
            break
          case 4:
            if (!this.chkPDAPhone(modelCd, '')) {
              this.openAlert(
                      '온라인 가입신청 안내',
                      '해당단말기는 접속 라이트 PDA 요금제를 신청할 수 없습니다.'
              )
              chkResult = true
            }
            break
          case 5:
            if (!this.chkPDAPhone(modelCd, '')) {
              this.openAlert(
                      '온라인 가입신청 안내',
                      '해당단말기는 접속 일반 PDA 요금제를 신청할 수 없습니다.'
              )
              chkResult = true
            }
            break
          case 6:
            if (!this.chkPDAPhone(modelCd, '')) {
              this.openAlert(
                      '온라인 가입신청 안내',
                      '해당단말기는 접속 프리미엄 PDA 요금제를 신청할 수 없습니다.'
              )
              chkResult = true
            }
            break
          case 7:
            if (!this.chkPDAPhone(modelCd, 'WEB')) {
              this.openAlert(
                      '온라인 가입신청 안내',
                      '해당단말기는 OZ무한자유 팩 라이트 요금제를 신청할 수 없습니다.'
              )
              chkResult = true
            }
            break
          case 8:
            if (!this.chkPDAPhone(modelCd, 'WEB')) {
              this.openAlert(
                      '온라인 가입신청 안내',
                      '해당단말기는 OZ무한자유 팩 일반 요금제를 신청할 수 없습니다.'
              )
              chkResult = true
            }
            break
          case 9:
            if (!this.chkPDAPhone(modelCd, 'WEB')) {
              this.openAlert(
                      '온라인 가입신청 안내',
                      '해당단말기는 OZ무한자유 팩 프리미엄 요금제를 신청할 수 없습니다.'
              )
              chkResult = true
            }
            break
          case 10:
            if (!this.chkUSBModem(modelCd)) {
              this.openAlert(
                      '온라인 가입신청 안내',
                      '해당단말기는 USB모뎀 라이트 요금제를 신청할 수 없습니다.'
              )
              chkResult = true
            }
            break
          case 11:
            if (!this.chkUSBModem(modelCd)) {
              this.openAlert(
                      '온라인 가입신청 안내',
                      '해당단말기는 USB모뎀 일반 요금제를 신청할 수 없습니다.'
              )
              chkResult = true
            }
            break
          case 12:
            if (!this.chkUSBModem(modelCd)) {
              this.openAlert(
                      '온라인 가입신청 안내',
                      '해당단말기는 USB모뎀 프리미엄 요금제를 신청할 수 없습니다.'
              )
              chkResult = true
            }
            break
          case 13:
            if (this.chkPDAPhone(modelCd, '') || this.chkUSBModem(modelCd)) {
              this.openAlert(
                      '온라인 가입신청 안내',
                      '해당단말기는 OZ파워팩 요금제를 신청할 수 없습니다.'
              )
              chkResult = true
            }
            break
          case 14:
            if (this.chkPDAPhone(modelCd, '') || this.chkUSBModem(modelCd)) {
              this.openAlert(
                      '온라인 가입신청 안내',
                      '해당단말기는 OZ & Joy 요금제를 신청할 수 없습니다.'
              )
              chkResult = true
            }
            break
          case 15:
            if (this.chkPDAPhone(modelCd, '') || this.chkUSBModem(modelCd)) {
              this.openAlert(
                      '온라인 가입신청 안내',
                      '해당단말기는 OZ & Joy 요금제를 신청할 수 없습니다.'
              )
              chkResult = true
            }
            break
          case 16:
            if (this.chkPDAPhone(modelCd, '') || this.chkUSBModem(modelCd)) {
              this.openAlert(
                      '온라인 가입신청 안내',
                      '해당단말기는 OZ & Joy 요금제를 신청할 수 없습니다.'
              )
              chkResult = true
            }
            break
          case 17:
            if (this.chkPDAPhone(modelCd, '') || this.chkUSBModem(modelCd)) {
              this.openAlert(
                      '온라인 가입신청 안내',
                      '해당단말기는 OZ & Joy 요금제를 신청할 수 없습니다.'
              )
              chkResult = true
            }
            break
          case 18:
            if (this.chkPDAPhone(modelCd, '') || this.chkUSBModem(modelCd)) {
              this.openAlert(
                      '온라인 가입신청 안내',
                      '해당단말기는 OZ & Joy 요금제를 신청할 수 없습니다.'
              )
              chkResult = true
            }
            break
          case 19:
            if (this.chkPDAPhone(modelCd, '') || this.chkUSBModem(modelCd)) {
              this.openAlert(
                      '온라인 가입신청 안내',
                      '해당단말기는 OZ & Joy 요금제를 신청할 수 없습니다.'
              )
              chkResult = true
            }
            break
          case 20:
            if (!this.chkPDAPhone(modelCd, 'WEB')) {
              this.openAlert(
                      '온라인 가입신청 안내',
                      '해당단말기는 OZ무한자유 스마트폰 요금제를 신청할 수 없습니다.'
              )
              chkResult = true
            }
            break
          default:
            chkResult = false
            break
        }

        if (chkResult) {
          this.selBoxReset(obj1, oCode)
          result = false
        } else {
          result = true
        }

        return result
      },

      /**
       * Function    : selBoxReset
       * Description : 셀렉트박스 초기화
       **/
      selBoxReset(obj, code) {
        if (code === '' || code === null) {
          obj.value = obj[0].value
        } else {
          obj.value = code
        }
        return
      },

      /**
       * Function    : dataPriceType
       * Description : 데이터정액요금제 종류
       **/
      dataPriceType(dataPriceCd) {
        let type
        let aDataPrice = [
          'LRZ0000010',
          'LRZ0000984',
          'LRZ0000011',
          'LRZ0000005',
          'LRZ0000047',
          'LRZ0000048',
          'LRZ0000049',
          'LRZ0000006',
          'LRZ0000007',
          'LRZ0000008',
          'LPZ0000018',
          'LPZ0000019',
          'LPZ0000020',
          'LRZ0000134',
          'LRZ0000240',
          'LRZ0000241',
          'LRZ0000242',
          'LRZ0000243',
          'LRZ0000244',
          'LRZ0000245',
          'LRZ0000249',
          'LRZ0000278',
          'LRZ0000279'
        ]
        /*
                "LRZ0000010", - OZ 무한자유 			: 0
                "LRZ0000984", - 안심정액 데이터		: 1
                "LRZ0000011", - 데이터 일 정액제		: 2
                "LRZ0000005", - OZ무한자유 웹뷰어		: 3
                "LRZ0000047", - 접속 라이트 PDA		: 4
                "LRZ0000048", - 접속 일반 PDA			: 5
                "LRZ0000049", - 접속 프리미엄 PDA		: 6
                "LRZ0000006", - OZ무한자유 팩 라이트	: 7
                "LRZ0000007", - OZ무한자유 팩 일반		: 8
                "LRZ0000008", - OZ무한자유 팩 프리미엄	: 9
                "LPZ0000018", - USB모뎀 라이트		: 10
                "LPZ0000019", - USB모뎀 일반			: 11
                "LPZ0000020" - USB모뎀 프리미엄		: 12
                "LRZ0000134" - OZ 파워팩				: 13 - 2009.02.01 출시
                "LRZ0000240" - OZ & Joy 영화			: 14 - 2009.08.19 추가
                "LRZ0000241" - OZ & Joy 북			: 15 - 2009.08.19 추가
                "LRZ0000242" - OZ & Joy 편의점		: 16 - 2009.08.19 추가
                "LRZ0000243" - & Joy 영화			: 17 - 2009.08.19 추가
                "LRZ0000244" - & Joy 북  			: 18 - 2009.08.19 추가
                "LRZ0000245" - & Joy 편의점			: 19 - 2009.08.19 추가
                "LRZ0000249" - OZ무한자유 스마트폰	    : 20 - 2009.11.01 출시
                "LRZ0000278" - OZ & Joy 커피	  		: 21 - 2009.12.01 출시
                "LRZ0000279" - & Joy 커피	    	: 22 - 2009.12.01 출시
                */
        for (let i = 0; i < aDataPrice.length; i++) {
          if (aDataPrice[i] == dataPriceCd) {
            type = i
            break
          }
        }

        return type
      },

      /**
       * Function    : retrieveDutyAgmtByModel
       * Description : 의무약정 정책조회 API 호출
       **/
      retrieveDutyAgmtByModel(
              svcCd,
              phoneModelCd,
              agentId,
              formId,
              obj
      ) {
        if (this.part2.formM2MYn === 'Y' || phoneModelCd === '' || svcCd === '')
          return false

        let params = {
          dealCd: agentId,
          entrRqstFomNo: formId,
          modelId: phoneModelCd
        }
        this.dutyAgmList = []
        return new Promise((resolve, reject) => {
          request({
            url: '/ococ/datacapture/openmarket/getDutyAgmtByModel',
            method: 'get',
            headers: {
              'Content-Type': 'application/json'
            },
            params
          })
                  .then(res => {
                    // 인증이 완료 될 경우...
                    resolve(res)
                    this.dutyAgmList = res.data.dsOutput ? res.data.dsOutput : []
                    //this.chgAgreedPrice('dutyAgm')
                    if (this.dutyData.length > 0 && this.part2.formM2MYn === 'Y') {
                      this.chgAgreedPrice('m2m')
                    }
                    if (this.routerDutyData.length > 0 && this.part2.formM2MYn === 'Y') {
                      this.chgAgreedPrice('rotr')
                    }
                    if (this.dutyAgmList.length > 0 && this.part2.formM2MYn === 'N') {
                      this.chgAgreedPrice('dutyAgm')
                    }
                    return
                  })
                  .catch(e => {
                    // 에러가 발생할 경우...
                    return reject(e)
                  })
        })
      },

      /**
       * Function    : setCallCharge
       * Description : 통화요금제 값셋팅
       **/
      setCallCharge(vCode, vName, vOption) {
        let oCode = this.registration.ppCd
        let oName = ''
        for (let i = 0; i < this.phonePayStyleList; i++) {
          if (this.phonePayStyleList[i].code === oCode) {
            oName = this.phonePayStyleList[i].name
            break
          }
        }

        let vDisp = ['none', 'none']
        // let vOptionFirst = vOption.split("/"); 잘라서 넘어옴
        let vHalin = '' //vOptionFirst[0].length==14 ? vOption.substr(0,4) : vOption.substr(0,2);
        //vOption = vOptionFirst[0].length==14 ? vOption.substr(4) : vOption.substr(2);
        if (vOption.length > 0) {
          if (vOption[0].length == 15) {
            vHalin = vOption.substr(0, 5)
            vOption = vOption.substr(5)
          } else if (vOption[0].length == 14) {
            vHalin = vOption.substr(0, 4)
            vOption = vOption.substr(4)
          } else if (vOption[0].length == 12) {
            vHalin = vOption.substr(0, 2)
            vOption = vOption.substr(2)
          }
        }

        //추가변경 : 2008.05.06 - LGT 정책 변경
        //할인서비스(약정할인:discType[0], 실속형할인:discType[1])
        //약정할인 할인기간 : discMonth
        if (vHalin.length == 4) {
          //추가변경 : 2008.06.04
          //할인서비스(빅 세이브:discType[0], 평생할인:discType[1])
          //빅세이브 조건 : 할부여부 -> 할부기간 18개월 이상 -> 가능요금제
          let vHalin1 = true
          if (document.all.halbuYn.value == 'Y') {
            vHalin1 = vHalin.substr(0, 1) == 'N' ? true : false
          }
          let vHalin2 = vHalin.substr(1, 1) == 'N' ? true : false
          // 할인서비스 사용안함				document.all.discType[0].disabled = vHalin1;
          // 할인서비스 사용안함				document.all.discType[1].disabled = vHalin2;
          //추가변경 : 2008.05.21 - 조은철K요청
          //할인서비스(항공마일리지:discType[2],주유할인:discType[3])
          let vHalin3 = vHalin.substr(2, 1) == 'N' ? true : false
          let vHalin4 = vHalin.substr(3, 1) == 'N' ? true : false
          // 할인서비스 사용안함				document.all.discType[2].disabled = vHalin3;
          // 할인서비스 사용안함				document.all.discType[3].disabled = vHalin4;
        } else if (vHalin.length == 2) {
          let vHalin3 = vHalin.substr(0, 1) == 'N' ? true : false
          let vHalin4 = vHalin.substr(1, 1) == 'N' ? true : false
          // 할인서비스 사용안함				document.all.discType[2].disabled = vHalin3;
          // 할인서비스 사용안함				document.all.discType[3].disabled = vHalin4;
        } else if (vHalin.length == 5) {
          let vHalin1 = true
          if (document.all.halbuYn.value == 'Y') {
            vHalin1 = vHalin.substr(0, 1) == 'N' ? true : false
          }
          let vHalin2 = vHalin.substr(1, 1) == 'N' ? true : false
          // 할인서비스 사용안함 document.all.discType[0].disabled = vHalin1;
          // 할인서비스 사용안함 document.all.discType[1].disabled = vHalin2;
          let vHalin3 = vHalin.substr(2, 1) == 'N' ? true : false
          let vHalin4 = vHalin.substr(3, 1) == 'N' ? true : false
          // 할인서비스 사용안함 document.all.discType[2].disabled = vHalin3;
          // 할인서비스 사용안함 document.all.discType[3].disabled = vHalin4;
          //추가변경 : 2008.06.19 - 조은철K요청
          //할인서비스(G마켓할인:discType[4])
          let vHalin5 = vHalin.substr(4, 1) == 'N' ? true : false
          // 할인서비스 사용안함 document.all.discType[4].disabled = vHalin5;
        }

        //알리미 및 지정번호 보이기여부
        // document.all.alrim.style.display    = vDisp[0];
        // document.all.numbers1.style.display = vDisp[1];
        /* 선택사항들 보류
                    //충전동의 (LPZ0001046:콩문자짱/LPZ0001047:콩조절/LPZ0001048:콩미니)
                    //2009.02.12 추가 -> LPZ0000031:링스마트요금제 출시(2009.02.09)
                    //2009.03.09 추가 -> LPZ0000032:링친구문자프리, LPZ0000037:OZ링 스마트, LPZ0000038:OZ링 친구문자프리 출시(2009.03.01)
                    if (vCode == "LPZ0001046" || vCode == "LPZ0001047" || vCode == "LPZ0001048"
                        || vCode == "LPZ0000031"
                        || vCode == "LPZ0000032" || vCode == "LPZ0000037" || vCode == "LPZ0000038") {
                        //document.all.elecChk0.rowSpan = "11";
                        document.all.elecChk1.style.display = "";
                        document.all.elecChk2.style.display = "";
                    } else {
                        //document.all.elecChk0.rowSpan = "9";
                        document.all.elecChk1.style.display = "none";
                        document.all.elecChk2.style.display = "none";
                    }
                */
      },

      /**
       * Function    : chgAgreedPrice
       * Description : 약정개월수 선택 함수
       **/
      chgAgreedPrice(type) {
        if (this.retrieveData.agmtTermMmct || this.retrieveData.rotrAgmtMmct) {
          if (type) {
            if (type === 'm2m') {
              let code = this.retrieveData.agmtTermMmct
              let duty = this.dutyData.filter(data => {
                return data.code === code
              })

              let agreedPrice = duty[0].item
              let dlrAgmtAmt = code

              this.registration.dutyAgmtSuptAmt = agreedPrice
              this.registration.agmtTermMmct = dlrAgmtAmt

              this.retrieveData.dutyAgmtSuptAmt = this.commaAmt(agreedPrice)

              if (dlrAgmtAmt == '0' || !dlrAgmtAmt) {
                this.m2m_phonePriceTr = false
                this.phonePriceDescTr = false

                // 약정선택시
              } else {
                this.m2m_phonePriceTr = true
                this.phonePriceDescTr = true
              }
            }
            if (type === 'rotr') {
              let code = this.retrieveData.rotrAgmtMmct
              let rotr = this.routerDutyData.filter(data => {
                return data.code === code
              })
              let agreedPrice = rotr[0].item
              let dlrAgmtAmt = code

              this.registration.rotrAgmtAmt = agreedPrice
              this.registration.rotrAgmtMmct = dlrAgmtAmt

              this.retrieveData.rotrAgmtAmt = this.commaAmt(agreedPrice)

              if (dlrAgmtAmt == '0' || !dlrAgmtAmt) {
                this.rotr_phonePriceTr = false
                this.phonePriceDescTr = false

                // 약정선택시
              } else {
                this.rotr_phonePriceTr = true
                this.phonePriceDescTr = true
              }
            }
            if (type === 'dutyAgm') {
              let code = this.retrieveData.agmtTermMmct
              let dutyAgm = this.dutyAgmList.filter(data => {
                return data.agmtMnbr === code
              })

              let agmtAmt = dutyAgm[0].item
              let agmtMnbr = code

              this.registration.dutyAgmtSuptAmt = agmtAmt
              this.registration.agmtTermMmct = agmtMnbr

              this.retrieveData.dutyAgmtSuptAmt = this.commaAmt(agmtAmt)

              if (agmtMnbr == '0' || !agmtMnbr) {
                this.duty_agm_phonePriceTr = false
                this.phonePriceDescTr = false
                this.registration.dutyAgmtAgrYn = 'N'

                // 약정선택시
              } else {
                this.duty_agm_phonePriceTr = true
                this.phonePriceDescTr = true
              }
            }
          }
        } else {
          this.m2m_phonePriceTr = false
          this.phonePriceDescTr = false

          // [ST][CSR ID:RITM2876892] M2M 요금약정기간 추가 건-20260909
          // 기존버그 수정
          this.registration.agmtTermMmct = ''
        }
      },

      /**
       * Function    : fn_AgreedMonthInit
       * Description : 의무약정 종류에 따라 값 세팅
       **/
      //C20180123_89160_3620987 : M2M 프로세스 구조개선 프로젝트 운영이관
      fn_AgreedMonthInit() {
        if (this.dutyData.length > 0 && this.part2.formM2MYn === 'Y') {
          this.chgAgreedPrice('m2m')
        }
        if (this.routerDutyData.length > 0 && this.part2.formM2MYn === 'Y') {
          this.chgAgreedPrice('rotr')
        }
        if (this.dutyAgmList.length > 0 && this.part2.formM2MYn === 'N') {
          this.chgAgreedPrice('dutyAgm')
        }
      },

      /**
       * Function    : getDutyData
       * Description : 일반의무약정 조회
       **/
      getDutyData() {
        this.dutyData = []
        getApplServiceKindInfo(
                this.openMarketInfo.dealCd,
                this.openMarketInfo.formId,
                'duty'
        ).then(res => {
          this.dutyData = res.data

          // [ST][CSR ID:RITM2876892] M2M 요금약정기간 추가 건-20260909
          // 기존버그 수정
          if (this.dutyData.length > 0 && this.part2.formM2MYn === 'Y') {            
            this.chgAgreedPrice('m2m')
          }
          // [ED][CSR ID:RITM2876892] M2M 요금약정기간 추가 건-20260909
        })
      },

      /**
       * Function    : getRouterDutyData
       * Description : 라우터 의무약정 조회
       **/
      getRouterDutyData() {
        this.routerDutyData = []
        getApplServiceKindInfo(
                this.openMarketInfo.dealCd,
                this.openMarketInfo.formId,
                'rotr'
        ).then(res => {
          this.routerDutyData = res.data

          // [ST][CSR ID:RITM2876892] M2M 요금약정기간 추가 건-20260909
          // 기존버그 수정
          if (this.routerDutyData.length > 0 && this.part2.formM2MYn === 'Y') {          
            this.chgAgreedPrice('rotr')
          }
          // [ED][CSR ID:RITM2876892] M2M 요금약정기간 추가 건-20260909
        })
      },

      // [ST][CSR ID:RITM2876892] M2M 요금약정기간 추가 건-20261018
      /**
       * Function    : getDutyData
       * Description : 일반의무약정 조회
       **/
      getDsntData() {
        this.dsntData = []
        getApplServiceKindInfo(
                this.openMarketInfo.dealCd,
                this.openMarketInfo.formId,
                'dsnt'
        ).then(res => {
          this.dsntData = res.data
          
          //console.log(this.dsntData)
        })
      },      
      // [ED][CSR ID:RITM2876892] M2M 요금약정기간 추가 건-20261018      

      /**
       * Function    : getChrgAgmtPlcy
       * Description : 요금약정명 조회
       **/
      // [ST][CSR ID:RITM2876892] M2M 요금약정기간 추가 건-20260909
      getChrgAgmtPlcy() {
        this.chrgAgmtPlcyData = []
        
        this.m2mDcntNm = ''   
        
        requestChrgAgmtPlcy(
                this.registration.mobileRegistrationCaptureDetail.m2mPpAgdcMmct, //chrgAgmtMmct,             // M2M요금약정개월수
                '',   //mblDcntCd: mblDcntCd, // 할인코드 
                this.registration.ppCd //'LPZ7002120'  //prodCd: prodCd  // 요금제코드 LPZ7002120
        ).then(res => {
                    
          this.chrgAgmtPlcyData = res.data

          //console.log('m2mPpAgdcMmct = ' + this.registration.mobileRegistrationCaptureDetail.m2mPpAgdcMmct)
          //console.log('this.registration.ppCd = ' + this.registration.ppCd)
          
          this.m2mDcntNm = this.chrgAgmtPlcyData.dsRslt[0].mblDcntNm

          this.registration.mobileRegistrationCaptureDetail.m2mPpAgdcTermNm = this.m2mDcntNm
        
        })
      },      
      // [ED][CSR ID:RITM2876892] M2M 요금약정기간 추가 건-20260909

      // [ST][CSR ID:RITM2876892] M2M 요금약정기간 추가 건-20260909
      /**
       * Function    : chgAgreedM2mDcntNm
       * Description : 요금약정기간 변경 이벤트
       **/
      chgAgreedM2mDcntNm() {
        
        if( this.registration.mobileRegistrationCaptureDetail.m2mPpAgdcMmct == '24'
            || this.registration.mobileRegistrationCaptureDetail.m2mPpAgdcMmct == '36'
        ){
          this.m2mDcntNmTr = true
          this.getChrgAgmtPlcy()

        }else{
          this.m2mDcntNmTr = false          
          this.registration.mobileRegistrationCaptureDetail.m2mPpAgdcTermNm = ''
        }
        
      },
      // [ED][CSR ID:RITM2876892] M2M 요금약정기간 추가 건-20260909

      /**
       * Function    : discountDesc
       * Description : 약정 설명
       **/
      discountDesc(e) {
        e.preventDefault()
        window.open(
                'https://www.lguplus.com/benefit-uplus/price-discount/B400000001',
                'PopupWin',
                'width=1100,height=700,top=0,left=0,scrollbars=yes,resizable=yes'
        )
      },

      /**
       * Function    : changePpCd
       * Description : 대리점 추천 요금제 선택
       **/
      changePpCd() {
        // this.resetFeePlan()
        let phoneModelCd = this.registration.dvicMdlCd
        let ppCd = this.registration.ppCd

        if (phoneModelCd && ppCd) {
          this.$nextTick(() => {
            for (let i = 0; i < this.phonePayStyleList.length; i++) {
              if (this.phonePayStyleList[i].code === ppCd) {
                this.registration.ppNm = this.phonePayStyleList[i].name
                break
              }
            }
          })
          this.$store.dispatch('SetDevcieSectionSelfPhonePayStyle', false)
          this.fn_paySelect()
          
          //[ST][CSR ID:RITM2876892]M2M 요금약정기간 추가 건-20260909
          if( this.openMarketInfo.registrationTypeCode === 'new' && this.part2.formM2MYn === 'Y' ) {
          
            if( this.registration.mobileRegistrationCaptureDetail.m2mPpAgdcMmct == '24'
                || this.registration.mobileRegistrationCaptureDetail.m2mPpAgdcMmct == '36'
            ){
              
              
                this.getChrgAgmtPlcy()
            }
          }
          //[ST][CSR ID:RITM2876892]M2M 요금약정기간 추가 건-20260909
        } else if(!ppCd){
          this.registration.ppNm = ''
        }
      },

      /**
       * Function    : changeDataPpCd
       * Description : 대리점 옵션 요금제 선택
       **/
      changeDataPpCd() {
        for (let i = 0; i < this.dataPayStyleList.length; i++) {
          if (this.dataPayStyleList[i].code === this.registration.dataPpCd) {
            this.registration.dataPpNm = this.dataPayStyleList[i].name
          }
        }
      },

      /**
       * Function    : getDeviceList
       * Description : 단말기 종류
       **/
      getDeviceList(agentId, formId) {
        getDeviceList(agentId, formId).then(res => {
          this.deviceList = res.data
          for (let index in this.deviceList) {
              if (this.deviceList[index].trmMdlCd === this.registration.dvicMdlCd  ) {
                if (this.deviceList[index].esimTrmYn==='Y'){
                    this.display.isEsimDevice = true
                }
                break
              }
          }
        })
      },

      /**
       * Function    : getColorList
       * Description : 단말기 색상 종류
       **/
      getColorList(agentId, formId) {
        getApplServiceKindInfo(agentId, formId, 'colors').then(res => {
          this.colorList = res.data
        })
      },

      /**
       * Function    : getMccoList
       * Description : 이동통신사 종류
       **/
      getMccoList(agentId, formId) {
        getApplServiceKindInfo(agentId, formId, 'mcco').then(res => {
          this.mccoList = res.data
        })
      },

      /**
       * Function    : isttTermMmct
       * Description : 할부이고 초기에 값이 없을 경우 세팅
       **/
      isttTermMmct() {
        if (this.display.useDscnt && !this.display.nonDscnt) {
          if (!this.registration.isttTermMmct) {
            this.registration.isttTermMmct = '24'
          }
        }
      },

      /**
       * Function    : changeDcntKdCd
       * Description : 할인내역 선택
       **/
      changeDcntKdCd() {
        if(this.onsaAplyPlnNm === "Six Plan"){
          this.registration.dcntKdCd = 'DT01'
        }else if(this.onsaAplyPlnNm === "Basic"){
          this.registration.dcntKdCd = 'DT01'
        }else{
          this.registration.dcntKdCd = 'DT02'
        }

        if (this.display.useDscnt && !this.display.nonDscnt) {
          if (this.registration.dcntKdCd) {
            this.registration.isttTermMmct = '24'
          } else {
            this.registration.isttTermMmct = '0'
          }
          //[ST] [오픈마켓유심가입] 2025.12.18 전승미
          if(this.openMarketInfo.shndHphnYn !== 'Y' && this.openMarketInfo.usimEntrAppfYn !== 'Y') {
          //[ED] [오픈마켓유심가입] 2025.12.18 전승미  
            this.selectSubList()
          }
          // this.reqItemDstrDiscount()
          this.chkDscntType()

        }
        this.reqPhonePayType()
      },

      /**
       * Function    : chkDscntType
       * Description : 할인내역 타입 검색
       **/
      chkDscntType() {
        let phonePayStyle3 = this.$store.state.ValidationView[
                'installmentSectionPhonePayStyle'
                ][3]

        if (this.registration.dcntKdCd === 'DT02') {
          this.$store.dispatch('SetInstallmentSectionPhonePayStyle', [
            true,
            false,
            false,
            phonePayStyle3
          ])
          // 선택적약정할인이 아닐때
        } else {
          // 식스플랜에 동의가 있을 시 보여 줌
          if (this.sixPlanAgreeChk) {
            this.$store.dispatch('SetInstallmentSectionPhonePayStyle', [
              false,
              false,
              true,
              phonePayStyle3
            ])
          } else {
            this.$store.dispatch('SetInstallmentSectionPhonePayStyle', [
              false,
              true,
              false,
              phonePayStyle3
            ])
          }
        }
      },

      /**
       * Function    : sixPlanDesc
       * Description : 식스플랜 상세보기
       **/
      sixPlanDesc(e) {
        e.preventDefault()
        window.open(
                'https://www.lguplus.com/plan/popup/sixplan',
                'PopupWin',
                'width=780,height=845,top=30,left=30,scrollbars=yes,resizable=yes'
        )
      },

      /**
       * Function    : btnAddService
       * Description : 부가서비스 상세보기
       **/
      btnAddService(e) {
        e.preventDefault()
        window.open(
                'https://www.lguplus.com/plan/addon',
                'PopupWin',
                'width=1100,height=700,top=0,left=0,scrollbars=yes,resizable=yes'
        )
      },

      /**
       * Function    : popLssInsr
       * Description : 휴대폰 보험 상세보기
       **/
      popLssInsr(e) {
        e.preventDefault()
        window.open(
                'https://www.lguplus.com/plan/addon',
                'PopupWin',
                'width=1100,height=700,top=0,left=0,scrollbars=yes,resizable=yes'
        )
      },

      /**
       * Function    : popLssInsr2
       * Description : 휴대폰 보험 이용약관 보기
       **/
      popLssInsr2(e) {
        e.preventDefault()
        window.open(
                'https://www.lguplus.com/plan/addon/addon-safe/C000180903',
                'PopupWin',
                'width=1100,height=700,top=0,left=0,scrollbars=yes,resizable=yes'
        )
      },

      /**
       * Function    : popLssInsr3
       * Description : 내맘대로 폰교체 자세히 보기
       **/
      popLssInsr3(e) {
        e.preventDefault()
        window.open(
                'https://www.lguplus.com/plan/addon/addon-safe/Z020201015',
                'PopupWin',
                'width=1100,height=700,top=0,left=0,scrollbars=yes,resizable=yes'
        )
      },

      /**
       * Function    : checkInsr
       * Description : 휴대폰보험 맘대로폰교체 보험 중복선택 체크
       **/
      checkInsr(val) {
        this.registration.onetAplePncrDivsCd = '';
        this.registration.lssDsydCmpsEntrAgrCntn='';
        
        if(val != '2') {
          this.changeDisabled = true;
          this.noChangeDisabled = true;
        } else {
          this.changeDisabled = false;
          this.noChangeDisabled = false;
        }
      },

      /**
       * Function    : checkInsrAlert
       * Description : 휴대폰보험 맘대로폰교체 보험 alert
       **/
      checkInsrAlert() {
        this.registration.lssDsydCmpsEntrAgrCntn='';
        if(this.registration.lssInsrCnslAgrYn != '2') {
         // alert("이미 분실/파손 보상 보험을 선택하셨습니다. \n"
        //       +"분실/파손보험 미가입 변경 후 맘대로폰교체를 선택해주세요")
               this.openAlert(
                  '온라인 가입신청 안내',
                  "이미 분실/파손 보상 보험을 선택하셨습니다. \n"
               +"분실/파손보험 미가입 변경 후 맘대로폰교체를 선택해주세요"
                )
          return
        }else{

          for (var dsydLmt of this.dsydLmtList) {
           this.registration.lssDsydCmpsEntrAgrCntn="("+dsydLmt.lssSdydTrmProdDivsNm+" , "+dsydLmt.lssDsydTrmMmUsfe+"원)";
           }
        }


      },

  /**
       * Function    : getInsLmtList
       * Description :  맘대로폰교체 보험 리스트조회
       **/
      getInsLmtList() {
        getLssDaydInsLmtList(this.registration.dvicMdlCd).then(res => {
          this.dsydLmtList = res.data.result
        })

      },

      /**
       * Function    : passwordDesc
       * Description : 비밀번호설정안내 상세보기
       **/
      passwordDesc(e) {
        e.preventDefault()
        window.open(
                'https://www.lguplus.com/plan/popup/sixplan',
                'PopupWin',
                'width=780,height=845,top=30,left=30,scrollbars=yes,resizable=yes'
        )
      },

      /**
       * Function    : priceDiscount
       * Description : 선택약정 상세보기
       **/
      priceDiscount(e) {
        e.preventDefault()
        window.open(
                'https://www.lguplus.com/benefit-uplus/price-discount/B400000003',
                'PopupWin',
                'width=780,height=845,top=30,left=30,scrollbars=yes,resizable=yes'
        )
      },

      /**
       * Function    : zipcodeAddressPop
       * Description : 배송지 주소 팝업
       **/
      zipcodeAddressPop() {
        this.isPart2Popup = true
        this.$nextTick(() => {
          this.$store.state.zipType = 'shipToAddr'
          this.$modal.show('zipcodeAddress')
        })
      },

      /**
       * Function    : copyCustomerAddressToShop
       * Description : 가입자와 같은 주소
       **/
      copyCustomerAddressToShop() {
        if (!this.sameWithCustomerAddressToShip) {
          this.registration.dlplZpcd = this.registration.crplZpcd
          this.registration.dlplBadr = this.registration.crplAddr
          this.registration.dlplDadr = this.registration.crplDadr
          this.registration.dlvRcipNm = this.$store.state.step1.customer.name
          this.registration.dlplTlno = this.registration.aplcTlno
          // this.registration.dlvCtplNm = '' //연락처2
        } else {
          this.registration.dlplZpcd = ''
          this.registration.dlplBadr = ''
          this.registration.dlplDadr = ''
          this.registration.dlvRcipNm = ''
          this.registration.dlplTlno = ''
          // this.registration.dlvCtplNm = '' //연락처2
        }
      },

      /**
       * Function    : setAdditionalService
       * Description : 저장시 부가서비스 ',' 로 넣기 위해 포맷 함수
       **/
      setAdditionalService() {
        let sppsProdCdCntn = ''
        let sppsProdNmCntn = ''
        let rqstSppsCdCntn = ''
        let rqstSppsNmCntn = ''

        for (let i = 0; i < this.sppsList.length; i++) {
          sppsProdCdCntn += this.sppsList[i].code
          sppsProdNmCntn += this.sppsList[i].name
          if (i + 1 !== this.sppsList.length) {
            sppsProdCdCntn += ','
            sppsProdNmCntn += ','
          }
        }

       /*  에러로 if(this.part2.checkedRqstSppsCdList){ 조건 추가  */
        if(this.part2.checkedRqstSppsCdList){
          for (let i = 0; i < this.part2.checkedRqstSppsCdList.length; i++) { 
            if(this.part2.checkedRqstSppsCdList[i] !== 'LRZ0003114'){ 
              if ( rqstSppsCdCntn !== '' && this.part2.checkedRqstSppsCdList[i] !=='' ) {
                rqstSppsCdCntn += ','
                rqstSppsNmCntn += ','
              } 
              rqstSppsCdCntn += this.part2.checkedRqstSppsCdList[i]
              rqstSppsNmCntn += this.getRqstSppsNm(this.part2.checkedRqstSppsCdList[i])
            } 
          }
        }

        /* [ST][CSR:C20211110_82139_4482139] 신규부가서비스(디즈니)반영요청건 2021.11.15 박지숙 */
        if (this.dsnyRqstSppsCd === 'LRZ0003114' && this.onetDsnySppsUseYn === 'Y'){

          if ( rqstSppsCdCntn !== '' ) {
              rqstSppsCdCntn += ','
              rqstSppsNmCntn += ','
          }

          rqstSppsCdCntn += this.dsnyRqstSppsCd
          rqstSppsNmCntn += this.getRqstSppsNm(this.dsnyRqstSppsCd)

          if (this.dsnySppsAgrYn){
            this.registration.mobileRegistrationCaptureDetail.onetDsnySppsAgrYn = 'Y'
          }

        }else{
          this.registration.mobileRegistrationCaptureDetail.onetDsnySppsAgrYn = ''
        }
        /* [ED]][CSR:C20211110_82139_4482139] 신규부가서비스(디즈니)반영요청건 2021.11.15 박지숙 */
        
        this.registration.sppsProdCdCntn = sppsProdCdCntn
        this.registration.sppsProdNmCntn = sppsProdNmCntn
        this.registration.rqstSppsCdCntn = rqstSppsCdCntn
        this.registration.rqstSppsNmCntn = rqstSppsNmCntn

      },
// 2021.11.02 장희정 추가
      getRqstSppsNm(code){
        /* [ST][CSR:C20211110_82139_4482139] 신규부가서비스(디즈니)반영요청건 2021.11.15 박지숙 */
        if ( code === 'LRZ0003114' ){  
          return '디즈니+ 유료 월 9900(부가세 포함)'
        }
        /* [ED]][CSR:C20211110_82139_4482139] 신규부가서비스(디즈니)반영요청건 2021.11.15 박지숙 */

        for (let j = 0; j < this.rqstSppsList.length; j++) {
            if (this.rqstSppsList[j].code === code)
             return this.rqstSppsList[j].name
            
         }
         return  code
      }
      ,

      /**
       * Function    : savePart2
       * Description : 부모로 저장된 데이터 보내주는 함수
       **/
      savePart2() {
        this.setAdditionalService()
        return this.registration
      },

      /**
       * Function    : popupClose
       * Description : 주소 팝업 닫는 이벤트
       **/
      popupClose(result) {
        if (result.id === 'ok') {
          if (result.type === 'shipToAddr') {
            this.display.sameWithCustomerAddressToShip = false
            this.registration.dlplZpcd = result.ok.zip
            this.registration.dlplBadr = result.ok.addr1
            this.registration.dlplDadr = result.ok.addrDetail
            this.$refs.ref_zipcodeAddressPop.focus()
          }
        }
        this.isPart2Popup = false
      },
      /**
       * Function    : transitionPopupClose
       * Description : handle to close the popup from child component
       **/
      transitionPopupClose() {
        this.isOpenTransitionPopUp = false;
        this.chkAgreeMNP = false;
        
      },

      /**
       * Function    : transitionPopupConfirm
       * Description : handle to confirm and close the popup from child component
       **/
      transitionPopupConfirm() {
        this.isOpenTransitionPopUp = false;
        this.chkAgreeMNP = true;
        
      },
      /**
       * Function    : changeDcntKd
       * Description : 할부개월 변경 이벤트
       **/
      changeDcntKd() {
        let totalSuprt = 0
        let allCvrtSufuAmt = 0
        if (this.registration.isttTermMmct === '12') {
          totalSuprt =
                  parseInt(this.itemDstrDiscount.suprtAmt12.replace(/,/g, '')) +
                  parseInt(this.itemDstrDiscount.addSuprtAmt12.replace(/,/g, ''))
        }
        if (this.registration.isttTermMmct === '24') {
          allCvrtSufuAmt = 
                  parseInt(this.itemDstrDiscount.mnpCvrtSuptAmt.replace(/,/g, ''))+
                  parseInt(this.itemDstrDiscount.addCvrtSuptAmt.replace(/,/g, ''))
          totalSuprt =
                  parseInt(this.itemDstrDiscount.suprtAmt24.replace(/,/g, '')) +
                  parseInt(this.itemDstrDiscount.addSuprtAmt24.replace(/,/g, ''))+
                  allCvrtSufuAmt
        }
        this.itemDstrDiscount.totalSuprtAmt = this.commaAmt(totalSuprt)
        this.itemDstrDiscount.allCvrtSufuAmt = this.commaAmt(allCvrtSufuAmt)
        this.pricePerMonth = this.commaAmt(
                (
                        (this.itemDstrDiscount.phoneHalbuPrice.replace(/,/g, '') /
                                (this.registration.isttTermMmct * 100)) *
                        100
                ).toFixed()
        )
      },

      /**
       * Function    : commaAmt
       * Description : 판매 금액 "," 넣기
       **/
      commaAmt(amt) {
        let amtData = amt ? amt : 0
        return common.comma(amtData)
      },

      /**
       * Function    : appUseYnRadiobox
       * Description : (선택)자녀폰 지킴이 무료/유료 체크 이벤트
       **/
      appUseYnRadiobox() {
        if (this.registration.smatAppUseYn === 'Y') {
          this.registration.bukeAppUseYn = 'N'
        }
        if (this.registration.smatAppUseYn === 'N') {
          this.registration.bukeAppUseYn = 'Y'
        }
      },
      /**
       * Function    : getCtdoClssNmList
       * Description : 시도 리스트 조회
       **/
      getCtdoClssNmList() {
        searchCtdoClssNmList()
          .then(res => {
            this.ctdoList = res.data
          })
          .catch(e => {
            //console.error(e)
          })
      },

       /**
       * Function    : getCcwNmList
       * Description : 시군구 리스트 조회
       **/
      getCcwNmList() {
        searchCcwNmList(this.addr.ctdoClssNm)
          .then(res => {
            this.ccwNmList = res.data
            this.addr.ccwNm= this.registration.mobileRegistrationCaptureDetail.g5CovrCcwNm
             if(this.addr.ccwNm){
                this.getTownNmAdngList()
              }
          })
          .catch(e => {
            //console.error(e)
          })
      },

      /**
       * Function    : getTownNmAdngList
       * Description : 읍면동 리스트 조회
       **/
      getTownNmAdngList() {
        searchTownNmAdngList(this.addr)
          .then(res => {
            this.townNmList = res.data
            this.addr.townNm =this.registration.mobileRegistrationCaptureDetail.g5CovrTownNm 
          })
          .catch(e => {
            //console.error(e)
          })
      },
      selectedCtdo() {
          this.registration.mobileRegistrationCaptureDetail.g5CovrWideCtdoNm=this.addr.ctdoClssNm
          this.getCcwNmList()
      },
      selectedCcwNm() {
          this.registration.mobileRegistrationCaptureDetail.g5CovrCcwNm=this.addr.ccwNm
          this.getTownNmAdngList()
      },
      selectedTownNm(){
        //this.registration.mobileRegistrationCaptureDetail.g5CovrWideCtdoNm = this.addr.ctdoClssNm
       // this.registration.mobileRegistrationCaptureDetail.g5CovrCcwNm = this.addr.ccwNm
        this.registration.mobileRegistrationCaptureDetail.g5CovrTownNm = this.addr.townNm

      },
      /**
       * Function    : selectCtdoClssNm
       * Description : 시도 선택시 구시군 입력으로 focus
       **/
      selectInit() {
        //this.$refs.findAddressDetail.focus()
       // this.addr.ctdoClssNm=""
       // this.addr.ccwNm=""
       // this.addr.townNm=""
        this.addr.ctdoClssNm =this.registration.mobileRegistrationCaptureDetail.g5CovrWideCtdoNm  
        if(this.addr.ctdoClssNm){
            this.getCcwNmList()
          
        }
       

      },
      /**
       * Function    : openCoverMap
       * Description : 5G 서비스 새창
       **/
      openCoverMap(e) {
        e.preventDefault()
        window.open(
                'http://coveragemap.uplus.co.kr/EssCvgApp/index_v2.html',
                'PopupWin',
                'width=1100,height=700,top=0,left=0,scrollbars=yes,resizable=yes'
        )
      },
      /**
       * Function    : popDisney
       * Description : 디즈니+ 상세보기
       **/
      popDisneyDetail(e) {
        e.preventDefault()
        window.open(
                'https://www.lguplus.com/plan/addon/addon-media/LRZ0003114',
                'PopupWin',
                'width=1100,height=700,top=0,left=0,scrollbars=yes,resizable=yes'
        )
      },
      /**
       * Function    : popDisney
       * Description : 디즈니+ 약관
       **/
      popDisney(e) {
        e.preventDefault()
        window.open(
                'https://www.lguplus.com/plan/addon/addon-media/LRZ0003114',
                'PopupWin',
                'width=1100,height=700,top=0,left=0,scrollbars=yes,resizable=yes'
        )
      },

      checkDisney(val){

        if (val === '2'){
          this.dsnySppsAgrYn = false
        }
       //    this.registration.rqstSppsNmCntn = this.getRqstSppsNm(this.registration.rqstSppsCdCntn)
       //    console.log(this.registration.rqstSppsNmCntn)
      }
      ,

      /**
       * Function    : clickDsnySppsAgrYn
       * Description : 디즈니 동의 여부 팝업
       **/
      clickDsnySppsAgrYn() {

       // alert(this.registration.mobileRegistrationCaptureDetail.onetDsnySppsAgrYn)
       //alert(this.dsnySppsAgrYn)
        if (!this.dsnySppsAgrYn) {
        // if (!this.isDisneyPop) {
            //this.$store.state.isConfirm = false
            this.$modal.show('disneyAgree')
        }
      },

      /**
       * Function    : clickDsnySppsPrvs
       * Description : 디즈니 동의 약관 팝업
       **/
      clickDsnySppsPrvs(){
        this.$modal.show('disneyAgree')
      },

      /**
       * Function    : popupDisneyClose
       * Description : 디즈니 동의 여부 닫힐 때 콜백함수
       **/
      popupDisneyClose(result) {
        if (result.id === 'ok') {
          if (result.ok === 'Y'){
              this.dsnySppsAgrYn = true
          }else {
            this.dsnySppsAgrYn = false 
          }
        } else {
          this.dsnySppsAgrYn = false 
        }
      },
      /**
       * Function    : checkSimInsr
       * Description : USIM 선택 체크
       **/
      checkUsimInsr(val) {
        /*
        if(this.display.isEsimDevice){
            if( val === 'Y' && document.all.esimUseYn[0].checked === true ) {
                this.registration.mobileRegistrationCaptureDetail.usimRqstYn = 'N'
                document.all.usimUseYn[1].checked = true
                this.openAlert(
                  'SIM 신청 안내',
                  'USIM/eSIM 중 한가지만 선택가능 합니다.',
                  this.$refs.ref_usimRqstYn
                )
                return 
            }
         }
          if(!this.display.isEsimDevice){
              if(  val === 'N' && (this.openMarketInfo.registrationTypeCode === 'new' || this.openMarketInfo.registrationTypeCode === 'move')  ){
                document.all.usimUseYn[0].checked = true
                this.openAlert(
                  'SIM 신청 안내',
                  '[신규/번호이동]은 USIM 신청을 하셔야 합니다.',
                  this.$refs.ref_usimRqstYn
                )
              }
          }
          */
          this.registration.mobileRegistrationCaptureDetail.usimRqstYn = val
          this.registration.mobileRegistrationCaptureDetail.esimTrmYn = 'N'
      },
      /**
       * Function    : checkSimInsr
       * Description : USIM 선택 체크
       **/
      checkEsimInsr(val) {
          /*
          if(this.registration.mobileRegistrationCaptureDetail.usimRqstYn === 'Y' && val === 'Y') {
            this.registration.mobileRegistrationCaptureDetail.esimTrmYn = 'N'
            document.all.esimUseYn[1].checked = true
            this.openAlert(
              'SIM 신청 안내',
              'USIM/eSIM 중 한가지만 선택가능 합니다.',
              this.$refs.ref_usimRqstYn
            )
            return 
          }
          */
         this.registration.mobileRegistrationCaptureDetail.esimTrmYn = val
         this.registration.mobileRegistrationCaptureDetail.usimRqstYn = 'N'
      },
      /**
       * Function    : informEsim
       * Description : eSIM 상세설명
       **/
      informEsim(){
            this.openAlert(
                    'eSIM 안내',
                    '일반적인 물리SIM카드(USIM)와 달리<br/> eSIM(embedded SIM)은 단말기<br/> 내부에 내장된 Digital SIM 입니다.'
            )
       },
    }
  }
</script>

<style scoped></style>
